// Mock data for Syrian Student Union website

export const translations = {
  ar: {
    nav: {
      home: 'الرئيسية',
      subUnions: 'الاتحادات الفرعية',
      articles: 'المقالات والأخبار',
      projects: 'المشاريع',
      offices: 'المكاتب والهيئات',
      graduates: 'الخريجون',
      myInfo: 'معلوماتي',
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      signup: 'إنشاء حساب'
    },
    home: {
      hero: {
        title: 'الاتحاد العام لطلبة سوريا',
        subtitle: 'هيئة طلابية نقابية وطنية منتخبة ومستقلة، تهدف لتمثيل الحركة الطلابية السورية داخل الجامعات التركية، تستمد شرعيتها من قواعدهـا الطلابيـة الجامعيـة، و تمثل الطلبـة السوريين بقضاياهم وحقوقهم في تركيا.',
        cta: 'انضم إلينا'
      },
      about: {
        title: 'عن الاتحاد',
        description: 'هيئة طلابية نقابية وطنية منتخبة ومستقلة تهدف لتمثيل الحركة الطلابية السورية في الجامعات التركية ، تستمد شرعيتها من قواعدها الطلابية الجامعية، وتمثل الطلبة السوريين بقضاياهم وحقوقهم أمام السلطات والرأي العام في تركيا.'
      },
      stats: {
        students: 'طالب وطالبة',
        unions: 'اتحاد فرعي',
        projects: 'مشروع نشط',
        cities: 'مدينة تركية'
      }
    },
    footer: {
      about: 'نبذة عن الاتحاد',
      aboutText: 'الاتحاد العام لطلبة سوريا يعمل على دعم وتمثيل الطلاب السوريين في تركيا.',
      quickLinks: 'روابط سريعة',
      contact: 'اتصل بنا',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      rights: 'جميع الحقوق محفوظة'
    },
    login: {
      title: 'تسجيل الدخول',
      welcomeBack: 'مرحباً بك مرة أخرى',
      email: 'البريد الإلكتروني',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      rememberMe: 'تذكرني',
      forgotPassword: 'نسيت كلمة المرور؟',
      submit: 'تسجيل الدخول',
      or: 'أو',
      google: 'Google',
      facebook: 'Facebook',
      noAccount: 'ليس لديك حساب؟',
      signupLink: 'إنشاء حساب',
      unionTitle: 'اتحاد الطلبة السوريين',
      unionSubtitle: 'انضم إلى مجتمعنا العالمي من الطلاب السوريين المتميزين',
      subUnions: 'اتحاد فرعي',
      memberStudents: 'طالب عضو',
      countries: 'دولة'
    },
    signup: {
      title: 'إنشاء حساب جديد',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      submit: 'إنشاء حساب',
      hasAccount: 'لديك حساب بالفعل؟',
      loginLink: 'تسجيل الدخول'
    },
    subUnions: {
      title: 'الاتحادات الفرعية',
      subtitle: 'اتحاداتنا الطلابية في المدن التركية',
      mapTitle: 'خريطة الاتحادات',
      selectCity: 'اختر مدينة لعرض الاتحادات',
      contact: 'تواصل معنا',
      aboutUnion: 'نبذة عن الاتحاد',
      aboutDescription: 'يمثل هذا الاتحاد الطلبة السوريين في الجامعة ويعمل على تقديم الدعم الأكاديمي والاجتماعي والثقافي لهم. تأسس الاتحاد بمبادرة من الطلاب لتوحيد جهودهم وتمثيل مصالحهم داخل الجامعة وخارجها، وتنظيم الفعاليات والأنشطة التي تعزز الهوية الوطنية والتواصل بين الطلبة.',
      established: 'تاريخ التأسيس',
      status: 'الحالة',
      active: 'نشط',
      visitWebsite: 'زيارة الموقع',
      noUnionsInCity: 'لا توجد اتحادات في هذه المدينة حالياً',
      clickCityToView: 'انقر على مدينة على الخريطة لعرض الاتحادات',
      academic: 'الأكاديمي',
      cultural: 'الثقافي',
      social: 'الاجتماعي',
      cardDescription: 'يمثل هذا الاتحاد الطلبة السوريين في الجامعة ويعمل على تقديم الدعم الأكاديمي والاجتماعي والثقافي لهم.',
      establishedYear: 'تأسس',
      learnMore: 'تعرف أكثر',
      allSubunions: 'جميع الاتحادات الفرعية',
      source: 'المصدر:',
      contactNumber: 'رقم الاتصال',
      activitiesAndAchievements: 'الأنشطة والإنجازات',
      specialAchievements: 'الإنجازات الخاصة',
      currentAdministrativeTeam: 'الفريق الإداري الحالي',
      notes: 'ملاحظات'
    },
    articles: {
      title: 'المقالات والأخبار',
      subtitle: 'آخر الأخبار والمقالات من الاتحاد',
      readMore: 'اقرأ المزيد',
      all: 'الكل',
      news: 'أخبار',
      events: 'فعاليات',
      announcements: 'إعلانات'
    },
    projects: {
      title: 'المشاريع',
      subtitle: 'مشاريعنا الحالية والسابقة',
      ongoing: 'جاري التنفيذ',
      completed: 'مكتمل',
      viewDetails: 'عرض التفاصيل'
    },
    offices: {
      title: 'المكاتب والهيئات',
      subtitle: 'الهيكل التنظيمي للاتحاد',
      contact: 'للتواصل'
    }
  },
  en: {
    nav: {
      home: 'Home',
      subUnions: 'Sub-Unions',
      articles: 'Articles & News',
      projects: 'Projects',
      offices: 'Offices & Committees',
      graduates: 'Graduates',
      myInfo: 'My Info',
      login: 'Login',
      logout: 'Logout',
      signup: 'Sign Up'
    },
    home: {
      hero: {
        title: 'Syrian Student Union',
        subtitle: 'Together we build a better future for Syrian students',
        cta: 'Join Us'
      },
      about: {
        title: 'About the Union',
        description: 'A national, elected, and independent student union organization that aims to represent the Syrian student movement in Turkish universities. It derives its legitimacy from its university student base, and represents Syrian students with their issues and rights before the authorities and public opinion in Turkey.'
      },
      stats: {
        students: 'Students',
        unions: 'Sub-Unions',
        projects: 'Active Projects',
        cities: 'Turkish Cities'
      }
    },
    footer: {
      about: 'About the Union',
      aboutText: 'The General Union of Syrian Students works to support and represent Syrian students in Turkey.',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      email: 'Email',
      phone: 'Phone',
      rights: 'All rights reserved'
    },
    login: {
      title: 'Login',
      welcomeBack: 'Welcome back',
      email: 'Email',
      username: 'Username',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      submit: 'Login',
      or: 'Or',
      google: 'Google',
      facebook: 'Facebook',
      noAccount: "Don't have an account?",
      signupLink: 'Create account',
      unionTitle: 'Syrian Student Union',
      unionSubtitle: 'Join our global community of distinguished Syrian students',
      subUnions: 'Sub-unions',
      memberStudents: 'Member students',
      countries: 'Countries'
    },
    signup: {
      title: 'Create Account',
      name: 'Full Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      submit: 'Create Account',
      hasAccount: 'Already have an account?',
      loginLink: 'Login'
    },
    subUnions: {
      title: 'Sub-Unions',
      subtitle: 'Our student unions across Turkish cities',
      mapTitle: 'Union Map',
      selectCity: 'Select a city to view unions',
      contact: 'Contact Us',
      aboutUnion: 'About the Union',
      aboutDescription: 'This union represents Syrian students at the university and works to provide them with academic, social, and cultural support. The union was established by student initiative to unite their efforts and represent their interests inside and outside the university.',
      established: 'Established',
      status: 'Status',
      active: 'Active',
      visitWebsite: 'Visit Website',
      noUnionsInCity: 'No unions in this city yet',
      clickCityToView: 'Click on a city on the map to view unions',
      academic: 'Academic',
      cultural: 'Cultural',
      social: 'Social',
      cardDescription: 'This union represents Syrian students at the university and works to provide them with academic, social, and cultural support.',
      establishedYear: 'Est.',
      learnMore: 'Learn More',
      allSubunions: 'All Subunions',
      source: 'Source:',
      contactNumber: 'Contact Number',
      activitiesAndAchievements: 'Activities and Achievements',
      specialAchievements: 'Special Achievements',
      currentAdministrativeTeam: 'Current Administrative Team',
      notes: 'Notes'
    },
    articles: {
      title: 'Articles & News',
      subtitle: 'Latest news and articles from the union',
      readMore: 'Read More',
      all: 'All',
      news: 'News',
      events: 'Events',
      announcements: 'Announcements'
    },
    projects: {
      title: 'Projects',
      subtitle: 'Our current and past projects',
      ongoing: 'Ongoing',
      completed: 'Completed',
      viewDetails: 'View Details'
    },
    offices: {
      title: 'Offices & Committees',
      subtitle: 'Organizational structure of the union',
      contact: 'Contact'
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      subUnions: 'Alt Birlikler',
      articles: 'Makaleler ve Haberler',
      projects: 'Projeler',
      offices: 'Ofisler ve Komiteler',
      graduates: 'Mezunlar',
      myInfo: 'Bilgilerim',
      login: 'Giriş Yap',
      logout: 'Çıkış Yap',
      signup: 'Kayıt Ol'
    },
    home: {
      hero: {
        title: 'Suriyeli Öğrenciler Birliği',
        subtitle: 'Suriyeli öğrenciler için daha iyi bir gelecek inşa ediyoruz',
        cta: 'Bize Katılın'
      },
      about: {
        title: 'Birlik Hakkında',
        description: 'Türk üniversitelerindeki Suriyeli öğrenci hareketini temsil etmeyi amaçlayan ulusal, seçilmiş ve bağımsız bir öğrenci sendika örgütü. Meşruiyetini üniversite öğrenci tabanından alır ve Suriyeli öğrencileri sorunları ve haklarıyla Türkiye\'deki yetkililer ve kamuoyu önünde temsil eder.'
      },
      stats: {
        students: 'Öğrenci',
        unions: 'Alt Birlik',
        projects: 'Aktif Proje',
        cities: 'Türk Şehri'
      }
    },
    footer: {
      about: 'Birlik Hakkında',
      aboutText: 'Suriye Öğrencileri Genel Birliği, Türkiye\'deki Suriyeli öğrencileri desteklemek ve temsil etmek için çalışmaktadır.',
      quickLinks: 'Hızlı Bağlantılar',
      contact: 'İletişim',
      email: 'E-posta',
      phone: 'Telefon',
      rights: 'Tüm hakları saklıdır'
    },
    login: {
      title: 'Giriş Yap',
      welcomeBack: 'Tekrar hoş geldiniz',
      email: 'E-posta',
      username: 'Kullanıcı adı',
      password: 'Şifre',
      rememberMe: 'Beni hatırla',
      forgotPassword: 'Şifrenizi mi unuttunuz?',
      submit: 'Giriş Yap',
      or: 'Veya',
      google: 'Google',
      facebook: 'Facebook',
      noAccount: 'Hesabınız yok mu?',
      signupLink: 'Hesap oluştur',
      unionTitle: 'Suriyeli Öğrenciler Birliği',
      unionSubtitle: 'Seçkin Suriyeli öğrencilerin küresel topluluğumuza katılın',
      subUnions: 'Alt birlik',
      memberStudents: 'Üye öğrenci',
      countries: 'Ülke'
    },
    signup: {
      title: 'Hesap Oluştur',
      name: 'Ad Soyad',
      email: 'E-posta',
      password: 'Şifre',
      confirmPassword: 'Şifre Onayı',
      submit: 'Hesap Oluştur',
      hasAccount: 'Zaten hesabınız var mı?',
      loginLink: 'Giriş yap'
    },
    subUnions: {
      title: 'Alt Birlikler',
      subtitle: 'Türk şehirlerindeki öğrenci birliklerimiz',
      mapTitle: 'Birlik Haritası',
      selectCity: 'Birlikleri görmek için bir şehir seçin',
      contact: 'Bize Ulaşın',
      aboutUnion: 'Birlik Hakkında',
      aboutDescription: 'Bu birlik, üniversitedeki Suriyeli öğrencileri temsil eder ve onlara akademik, sosyal ve kültürel destek sağlamak için çalışır. Birlik, öğrencilerin çabalarını birleştirmek ve üniversite içinde ve dışında çıkarlarını temsil etmek için öğrenci inisiyatifiyle kurulmuştur.',
      established: 'Kuruluş Tarihi',
      status: 'Durum',
      active: 'Aktif',
      visitWebsite: 'Siteyi Ziyaret Et',
      noUnionsInCity: 'Şu anda bu şehirde birlik yok',
      clickCityToView: 'Birlikleri görüntülemek için haritada bir şehre tıklayın',
      academic: 'Akademik',
      cultural: 'Kültürel',
      social: 'Sosyal',
      cardDescription: 'Bu birlik, üniversitedeki Suriyeli öğrencileri temsil eder ve onlara akademik, sosyal ve kültürel destek sağlar.',
      establishedYear: 'Kuruluş',
      learnMore: 'Daha Fazla Bilgi',
      allSubunions: 'Tüm Alt Birlikler',
      source: 'Kaynak:',
      contactNumber: 'İletişim Numarası',
      activitiesAndAchievements: 'Etkinlikler ve Başarılar',
      specialAchievements: 'Özel Başarılar',
      currentAdministrativeTeam: 'Mevcut Yönetim Ekibi',
      notes: 'Notlar'
    },
    articles: {
      title: 'Makaleler ve Haberler',
      subtitle: 'Birlikten en son haberler ve makaleler',
      readMore: 'Devamını Oku',
      all: 'Tümü',
      news: 'Haberler',
      events: 'Etkinlikler',
      announcements: 'Duyurular'
    },
    projects: {
      title: 'Projeler',
      subtitle: 'Mevcut ve geçmiş projelerimiz',
      ongoing: 'Devam Ediyor',
      completed: 'Tamamlandı',
      viewDetails: 'Detayları Gör'
    },
    offices: {
      title: 'Ofisler ve Komiteler',
      subtitle: 'Birliğin organizasyon yapısı',
      contact: 'İletişim'
    }
  }
};

export const turkeyUnions = {
  istanbul: [
    {
      id: 1,
      name: { ar: 'اتحاد طلبة إسطنبول - الأوروبي', en: 'Istanbul European Side Union', tr: 'İstanbul Avrupa Yakası Birliği' },
      contact: 'istanbul.eu@syrianstudents.org',
      phone: '+90 212 XXX XXXX',
      members: 1200
    },
    {
      id: 2,
      name: { ar: 'اتحاد طلبة إسطنبول - الآسيوي', en: 'Istanbul Asian Side Union', tr: 'İstanbul Asya Yakası Birliği' },
      contact: 'istanbul.as@syrianstudents.org',
      phone: '+90 216 XXX XXXX',
      members: 950
    }
  ],
  ankara: [
    {
      id: 3,
      name: { ar: 'اتحاد طلبة أنقرة', en: 'Ankara Student Union', tr: 'Ankara Öğrenci Birliği' },
      contact: 'ankara@syrianstudents.org',
      phone: '+90 312 XXX XXXX',
      members: 850
    }
  ],
  izmir: [
    {
      id: 4,
      name: { ar: 'اتحاد طلبة إزمير', en: 'Izmir Student Union', tr: 'İzmir Öğrenci Birliği' },
      contact: 'izmir@syrianstudents.org',
      phone: '+90 232 XXX XXXX',
      members: 620
    }
  ],
  bursa: [
    {
      id: 5,
      name: { ar: 'اتحاد طلبة بورصة', en: 'Bursa Student Union', tr: 'Bursa Öğrenci Birliği' },
      contact: 'bursa@syrianstudents.org',
      phone: '+90 224 XXX XXXX',
      members: 480
    }
  ],
  gaziantep: [
    {
      id: 6,
      name: { ar: 'اتحاد طلبة غازي عنتاب', en: 'Gaziantep Student Union', tr: 'Gaziantep Öğrenci Birliği' },
      contact: 'gaziantep@syrianstudents.org',
      phone: '+90 342 XXX XXXX',
      members: 730
    }
  ],
  antalya: [
    {
      id: 7,
      name: { ar: 'اتحاد طلبة أنطاليا', en: 'Antalya Student Union', tr: 'Antalya Öğrenci Birliği' },
      contact: 'antalya@syrianstudents.org',
      phone: '+90 242 XXX XXXX',
      members: 390
    }
  ],
  konya: [
    {
      id: 8,
      name: { ar: 'اتحاد طلبة قونية', en: 'Konya Student Union', tr: 'Konya Öğrenci Birliği' },
      contact: 'konya@syrianstudents.org',
      phone: '+90 332 XXX XXXX',
      members: 410
    }
  ]
};

export const articles = [
  {
    id: 1,
    title: { ar: 'زيارة منبر منظمات المجتمع المدني', en: 'Visit to the Platform of Civil Society Organizations', tr: 'Sivil Toplum Kuruluşları Platformu Ziyareti' },
    excerpt: { ar: 'قام وفد من الاتحاد العام للطلبة السوريين بزيارة إلى منبر منظمات المجتمع المدني السوري، تم خلالها بحث سبل التعاون المشترك ودعم المبادرات الطلابية. تناول اللقاء أهمية دور منظمات المجتمع المدني في دعم الطلبة السوريين وتذليل العقبات التي تواجههم، وتم الاتفاق على إقامة أنشطة وفعاليات مشتركة خلال الفترة القادمة. كما أكد الطرفان على أهمية تنسيق الجهود لخدمة الطلبة السوريين وتلبية احتياجاتهم المختلفة.', en: 'A delegation from the General Union of Syrian Students visited the Syrian Civil Society Organizations Platform, during which they discussed ways of joint cooperation and supporting student initiatives. The meeting addressed the importance of the role of civil society organizations in supporting Syrian students and overcoming the obstacles they face. It was agreed to hold joint activities and events during the coming period. The two parties also emphasized the importance of coordinating efforts to serve Syrian students and meet their various needs.', tr: 'Suriyeli Öğrenciler Genel Birliği\'nden bir delegasyon, Suriye Sivil Toplum Kuruluşları Platformu\'nu ziyaret etti. Ziyaret sırasında ortak işbirliği yolları ve öğrenci girişimlerini destekleme konuları ele alındı. Toplantıda sivil toplum kuruluşlarının Suriyeli öğrencileri desteklemedeki rolünün önemi ve karşılaştıkları engellerin aşılması konuları görüşüldü. Önümüzdeki dönemde ortak etkinlikler ve faaliyetler düzenlenmesi konusunda anlaşmaya varıldı. Her iki taraf da Suriyeli öğrencilere hizmet etmek ve çeşitli ihtiyaçlarını karşılamak için çabaları koordine etmenin önemini vurguladı.' },
    date: '2025-01-15',
    formattedDate: { ar: '15 يناير 2025', en: 'January 15, 2025', tr: '15 Ocak 2025' },
    category: 'news',
    image: '/assets/news5.jpg'
  },
  {
    id: 2,
    title: { ar: 'مؤتمر والصبح إذا تنفس', en: 'Conference: "And the Morning When It Breathes"', tr: 'Konferans: "Ve Sabah Nefes Aldığında"' },
    excerpt: { ar: 'مؤتمر "والصبح إذا تنفس" في إسطنبول إحياء لذكرى الثورة السورية. أقام الاتحاد العام للطلبة السوريين - فرع تركيا مؤتمرا بعنوان "والصبح إذا تنفس" في مدينة إسطنبول، تزامنا مع الذكرى السنوية لانطلاق الثورة السورية المباركة. تخلل المؤتمر عدد من الفعاليات المتنوعة، من بينها قصائد شعرية ومشاهد مسرحية مؤثرة جسدت معاناة المعتقلين السوريين في سجون النظام. واختتمت الفعالية بأهازيج الثورة التي أعادت إلى الأذهان روح الحراك الشعبي. وفي ختام الأمسية، اجتمع الحضور على مائدة إفطار رمضانية سادتها أجواء من التضامن والأمل المتجدد. يتوجه الاتحاد بالشكر إلى مؤسسة نيوهورايزون على دعمها الكريم، والذي ساهم في إنجاح المؤتمر وخروجه بصورة تليق بعظمة الذكرى.', en: 'The conference "And the Morning When It Breathes" was held in Istanbul to commemorate the Syrian Revolution. The General Union of Syrian Students - Turkey Branch organized a conference titled "And the Morning When It Breathes" in Istanbul, coinciding with the annual anniversary of the blessed Syrian Revolution. The conference included a number of diverse activities, among them impactful poetry readings and theatrical scenes that depicted the suffering of Syrian detainees in the regime\'s prisons. The event concluded with revolutionary chants that brought back the spirit of the popular movement. At the end of the evening, attendees gathered for an Iftar (Ramadan breaking of fast) meal, which was filled with an atmosphere of solidarity and renewed hope. The Union extends its gratitude to the New Horizon Foundation for its generous support, which contributed to the success of the conference and its presentation in a manner befitting the greatness of the anniversary.', tr: '"Ve Sabah Nefes Aldığında" konferansı, Suriye Devrimi\'ni anmak için İstanbul\'da düzenlendi. Suriyeli Öğrenciler Genel Birliği - Türkiye Şubesi, Suriye Devrimi\'nin kutsal yıldönümüyle aynı zamana denk gelecek şekilde İstanbul\'da "Ve Sabah Nefes Aldığında" başlıklı bir konferans düzenledi. Konferans, aralarında rejim hapishanelerindeki Suriyeli tutukluların acılarını betimleyen etkileyici şiir okumaları ve tiyatral sahnelerin de bulunduğu çeşitli etkinlikler içerdi. Etkinlik, halk hareketinin ruhunu geri getiren devrimci marşlarla sona erdi. Akşamın sonunda, katılımcılar dayanışma و yenilenmiş umut atmosferiyle dolu bir Ramazan iftar sofrasında bir araya geldi. Birlik, konferansın başarısına ve anmanın büyüklüğüne yakışır bir şekilde sunulmasına katkıda bulunan cömert desteği için New Horizon Vakfı\'na teşekkür eder.' },
    date: '2025-01-10',
    formattedDate: { ar: '10 يناير 2025', en: 'January 10, 2025', tr: '10 Ocak 2025' },
    category: 'events',
    image: '/assets/news1.jpg'
  },
  {
    id: 3,
    title: { ar: 'مسرحية الخوف من الباب الوحيد', en: 'The Play of Fear from the Only Door', tr: 'Tek Kapının Korkusu Oyunu' },
    excerpt: { ar: 'نظم الاتحاد العام للطلبة السوريين حفل عرض مسرحية "الخوف من الباب الوحيد، والتي تناولت معاناة السوريين وتجاربهم المختلفة خلال سنوات الحرب، وقدمت المسرحية رؤية أصيلة حول تأثير الخوف على حياة الإنسان ودوره في صنع القرارات المصيرية. شهدت المسرحية حضورًا لافتا وتفاعلا كبيرا من الجمهور الذي تأثر بالعرض المسرحي المتميز والأداء الاحترافي للفريق.', en: 'The General Union of Syrian Students organized a ceremony to present the play "The Fear from the Only Door," which dealt with the suffering of Syrians and their various experiences during the war years. The play presented an original vision about the impact of fear on human life and its role in making fateful decisions. The play witnessed a remarkable attendance and great interaction from the audience, who were affected by the distinguished theatrical presentation and the professional performance of the team.', tr: 'Suriyeli Öğrenciler Genel Birliği, Suriyelilerin acılarını ve savaş yılları boyunca yaşadıkları çeşitli deneyimleri ele alan "Tek Kapının Korkusu" oyununun gösterimi için bir tören düzenledi. Oyun, korkunun insan hayatı üzerindeki etkisi ve kader belirleyici kararlar vermedeki rolü hakkında özgün bir vizyon sundu. Oyun, seçkin tiyatro sunumundan ve ekibin profesyonel performansından etkilenen seyircilerden olağanüstü bir katılım ve büyük bir etkileşim gördü.' },
    date: '2025-01-05',
    formattedDate: { ar: '5 يناير 2025', en: 'January 5, 2025', tr: '5 Ocak 2025' },
    category: 'announcements',
    image: '/assets/news3.jpg'
  },
  {
    id: 4,
    title: { ar: 'ورشة عمل: كيفية التقديم للجامعات التركية', en: 'Workshop: How to Apply to Turkish Universities', tr: 'Çalıştay: Türk Üniversitelerine Nasıl Başvurulur' },
    excerpt: { ar: 'انضم إلينا في ورشة العمل المجانية حول كيفية التقديم للجامعات التركية والحصول على القبول.', en: 'Join us for a free workshop on how to apply to Turkish universities and get admission.', tr: 'Türk üniversitelerine nasıl başvurulacağı ve kabul edileceği hakkında ücretsiz çalıştaya katılın.' },
    date: '2024-12-20',
    formattedDate: { ar: '20 ديسمبر 2024', en: 'December 20, 2024', tr: '20 Aralık 2024' },
    category: 'events',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80'
  },
  {
    id: 5,
    title: { ar: 'نتائج انتخابات الهيئة الإدارية الجديدة', en: 'Results of New Administrative Board Elections', tr: 'Yeni Yönetim Kurulu Seçim Sonuçları' },
    excerpt: { ar: 'تم الإعلان عن نتائج انتخابات الهيئة الإدارية للاتحاد للفترة 2025-2026.', en: 'The results of the union\'s administrative board elections for 2025-2026 have been announced.', tr: '2025-2026 dönemi için birlik yönetim kurulu seçim sonuçları açıklandı.' },
    date: '2024-12-15',
    formattedDate: { ar: '15 ديسمبر 2024', en: 'December 15, 2024', tr: '15 Aralık 2024' },
    category: 'news',
    image: 'https://images.unsplash.com/photo-1623461487986-9400110de28e?w=800&q=80'
  },
  {
    id: 6,
    title: { ar: 'برنامج التوجيه للطلاب الجدد', en: 'Orientation Program for New Students', tr: 'Yeni Öğrenciler için Oryantasyon Programı' },
    excerpt: { ar: 'برنامج شامل لمساعدة الطلاب الجدد على التأقلم مع الحياة الجامعية في تركيا.', en: 'A comprehensive program to help new students adapt to university life in Turkey.', tr: 'Yeni öğrencilerin Türkiye\'deki üniversite yaşamına uyum sağlamalarına yardımcı olmak için kapsamlı bir program.' },
    date: '2024-12-10',
    formattedDate: { ar: '10 ديسمبر 2024', en: 'December 10, 2024', tr: '10 Aralık 2024' },
    category: 'announcements',
    image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=800&q=80'
  }
];

export const projects = [
  {
    id: 1,
    title: { ar: 'برنامج الدعم الأكاديمي', en: 'Academic Support Program', tr: 'Akademik Destek Programı' },
    description: { ar: 'برنامج يوفر دروس تقوية ودعم أكاديمي مجاني للطلاب السوريين في جميع التخصصات الجامعية.', en: 'A program providing free tutoring and academic support for Syrian students in all university majors.', tr: 'Tüm üniversite bölümlerinde Suriyeli öğrencilere ücretsiz ders takviyesi ve akademik destek sağlayan bir program.' },
    status: 'ongoing',
    image: 'https://images.pexels.com/photos/1438072/pexels-photo-1438072.jpeg?w=800&q=80',
    startDate: '2024-01-15',
    endDate: '2025-06-30',
    progress: 60,
    memberCount: 12,
    category: { ar: 'تعليمي', en: 'Educational', tr: 'Eğitim' }
  },
  {
    id: 2,
    title: { ar: 'مبادرة التواصل الثقافي', en: 'Cultural Exchange Initiative', tr: 'Kültürel Değişim Girişimi' },
    description: { ar: 'تنظيم فعاليات ثقافية لتعزيز التفاهم بين الطلاب السوريين والأتراك وتبادل الخبرات الثقافية.', en: 'Organizing cultural events to promote understanding between Syrian and Turkish students and exchange cultural experiences.', tr: 'Suriyeli ve Türk öğrenciler arasında anlayışı geliştirmek ve kültürel deneyimleri paylaşmak için kültürel etkinlikler düzenlemek.' },
    status: 'ongoing',
    image: 'https://images.unsplash.com/photo-1590012314607-cda9d9b699ae?w=800&q=80',
    startDate: '2024-03-10',
    endDate: '2025-12-31',
    progress: 45,
    memberCount: 8,
    category: { ar: 'تقني', en: 'Technical', tr: 'Teknik' }
  },
  {
    id: 3,
    title: { ar: 'مشروع التوظيف والتدريب المهني', en: 'Career and Vocational Training Project', tr: 'Kariyer ve Mesleki Eğitim Projesi' },
    description: { ar: 'توفير ورش عمل ودورات تدريبية مهنية لإعداد الطلاب لسوق العمل التركي.', en: 'Providing workshops and vocational training courses to prepare students for the Turkish job market.', tr: 'Öğrencileri Türk iş piyasasına hazırlamak için atölyeler ve mesleki eğitim kursları sağlamak.' },
    status: 'ongoing',
    image: 'https://images.unsplash.com/photo-1627556704302-624286467c65?w=800&q=80',
    startDate: '2023-09-01',
    endDate: '2025-08-31',
    progress: 80,
    memberCount: 15,
    category: { ar: 'صحي', en: 'Health', tr: 'Sağlık' }
  },
  {
    id: 4,
    title: { ar: 'حملة التوعية الصحية', en: 'Health Awareness Campaign', tr: 'Sağlık Bilinci Kampanyası' },
    description: { ar: 'حملة سنوية لنشر الوعي الصحي وتوفير استشارات طبية مجانية للطلاب.', en: 'An annual campaign to raise health awareness and provide free medical consultations for students.', tr: 'Sağlık bilincini artırmak ve öğrencilere ücretsiz tıbbi danışmanlık sağlamak için yıllık bir kampanya.' },
    status: 'completed',
    image: 'https://images.unsplash.com/photo-1539413595691-37a09a48579b?w=800&q=80',
    startDate: '2023-02-15',
    endDate: '2024-05-30',
    progress: 100,
    memberCount: 10,
    category: { ar: 'بيئي', en: 'Environmental', tr: 'Çevre' }
  },
  {
    id: 5,
    title: { ar: 'مكتبة الكتب الرقمية', en: 'Digital Library Project', tr: 'Dijital Kütüphane Projesi' },
    description: { ar: 'إنشاء مكتبة رقمية تحتوي على مراجع علمية وكتب دراسية باللغتين العربية والإنجليزية.', en: 'Creating a digital library containing academic references and textbooks in Arabic and English.', tr: 'Arapça ve İngilizce akademik referanslar ve ders kitapları içeren bir dijital kütüphane oluşturmak.' },
    status: 'completed',
    image: 'https://images.pexels.com/photos/1205651/pexels-photo-1205651.jpeg?w=800&q=80',
    startDate: '2022-11-20',
    endDate: '2024-03-15',
    progress: 100,
    memberCount: 25,
    category: { ar: 'مجتمعي', en: 'Community', tr: 'Toplum' }
  },
  {
    id: 6,
    title: { ar: 'برنامج المنح الدراسية', en: 'Scholarship Program', tr: 'Burs Programı' },
    description: { ar: 'توفير منح دراسية ومساعدات مالية للطلاب المتفوقين والمحتاجين.', en: 'Providing scholarships and financial assistance for outstanding and needy students.', tr: 'Başarılı ve ihtiyaç sahibi öğrencilere burs ve mali yardım sağlamak.' },
    status: 'ongoing',
    image: 'https://images.unsplash.com/photo-1636231945376-3d40fdcbc462?w=800&q=80',
    startDate: '2024-02-01',
    endDate: '2026-01-31',
    progress: 35,
    memberCount: 18,
    category: { ar: 'ريادي', en: 'Entrepreneurial', tr: 'Girişim' }
  }
];

export const categories = [
  { id: 1, name: { ar: 'مجلس الإدارة', en: 'Board of Directors', tr: 'Yönetim Kurulu' } },
  { id: 2, name: { ar: 'الهيئة الرقابية', en: 'Supervisory Body', tr: 'Denetim Kurulu' } },
  { id: 3, name: { ar: 'الهيئة الانتخابية', en: 'Electoral Commission', tr: 'Seçim Komisyonu' } },
  { id: 4, name: { ar: 'المكاتب واللجان التنفيذية', en: 'Offices & Executive Committees', tr: 'Ofisler ve İcra Komiteleri' } }
];

export const cities = [
  {
    id: 'istanbul',
    name: { ar: 'إسطنبول', en: 'Istanbul', tr: 'İstanbul' },
    svgX: 190,
    svgY: 250,
    colorZone: 10,
    clickZone: 1,
  },
  { 
    id: 'izmir', 
    name: { ar: 'إزمير', en: 'Izmir', tr: 'İzmir' }, 
    svgX: 125, 
    svgY: 340, 
    colorZone: 20, 
    clickZone: 1,
  },
  { 
    id: 'mersin', 
    name: { ar: 'مرسين', en: 'Mersin', tr: 'Mersin' }, 
    svgX: 365, 
    svgY: 400, 
    colorZone: 20, 
    clickZone: 1,
  },
  { 
    id: 'kilis', 
    name: { ar: 'كلس', en: 'Kilis', tr: 'Kilis' }, 
    svgX: 460, 
    svgY: 390, 
    colorZone: 10, 
    clickZone: 1,
  },
  { 
    id: 'duzce', 
    name: { ar: 'دوزجة', en: 'Düzce', tr: 'Düzce' }, 
    svgX: 267, 
    svgY: 255, 
    colorZone: 16, 
    clickZone: 1,
  },
  { 
    id: 'isparta', 
    name: { ar: 'اسبارطة', en: 'Isparta', tr: 'Isparta' }, 
    svgX: 258, 
    svgY: 370, 
    colorZone: 30, 
    clickZone: 1,
  },
  { 
    id: 'adiyaman', 
    name: { ar: 'أديامان', en: 'Adıyaman', tr: 'Adıyaman' }, 
    svgX: 505, 
    svgY: 360, 
    colorZone: 20, 
    clickZone: 1,
  },
  { 
    id: 'gaziantep', 
    name: { ar: 'غازي عنتاب', en: 'Gaziantep', tr: 'Gaziantep' }, 
    svgX: 470, 
    svgY: 380, 
    colorZone: 10, 
    clickZone: 1,
  },
  { 
    id: 'karabuk', 
    name: { ar: 'كرابوك', en: 'Karabük', tr: 'Karabük' }, 
    svgX: 308, 
    svgY: 247, 
    colorZone: 10, 
    clickZone: 1,
  },
  { 
    id: 'elazig', 
    name: { ar: 'إيلازيغ', en: 'Elazığ', tr: 'Elazığ' }, 
    svgX: 540, 
    svgY: 330, 
    colorZone: 20, 
    clickZone: 1,
  },
  { 
    id: 'sivas', 
    name: { ar: 'سيفاس', en: 'Sivas', tr: 'Sivas' }, 
    svgX: 470, 
    svgY: 300, 
    colorZone: 30, 
    clickZone: 1,
  },
  { 
    id: 'adana', 
    name: { ar: 'أضنة', en: 'Adana', tr: 'Adana' }, 
    svgX: 410, 
    svgY: 370, 
    colorZone: 30, 
    clickZone: 1 
  },
  { id: 'sakarya', name: { ar: 'سكاريا', en: 'Sakarya', tr: 'Sakarya' }, svgX: 220, svgY: 260, colorZone: 25, clickZone: 1 },
  { id: 'bursa', name: { ar: 'بورصة', en: 'Bursa', tr: 'Bursa' }, svgX: 180, svgY: 290, colorZone: 30, clickZone: 1 },
  { id: 'kahramanmaras', name: { ar: 'كهرمان مرعش', en: 'Kahramanmaraş', tr: 'Kahramanmaraş' }, svgX: 455, svgY: 360, colorZone: 25, clickZone: 1 },
  { id: 'malatya', name: { ar: 'ملاطيا', en: 'Malatya', tr: 'Malatya' }, svgX: 500, svgY: 330, colorZone: 25, clickZone: 1 },
  { id: 'hatay', name: { ar: 'هاتاي', en: 'Hatay', tr: 'Hatay' }, svgX: 440, svgY: 408, colorZone: 30, clickZone: 1 },
  { id: 'konya', name: { ar: 'قونيا', en: 'Konya', tr: 'Konya' }, svgX: 320, svgY: 340, colorZone: 35, clickZone: 1 },
  { id: 'bolu', name: { ar: 'بولو', en: 'Bolu', tr: 'Bolu' }, svgX: 280, svgY: 270, colorZone: 20, clickZone: 1 },
  { id: 'ankara', name: { ar: 'أنقرة', en: 'Ankara', tr: 'Ankara' }, svgX: 320, svgY: 290, colorZone: 30, clickZone: 1 },
  { id: 'kocaeli', name: { ar: 'كوجالي', en: 'Kocaeli', tr: 'Kocaeli' }, svgX: 240, svgY: 250, colorZone: 30, clickZone: 1 },
  { id: 'kastamonu', name: { ar: 'كاستامونو', en: 'Kastamonu', tr: 'Kastamonu' }, svgX: 340, svgY: 240, colorZone: 25, clickZone: 1 },
  { id: 'kayseri', name: { ar: 'قيصري', en: 'Kayseri', tr: 'Kayseri' }, svgX: 420, svgY: 330, colorZone: 30, clickZone: 1 },
  { id: 'kutahya', name: { ar: 'كوتاهيا', en: 'Kütahya', tr: 'Kütahya' }, svgX: 200, svgY: 310, colorZone: 25, clickZone: 1 },
  { id: 'usak', name: { ar: 'أوشاك', en: 'Uşak', tr: 'Uşak' }, svgX: 185, svgY: 325, colorZone: 25, clickZone: 1 }
];

// Individual descriptions for each subunion
// Key is the union name (Arabic name from subunions.json)
// If a union is not listed here, it will use the default generic descriptions
export const subUnionsIndividualData = {
  "اتحاد اطلس": {
    aboutDescription: {
      ar: 'اتحاد اطلس هو اتحاد طلابي نشط يضم الطلبة السوريين في جامعة اطلس بإسطنبول. يعمل الاتحاد على دعم الطلاب أكاديمياً واجتماعياً وثقافياً، ويسعى لخلق بيئة تعليمية محفزة تساعد الطلاب على تحقيق أهدافهم الأكاديمية والمهنية. ينظم الاتحاد العديد من الفعاليات والأنشطة الثقافية والتربوية التي تعزز التواصل بين الطلاب وتقوي الروابط الاجتماعية.',
      en: 'Atlas Union is an active student union that brings together Syrian students at Atlas University in Istanbul. The union works to support students academically, socially, and culturally, and strives to create an inspiring educational environment that helps students achieve their academic and professional goals. The union organizes many cultural and educational events and activities that enhance communication between students and strengthen social bonds.',
      tr: 'Atlas Birliği, İstanbul\'daki Atlas Üniversitesi\'ndeki Suriyeli öğrencileri bir araya getiren aktif bir öğrenci birliğidir. Birlik, öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışır ve öğrencilerin akademik ve mesleki hedeflerine ulaşmalarına yardımcı olan ilham verici bir eğitim ortamı yaratmaya çalışır. Birlik, öğrenciler arasındaki iletişimi geliştiren ve sosyal bağları güçlendiren birçok kültürel ve eğitim etkinliği düzenler.'
    },
    cardDescription: {
      ar: 'اتحاد طلابي نشط يضم الطلبة السوريين في جامعة اطلس بإسطنبول، يعمل على دعم الطلاب أكاديمياً واجتماعياً وثقافياً.',
      en: 'An active student union bringing together Syrian students at Atlas University in Istanbul, working to support students academically, socially, and culturally.',
      tr: 'İstanbul\'daki Atlas Üniversitesi\'ndeki Suriyeli öğrencileri bir araya getiren aktif bir öğrenci birliği, öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışır.'
    },
    contactNumber: {
      ar: '+90 212 XXX XXXX',
      en: '+90 212 XXX XXXX',
      tr: '+90 212 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'تنظيم ورش عمل أكاديمية، فعاليات ثقافية، رحلات تعليمية، برامج دعم أكاديمي، أنشطة اجتماعية متنوعة.',
      en: 'Organizing academic workshops, cultural events, educational trips, academic support programs, various social activities.',
      tr: 'Akademik atölye çalışmaları, kültürel etkinlikler, eğitim gezileri, akademik destek programları, çeşitli sosyal etkinlikler düzenlemek.'
    },
    specialAchievements: {
      ar: 'فوز بجائزة أفضل اتحاد طلابي لعام 2023، تنظيم مؤتمر طلابي دولي، إطلاق برنامج منح دراسية.',
      en: 'Winning Best Student Union Award 2023, organizing an international student conference, launching a scholarship program.',
      tr: '2023 Yılın En İyi Öğrenci Birliği Ödülü\'nü kazanmak, uluslararası öğrenci konferansı düzenlemek, burs programı başlatmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: أحمد محمد، نائب الرئيس: فاطمة علي، أمين السر: خالد حسن، أمين الصندوق: سارة أحمد.',
      en: 'President: Ahmed Mohammed, Vice President: Fatima Ali, Secretary: Khaled Hassan, Treasurer: Sara Ahmed.',
      tr: 'Başkan: Ahmed Mohammed, Başkan Yardımcısı: Fatima Ali, Sekreter: Khaled Hassan, Sayman: Sara Ahmed.'
    },
    notes: {
      ar: 'الاتحاد نشط بشكل خاص في الأنشطة الثقافية والتربوية. يقدم دعم متميز للطلاب الجدد.',
      en: 'The union is particularly active in cultural and educational activities. Provides excellent support for new students.',
      tr: 'Birlik özellikle kültürel ve eğitim etkinliklerinde aktiftir. Yeni öğrenciler için mükemmel destek sağlar.'
    },
    logo: ''
  },
  
  "تجمع الطلبة السوريين في جامعة السلطان محمد الفاتح": {
    aboutDescription: {
      ar: 'بدأ كنشاط باسم "السقيفة" لطلاب الجامعة قبل ثلاث سنين. هدفهم نفع أكبر عدد من الطلاب السوريين والعرب داخل وخارج الجامعة.',
      en: 'Started as an activity called "Al-Saqifa" for university students three years ago. Their goal is to benefit the largest number of Syrian and Arab students inside and outside the university.',
      tr: 'Üç yıl önce üniversite öğrencileri için "Al-Saqifa" adlı bir etkinlik olarak başladı. Hedefleri, üniversite içinde ve dışında en fazla sayıda Suriyeli ve Arap öğrenciye fayda sağlamaktır.'
    },
    cardDescription: {
      ar: 'تجمع طلابي في جامعة السلطان محمد الفاتح، بدأ كنشاط "السقيفة" قبل ثلاث سنين.',
      en: 'A student gathering at Sultan Mehmet Fatih University, started as "Al-Saqifa" activity three years ago.',
      tr: 'Sultan Mehmet Fatih Üniversitesi\'nde üç yıl önce "Al-Saqifa" etkinliği olarak başlayan bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '05317284111',
      en: '05317284111',
      tr: '05317284111'
    },
    activitiesAndAchievements: {
      ar: 'مجالس مدارسة كتب السقيفة للشباب (مؤنسات للبنات). مجالس نخب (محاضرات تثقيفية يلقيها مختصون). ورش عمل تقنية ومهنية. حلقات لتحفيظ.',
      en: 'Al-Saqifa book study circles for young men (gatherings for girls). Elite councils (educational lectures by specialists). Technical and professional workshops. Memorization circles.',
      tr: 'Genç erkekler için Al-Saqifa kitap çalışma çevreleri (kızlar için toplantılar). Seçkin konseyler (uzmanlar tarafından verilen eğitici konferanslar). Teknik ve mesleki atölye çalışmaları. Ezber çevreleri.'
    },
    specialAchievements: {
      ar: 'السقيفة: قبل ثلاث سنين اجتمع ثلة من طلاب الجامعة في علية أحد الجوامع، سموا نشاطهم "السقيفة"، ارتباطا منهم بالتراث، والسقيفة مكان مسقوف بسعف النخيل مفتوح من الجهة الأمامية؛ كان يتحدث فيه العرب بأمورهم.',
      en: 'Al-Saqifa: Three years ago, a group of university students gathered in the upper room of one of the mosques, they named their activity "Al-Saqifa", connecting to their heritage. Al-Saqifa is a place roofed with palm fronds, open from the front side; where Arabs used to discuss their matters.',
      tr: 'Al-Saqifa: Üç yıl önce, bir grup üniversite öğrencisi camilerden birinin üst odasında toplandı, etkinliklerine "Al-Saqifa" adını verdiler, miraslarına bağlanarak. Al-Saqifa, hurma yapraklarıyla çatılı, ön taraftan açık bir yerdir; Araplar burada meselelerini konuşurlardı.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: محمود الشواف. أمانة السر: عمار موسى. مسؤول العلاقات: محمد الشياح. شؤون الطلبة: بيان بيروتي. مسؤول الإعلام: أحمد اليوسف. الدعم اللوجستي: أسامة درويشة.',
      en: 'President: Mahmoud Al-Shawaf. Secretary: Ammar Musa. Relations Officer: Mohammed Al-Shayyah. Student Affairs: Bayan Beirut. Media Officer: Ahmed Al-Youssef. Logistics Support: Osama Darwish.',
      tr: 'Başkan: Mahmoud Al-Shawaf. Sekreter: Ammar Musa. İlişkiler Görevlisi: Mohammed Al-Shayyah. Öğrenci İşleri: Bayan Beirut. Medya Görevlisi: Ahmed Al-Youssef. Lojistik Destek: Osama Darwish.'
    },
    notes: {
      ar: 'لا',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/fatih-logo-2.png'
  },
  "اتحاد إزمير": {
    aboutDescription: {
      ar: 'تجمع طلابي تطوعي يضم الطلبة السوريين في جامعات ومعاهد المدينة، يهدف إلى تمثيلهم ودعمهم أكاديمياً واجتماعياً. رسالته تعزيز التجربة التعليمية والحياتية وبناء مجتمع طلابي متعاون ومندمج. يركز على تنظيم الأنشطة الثقافية والإرشادية، وتمثيل الطلبة، وتقديم الدعم في قضايا التعليم والسكن والمنح.',
      en: 'A voluntary student gathering that includes Syrian students in universities and institutes of the city, aiming to represent and support them academically and socially. Its mission is to enhance educational and life experience and build a cooperative and integrated student community. It focuses on organizing cultural and guidance activities, representing students, and providing support in education, housing, and scholarship issues.',
      tr: 'Şehirdeki üniversite ve enstitülerdeki Suriyeli öğrencileri içeren, onları akademik ve sosyal olarak temsil etmeyi ve desteklemeyi amaçlayan gönüllü bir öğrenci topluluğu. Misyonu, eğitim ve yaşam deneyimini geliştirmek ve işbirlikçi ve entegre bir öğrenci topluluğu oluşturmaktır. Kültürel ve rehberlik etkinliklerini organize etmeye, öğrencileri temsil etmeye ve eğitim, konut ve burs konularında destek sağlamaya odaklanır.'
    },
    cardDescription: {
      ar: 'اتحاد إزمير - تجمع طلابي تطوعي يهدف إلى تمثيل الطلبة ودعمهم أكاديمياً واجتماعياً.',
      en: 'Izmir Union - A voluntary student gathering aiming to represent and support students academically and socially.',
      tr: 'İzmir Birliği - Öğrencileri akademik ve sosyal olarak temsil etmeyi ve desteklemeyi amaçlayan gönüllü bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '+905393647159',
      en: '+905393647159',
      tr: '+905393647159'
    },
    activitiesAndAchievements: {
      ar: 'ملتقى رواد الغد: لقاء شبابي لتنمية المهارات القيادية. ملتقى التعريف عن سوريا: فعالية ثقافية لتعريف المجتمع التركي بتاريخ وثقافة سوريا. ديوانية تبيان: جلسات وإفطار رمضاني. مسرحية "الخوف من الباب الوحيد": عمل مسرحي يعبر عن معاناة المعتقلين بسوريا. فعالية اليوم الثقافي: مشاركة الاتحاد على مدى 3 أيام للتعريف بالثقافة السورية. حفل تخرج دفعة النصر: تنظيم احتفال تكريمي لخريجي العام. حملة الخبز: مبادرة خيرية لدعم الطلب والأسر المحتاجة في أيام التحرير.',
      en: 'Pioneers of Tomorrow Gathering: Youth meeting for developing leadership skills. Syria Introduction Gathering: Cultural event to introduce Turkish society to Syria\'s history and culture. Tibyan Diwaniya: Sessions and Ramadan Iftar. Play "Fear of the Only Door": A theatrical work expressing the suffering of detainees in Syria. Culture Day Event: Union participation over 3 days to introduce Syrian culture. Al-Nasr Batch Graduation Ceremony: Organizing an honorary celebration for graduates of the year. Bread Campaign: Charity initiative to support students and needy families during liberation days.',
      tr: 'Yarının Öncüleri Buluşması: Liderlik becerilerini geliştirmek için gençlik buluşması. Suriye Tanıtım Buluşması: Türk toplumunu Suriye\'nin tarihi ve kültürüyle tanıştırmak için kültürel etkinlik. Tibyan Divaniye: Oturumlar ve Ramazan İftarı. "Tek Kapıdan Korku" oyunu: Suriye\'deki tutukluların acılarını ifade eden bir tiyatro eseri. Kültür Günü Etkinliği: Suriye kültürünü tanıtmak için 3 gün boyunca birlik katılımı. El-Nasr Grubu Mezuniyet Töreni: Yılın mezunları için onurlandırıcı bir kutlama düzenlemek. Ekmek Kampanyası: Kurtuluş günlerinde öğrencilere ve ihtiyaç sahibi ailelere destek için hayır girişimi.'
    },
    specialAchievements: {
      ar: 'حقّق الاتحاد حضورًا فاعلاً عبر منحة طب بقيمة $7200$، ومبادرة "حلم يُبنى" التي قدمت ثلاث منح جزئية، إضافة إلى تعاونات تعليمية مهمة مع رواد المستقبل و Go Learn.',
      en: 'The union achieved an active presence through a medical scholarship worth $7200, and the "A Dream is Built" initiative that provided three partial scholarships, in addition to important educational collaborations with Pioneers of the Future and Go Learn.',
      tr: 'Birlik, $7200 değerinde bir tıp bursu ve üç kısmi burs sağlayan "Bir Rüya İnşa Ediliyor" girişimi aracılığıyla aktif bir varlık elde etti, ayrıca Geleceğin Öncüleri ve Go Learn ile önemli eğitim işbirlikleri gerçekleştirdi.'
    },
    currentAdministrativeTeam: {
      ar: 'نائبة الرئيس: أماني ناصيف. المديرة التنفيذية: راضية حنظل. مسؤولة المكتب الإعلامي: مرح الزعبي. مسؤولة الطالبات: بيان سندة. مسؤولة المكتب الترفيهي: إسراء الهلال.',
      en: 'Vice President: Amani Naseef. Executive Director: Radia Hanzal. Media Office Head: Marah al-Zoubi. Female Students Officer: Bayan Sanda. Entertainment Office Head: Israa al-Hilal.',
      tr: 'Başkan Yardımcısı: Amani Naseef. Genel Müdür: Radia Hanzal. Medya Ofisi Başkanı: Marah el-Zoubi. Kız Öğrenci Görevlisi: Bayan Sanda. Eğlence Ofisi Başkanı: Israa el-Hilal.'
    },
    notes: {
      ar: 'منبراً طلابيا فاعلا يجمع بين العمل النقابي والخدمة المجتمعية، ويسعى دائما لأن يكون صوت الطلبة ومظلتهم الجامعة في تركيا. يركز على تمكين الطلبة أكاديمياً ومهنياً من خلال المنح والبرامج التدريبية.',
      en: 'An active student platform that combines union work and community service, always seeking to be the voice and umbrella of students in Turkey. It focuses on empowering students academically and professionally through scholarships and training programs.',
      tr: 'Sendika çalışması ve toplum hizmetini birleştiren, her zaman Türkiye\'deki öğrencilerin sesi ve şemsiyesi olmaya çalışan aktif bir öğrenci platformu. Burslar ve eğitim programları aracılığıyla öğrencileri akademik ve mesleki olarak güçlendirmeye odaklanır.'
    },
    logo: './assets/subunions/izmir-logo.png'
  },
  "اتحاد الطلبة السوريين في العاصمة أنقرة": {
    aboutDescription: {
      ar: 'رسالته بناء بيئة طلابية فاعلة تعزز الانتماء والمسؤولية، وتدعم الطلبة في مسيرتهم التعليمية. أهدافه تتركز في تنظيم الأنشطة العلمية والثقافية، وتقديم الإرشاد الأكاديمي والخدمات الطلابية، وتعزيز التواصل.',
      en: 'Its mission is to build an active student environment that enhances belonging and responsibility, and supports students in their educational journey. Its objectives focus on organizing scientific and cultural activities, providing academic guidance and student services, and enhancing communication.',
      tr: 'Misyonu, aidiyet ve sorumluluğu geliştiren ve öğrencileri eğitim yolculuklarında destekleyen aktif bir öğrenci ortamı oluşturmaktır. Hedefleri, bilimsel ve kültürel etkinlikleri organize etmeye, akademik rehberlik ve öğrenci hizmetleri sağlamaya ve iletişimi geliştirmeye odaklanır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في العاصمة أنقرة - يهدف إلى بناء بيئة طلابية فاعلة وتعزيز الانتماء.',
      en: 'Syrian Students Union in the Capital Ankara - Aims to build an active student environment and enhance belonging.',
      tr: 'Başkent Ankara Suriyeli Öğrenci Birliği - Aktif bir öğrenci ortamı oluşturmayı ve aidiyeti geliştirmeyi amaçlar.'
    },
    contactNumber: {
      ar: '05539014593',
      en: '05539014593',
      tr: '05539014593'
    },
    activitiesAndAchievements: {
      ar: 'حفل التخرج السنوي. محاضرات علمية وتوعوية بالتعاون مع مختصين (أبرزها الجلسات التعريفية بمشاريع TUBITAK). برنامج تدريبي في استخدام برنامج SPSS لتحليل البيانات الإحصائية. التعريف بمنحة ESPS الأوروبية ومساعدة الطلبة في التسجيل. أنشطة ترفيهية واجتماعية وإفطارات رمضانية جماعية. مبادرات خدمية وتنظيمية لمساعدة الطلبة الجدد في الاندماج والتسجيل.',
      en: 'Annual graduation ceremony. Scientific and awareness lectures in cooperation with specialists (most notably introductory sessions on TUBITAK projects). Training program in using SPSS software for statistical data analysis. Introduction to ESPS European scholarship and assisting students in registration. Recreational and social activities and collective Ramadan Iftars. Service and organizational initiatives to help new students integrate and register.',
      tr: 'Yıllık mezuniyet töreni. Uzmanlarla işbirliği içinde bilimsel ve farkındalık konferansları (en önemlisi TUBITAK projeleri hakkında tanıtım oturumları). İstatistiksel veri analizi için SPSS yazılımını kullanma eğitim programı. ESPS Avrupa bursuna giriş ve öğrencilerin kayıtlarına yardımcı olma. Rekreasyon ve sosyal etkinlikler ve toplu Ramazan İftarları. Yeni öğrencilerin entegrasyonu ve kaydına yardımcı olmak için hizmet ve organizasyon girişimleri.'
    },
    specialAchievements: {
      ar: 'تنظيم جلسات تعريفية بمنحة ESPS الأوروبية ودورات SPSS. إعداد دليل شامل للجامعات في أنقرة لمساعدة الطلبة الجدد. إقامة حفل التخرج السنوي. النجاح في استقطاب عدد كبير من الطلبة الجدد.',
      en: 'Organizing introductory sessions on ESPS European scholarship and SPSS courses. Preparing a comprehensive guide to universities in Ankara to help new students. Holding the annual graduation ceremony. Success in attracting a large number of new students.',
      tr: 'ESPS Avrupa bursu ve SPSS kursları hakkında tanıtım oturumları düzenlemek. Yeni öğrencilere yardımcı olmak için Ankara\'daki üniversiteler hakkında kapsamlı bir rehber hazırlamak. Yıllık mezuniyet töreni düzenlemek. Çok sayıda yeni öğrenciyi çekmede başarı.'
    },
    currentAdministrativeTeam: {
      ar: 'يتكون من ثلاث هيئات رئيسية. الهيئة الرقابية: 3 أعضاء. الهيئة الانتخابية: 3 أعضاء. الهيئة الإدارية: 6 أعضاء (رئيس، نائب الرئيس، ومكاتب شؤون الطلبة، والترفيه، والإعلام والثقافة).',
      en: 'Consists of three main bodies. Supervisory Body: 3 members. Electoral Body: 3 members. Administrative Body: 6 members (president, vice president, and offices of student affairs, entertainment, media and culture).',
      tr: 'Üç ana organdan oluşur. Denetim Kurulu: 3 üye. Seçim Kurulu: 3 üye. Yönetim Kurulu: 6 üye (başkan, başkan yardımcısı ve öğrenci işleri, eğlence, medya ve kültür ofisleri).'
    },
    notes: {
      ar: 'يحرص على أن يكون نموذجاً للعمل الطلابي المنظم والمسؤول. يتميز بهويته الجامعة التي تعلي من روح التعاون والانتماء.',
      en: 'It strives to be a model of organized and responsible student work. It is distinguished by its unifying identity that elevates the spirit of cooperation and belonging.',
      tr: 'Organize ve sorumlu öğrenci çalışmasının bir modeli olmaya çalışır. İşbirliği ve aidiyet ruhunu yükselten birleştirici kimliğiyle ayırt edilir.'
    },
    logo: ''
  },
  "تجمع الطلاب السوريين في قونيا": {
    aboutDescription: {
      ar: 'تجمع طالبي نقابي مستقل قائم بذاته يمثل الطلبة السوريين المنتسبين إليه من جامعات (سلجوق - قونيا التقنية - كاراتاي - نجم دين أربكان) في ولاية قونيا التركية. يعمل للوصول إلى مستوى علمي ثقافي متقدم للطلبة.',
      en: 'An independent student union gathering that represents Syrian students affiliated with it from universities (Selçuk - Konya Technical - Karatay - Necmettin Erbakan) in Konya province, Turkey. It works to reach an advanced scientific and cultural level for students.',
      tr: 'Konya ili, Türkiye\'deki üniversitelerden (Selçuk - Konya Teknik - Karatay - Necmettin Erbakan) bağlı Suriyeli öğrencileri temsil eden bağımsız bir öğrenci birliği topluluğu. Öğrenciler için ileri bir bilimsel ve kültürel seviyeye ulaşmak için çalışır.'
    },
    cardDescription: {
      ar: 'تجمع الطلاب السوريين في قونيا - تجمع طالبي نقابي مستقل يمثل الطلبة السوريين من جامعات قونيا.',
      en: 'Syrian Students Gathering in Konya - An independent student union gathering representing Syrian students from Konya universities.',
      tr: 'Konya\'daki Suriyeli Öğrenci Topluluğu - Konya üniversitelerinden Suriyeli öğrencileri temsil eden bağımsız bir öğrenci birliği topluluğu.'
    },
    contactNumber: {
      ar: '05395787598',
      en: '05395787598',
      tr: '05395787598'
    },
    activitiesAndAchievements: {
      ar: 'حفل التخرج (دفعة خريجي الحرية). مؤتمر إنما الأمة بشبابها. فعالية الاحتفال بنصر الثورة. يوم الثقافة في جامعتي نجم الدين أربكان وسلجوق. حملة تبرع لغزة (كن عونا). رحلة في ظلال الطبيعة.',
      en: 'Graduation ceremony (Freedom Graduates batch). Conference "Indeed, the nation is with its youth". Victory of the Revolution celebration event. Culture Day at Necmettin Erbakan and Selçuk universities. Gaza donation campaign (Be a helper). Journey in the shadows of nature.',
      tr: 'Mezuniyet töreni (Özgürlük Mezunları grubu). "Gerçekten millet gençliğiyle birliktedir" konferansı. Devrimin Zaferi kutlama etkinliği. Necmettin Erbakan ve Selçuk üniversitelerinde Kültür Günü. Gazze bağış kampanyası (Yardımcı ol). Doğanın gölgelerinde yolculuk.'
    },
    specialAchievements: {
      ar: 'فعالية الاحتفال بنصر الثورة، حفل التخرج (دفعة خريجي الحرية).',
      en: 'Victory of the Revolution celebration event, Graduation ceremony (Freedom Graduates batch).',
      tr: 'Devrimin Zaferi kutlama etkinliği, Mezuniyet töreni (Özgürlük Mezunları grubu).'
    },
    currentAdministrativeTeam: {
      ar: 'الهيئة الإدارية: محمد كمال الدين نعسان - الأمين العام، جلال الدين موسى - نائب الأمين العام وأمين المكتب المالي، اسامة حاج سليمان - مسؤول أرشيف، حلا تاجي - أمينة المكتب الإعلامي، آية اصطيف - أمينة المكتب الأكاديمي، حيدر الجاسم - أمين مكتب الأنشطة، علي عرقاوي - أمين مكتب شؤون الطلبة، آية الحسين - أمينة مكتب الطالبات. الهيئة الرقابية: عمر بلبل - رئيس الهيئة الرقابية، عبد القادر الإسماعيل - عضو هيئة رقابية، فاطمة حمشو - عضو هيئة رقابية. ملحق إدارة نادي نبراس القراء: محمد منشار، رهام حمشو.',
      en: 'Administrative Body: Muhammad Kamal al-Din Naasan - Secretary General, Jalal al-Din Musa - Deputy Secretary General and Financial Office Secretary, Osama Haj Suleiman - Archive Officer, Hala Taji - Media Office Secretary, Aya Istayif - Academic Office Secretary, Haider al-Jassim - Activities Office Secretary, Ali Arqawi - Student Affairs Office Secretary, Aya al-Hussein - Female Students Office Secretary. Supervisory Body: Omar Bulbul - Head of Supervisory Body, Abdul Qadir al-Ismail - Supervisory Body Member, Fatima Hamsho - Supervisory Body Member. Nibras Readers Club Management: Muhammad Manshar, Riham Hamsho.',
      tr: 'Yönetim Kurulu: Muhammed Kemalettin Naasan - Genel Sekreter, Celalettin Musa - Genel Sekreter Yardımcısı ve Maliye Ofisi Sekreteri, Osama Hac Süleyman - Arşiv Sorumlusu, Hala Taci - Medya Ofisi Sekreteri, Aya Istayif - Akademik Ofis Sekreteri, Haydar el-Casim - Etkinlikler Ofisi Sekreteri, Ali Arqavi - Öğrenci İşleri Ofisi Sekreteri, Aya el-Hüseyin - Kız Öğrenciler Ofisi Sekreteri. Denetim Kurulu: Ömer Bulbul - Denetim Kurulu Başkanı, Abdülkadir el-İsmail - Denetim Kurulu Üyesi, Fatma Hamşo - Denetim Kurulu Üyesi. Nibras Okuyucular Kulübü Yönetimi: Muhammed Manshar, Riham Hamşo.'
    },
    notes: {
      ar: 'يعتبر هذا التجمع الناطق الرسمي باسم الطلبة السوريين المنخرطين فيه إزاء القضايا التي تهمهم والتي تواكب قضية وطنهم الساعي نحو الحرية والكرامة، ويمثل الطالب المنتسبين له أمام السلطات العامة والرأي العام.',
      en: 'This gathering is considered the official spokesperson for the Syrian students enrolled in it regarding issues that concern them and which accompany the cause of their homeland seeking freedom and dignity, and represents the affiliated students before public authorities and public opinion.',
      tr: 'Bu topluluk, içindeki Suriyeli öğrencilerin özgürlük ve onur arayışındaki vatanlarının davasına eşlik eden ve onları ilgilendiren konularda resmi sözcüsü olarak kabul edilir ve bağlı öğrencileri kamu otoriteleri ve kamuoyu önünde temsil eder.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين - مرسين": {
    aboutDescription: {
      ar: 'هيئة طلابية تعمل على تمثيل الطلاب والدفاع عن حقوقهم، وتعزيز مشاركتهم في الحياة الجامعية. رسالتنا خلق بيئة جامعية داعمة تحفز الإبداع وتبني روح المبادرة والمسؤولية. أهدافنا: تعزيز التواصل بين الطلبة وإدارة الجامعة، دعم الأنشطة العلمية والثقافية والاجتماعية، توفير برامج تدريبية ومبادرات تطوير مهاري، العمل على تقديم خدمات ومشاريع ترفع من جودة الحياة الجامعية.',
      en: 'A student body that works to represent students and defend their rights, and enhance their participation in university life. Our mission is to create a supportive university environment that stimulates creativity and builds a spirit of initiative and responsibility. Our objectives: enhancing communication between students and university administration, supporting scientific, cultural and social activities, providing training programs and skills development initiatives, working to provide services and projects that raise the quality of university life.',
      tr: 'Öğrencileri temsil eden ve haklarını savunan, üniversite yaşamına katılımlarını artıran bir öğrenci kuruluşu. Misyonumuz, yaratıcılığı teşvik eden ve girişimcilik ve sorumluluk ruhunu inşa eden destekleyici bir üniversite ortamı yaratmaktır. Hedeflerimiz: öğrenciler ve üniversite yönetimi arasındaki iletişimi geliştirmek, bilimsel, kültürel ve sosyal etkinlikleri desteklemek, eğitim programları ve beceri geliştirme girişimleri sağlamak, üniversite yaşamının kalitesini artıran hizmetler ve projeler sunmak için çalışmak.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين - مرسين: هيئة طلابية تعمل على تمثيل الطلاب والدفاع عن حقوقهم.',
      en: 'Syrian Students Union - Mersin: A student body working to represent students and defend their rights.',
      tr: 'Suriyeli Öğrenci Birliği - Mersin: Öğrencileri temsil eden ve haklarını savunan bir öğrenci kuruluşu.'
    },
    contactNumber: {
      ar: '+905388633503',
      en: '+905388633503',
      tr: '+905388633503'
    },
    activitiesAndAchievements: {
      ar: 'ذكرى الثورة السورية. فعالية اليوم الثقافي. حفل التخرج. مباريات. فعالية ثقافية للإناث. فعاليات للقراءة ومناقشة الكتب. ذكرى مجزرة الكيماوي.',
      en: 'Syrian Revolution commemoration. Culture Day event. Graduation ceremony. Sports matches. Cultural event for females. Reading and book discussion events. Chemical massacre commemoration.',
      tr: 'Suriye Devrimi anma. Kültür Günü etkinliği. Mezuniyet töreni. Spor maçları. Kadınlar için kültürel etkinlik. Okuma ve kitap tartışma etkinlikleri. Kimyasal katliam anması.'
    },
    specialAchievements: {
      ar: 'تنظيمنا لفعاليات أكاديمية وتدريبية وثقافية ساهمت بشكل واضح وملموس في رفع كفاءة الطلاب ودعم مسارهم المهني.',
      en: 'Our organization of academic, training and cultural events has clearly and tangibly contributed to raising student efficiency and supporting their career path.',
      tr: 'Akademik, eğitim ve kültürel etkinliklerin düzenlenmesi, öğrenci verimliliğini artırmada ve kariyer yollarını desteklemede açık ve somut bir şekilde katkıda bulunmuştur.'
    },
    currentAdministrativeTeam: {
      ar: 'رئيس الاتحاد: أحمد قطيش. نائب الرئيس: رحمة القاعد. مكتب الأنشطة والفعاليات: عمران الجاسم. مكتب شؤون الطلبة: أنس كمال الدين (مديرة: لانا الطاهي). مديرة مكتب الإعلام: يمامة كحلاوي. مدير المكتب اللوجيستي: سالم البشار. مديرة المكتب الثقافي: لين الوتار. مسؤول طلاب جامعة طوروس: محمد سميسم.',
      en: 'Union President: Ahmed Qateesh. Vice President: Rahma Al-Qaid. Activities and Events Office: Imran Al-Jassem. Student Affairs Office: Anas Kamal Al-Din (Director: Lana Al-Tahi). Media Office Director: Yamama Kahlaoui. Logistics Office Director: Salem Al-Bashar. Cultural Office Director: Lin Al-Watar. Toros University Students Officer: Mohammed Samisam.',
      tr: 'Birlik Başkanı: Ahmed Qateesh. Başkan Yardımcısı: Rahma Al-Qaid. Etkinlikler ve Faaliyetler Ofisi: Imran Al-Jassem. Öğrenci İşleri Ofisi: Anas Kamal Al-Din (Müdür: Lana Al-Tahi). Medya Ofisi Müdürü: Yamama Kahlaoui. Lojistik Ofisi Müdürü: Salem Al-Bashar. Kültür Ofisi Müdürü: Lin Al-Watar. Toros Üniversitesi Öğrenci Görevlisi: Mohammed Samisam.'
    },
    notes: {
      ar: 'تم التوضيح سابقا',
      en: 'As previously explained.',
      tr: 'Daha önce açıklandığı gibi.'
    },
    logo: './assets/subunions/mersin-logo.png'
  },
  "تجمع الطلبة السوريين في جامعة بورصة أولوداغ": {
    aboutDescription: {
      ar: 'كيان طلابي تطوعي منتخب ومستقل، مرخص في جامعة أولوداغ. يتبنى قضايا الطلبة السوريين ويمثلهم أمام الجهات الرسمية والخاصة، ويهدف لخدمة الطلبة وتنميتهم فكراً وثقافة ومهارة. الرؤية: ركن طلابي سوري تنموي قائد في التغيير المجتمعي. الأهداف الاستراتيجية: تعزيز الهوية السورية لدى الطلبة، إيجاد حلول جذرية للمشاكل، تعزيز الانسجام والتواصل بين الطلبة وخلق مساحة لتبادل الخبرات والأفكار، رفع المستوى الثقافي والعلمي للطلبة، نقل سردية وقضية الطالب السوري، الترفيه عن الطلاب، إتاحة الفرصة لاكتشاف الخبرات والمهارات التقنية والحياتية وتنميتها، التعاون مع الجهات والمؤسسات والمبادرات التعليمية والخدمية.',
      en: 'An elected, independent voluntary student entity, licensed at Uludag University. It adopts the issues of Syrian students and represents them before official and private bodies, and aims to serve students and develop them intellectually, culturally, and skillfully. Vision: A leading Syrian developmental student corner in societal change. Strategic objectives: strengthening Syrian identity among students, finding radical solutions to problems, enhancing harmony and communication among students and creating a space for exchanging experiences and ideas, raising the cultural and scientific level of students, conveying the narrative and cause of Syrian students, entertaining students, providing opportunities to discover and develop technical and life skills and experiences, cooperating with educational and service bodies, institutions and initiatives.',
      tr: 'Uludağ Üniversitesi\'nde lisanslı, seçilmiş, bağımsız gönüllü bir öğrenci varlığı. Suriyeli öğrencilerin sorunlarını benimser ve onları resmi ve özel kurumlar önünde temsil eder ve öğrencilere hizmet etmeyi ve onları entelektüel, kültürel ve beceri açısından geliştirmeyi amaçlar. Vizyon: Toplumsal değişimde öncü Suriyeli gelişimsel bir öğrenci köşesi. Stratejik hedefler: öğrenciler arasında Suriye kimliğini güçlendirmek, sorunlara köklü çözümler bulmak, öğrenciler arasında uyum ve iletişimi geliştirmek ve deneyim ve fikir alışverişi için bir alan yaratmak, öğrencilerin kültürel ve bilimsel seviyesini yükseltmek, Suriyeli öğrencilerin anlatısını ve davasını aktarmak, öğrencileri eğlendirmek, teknik ve yaşam becerileri ve deneyimlerini keşfetme ve geliştirme fırsatları sağlamak, eğitim ve hizmet kurumları, kuruluşları ve girişimleriyle işbirliği yapmak.'
    },
    cardDescription: {
      ar: 'تجمع الطلبة السوريين في جامعة بورصة أولوداغ - كيان طلابي تطوعي منتخب ومستقل.',
      en: 'Syrian Students Gathering at Bursa Uludag University - An elected, independent voluntary student entity.',
      tr: 'Bursa Uludağ Üniversitesi Suriyeli Öğrenci Topluluğu - Seçilmiş, bağımsız gönüllü bir öğrenci varlığı.'
    },
    contactNumber: {
      ar: '053530906877 (مسؤول العلاقات العامة - راشد البوعريب)',
      en: '053530906877 (Public Relations Officer - Rashid Al-Burayb)',
      tr: '053530906877 (Halkla İlişkiler Görevlisi - Rashid Al-Burayb)'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمر سوريا. مسرحية الخوف من الباب الوحيد. حفل تخرج "خطى". العديد من الورشات التدريبية والندوات. سلسلة من الورش المهنية والثقافية. إفطارات رمضانية.',
      en: 'Syria Conference. Play "Fear of the Only Door". Graduation ceremony "Steps". Many training workshops and seminars. Series of professional and cultural workshops. Ramadan Iftars.',
      tr: 'Suriye Konferansı. "Tek Kapıdan Korku" oyunu. "Adımlar" mezuniyet töreni. Birçok eğitim atölyesi ve seminer. Profesyonel ve kültürel atölye serisi. Ramazan İftarları.'
    },
    specialAchievements: {
      ar: 'مؤتمر النصر - الشباب السوري من الثورة إلى النهضة: أول مؤتمر طلابي يُعقد في تركيا احتفاء بانتصار الثورة، وأكبر حدث شبابي من نوعه في مدينة بورصة، حضره ما يزيد عن 1200 شخص. فيلم المغترب: مشروع تم تأليفه وكتابته وإخراجه وتصويره وتمثيله من قبل فريق الإعلام وبمساعدة أعضاء الإدارة والمتطوعين.',
      en: 'Victory Conference - Syrian Youth from Revolution to Renaissance: The first student conference held in Turkey celebrating the victory of the revolution, and the largest youth event of its kind in Bursa city, attended by more than 1,200 people. The Expatriate Film: A project written, scripted, directed, filmed, and acted by the media team with the help of administration members and volunteers.',
      tr: 'Zafer Konferansı - Devrimden Rönesansa Suriyeli Gençlik: Devrimin zaferini kutlamak için Türkiye\'de düzenlenen ilk öğrenci konferansı ve Bursa şehrindeki türünün en büyük gençlik etkinliği, 1,200\'den fazla kişi katıldı. Göçmen Filmi: Medya ekibi tarafından yazılan, senaryolaştırılan, yönetilen, çekilen ve oynanan, yönetim üyeleri ve gönüllülerin yardımıyla bir proje.'
    },
    currentAdministrativeTeam: {
      ar: 'مجلس الإدارة المنتخب: الرئيس: ريبار بكر، مسؤول العلاقات العامة: راشد البوعريب، المسؤول المالي واللوجستي: عمر عزيزي، مسؤولة الأنشطة: جود الشيخ أحمد، أمينة السر: كنانة الفرخ. المكاتب الدائمة: المكتب الإعلامي، مكتب تعزيز العلاقات، المكتب المالي، المكتب اللوجستي، المكتب الترفيهي، المكتب الرياضي، المكتب الثقافي، مكتب الطالبات، مكتب شؤون الطلبة، المكتب الأكاديمي، مكتب الموارد البشرية. وحدة المتابعة والتقييم: تتكون من ثلاث أشخاص منتخبين من الهيئة العامة.',
      en: 'Elected Board of Directors: President: Ribar Bakr, Public Relations Officer: Rashid Al-Burayb, Financial and Logistics Officer: Omar Azizi, Activities Officer: Joud Al-Sheikh Ahmed, Secretary: Kinana Al-Farkh. Permanent Offices: Media Office, Relations Enhancement Office, Financial Office, Logistics Office, Entertainment Office, Sports Office, Cultural Office, Female Students Office, Student Affairs Office, Academic Office, Human Resources Office. Monitoring and Evaluation Unit: Consists of three people elected from the general assembly.',
      tr: 'Seçilmiş Yönetim Kurulu: Başkan: Ribar Bakr, Halkla İlişkiler Görevlisi: Rashid Al-Burayb, Mali ve Lojistik Görevlisi: Omar Azizi, Etkinlikler Görevlisi: Joud Al-Sheikh Ahmed, Sekreter: Kinana Al-Farkh. Kalıcı Ofisler: Medya Ofisi, İlişkileri Geliştirme Ofisi, Mali Ofis, Lojistik Ofis, Eğlence Ofisi, Spor Ofisi, Kültür Ofisi, Kız Öğrenci Ofisi, Öğrenci İşleri Ofisi, Akademik Ofis, İnsan Kaynakları Ofisi. İzleme ve Değerlendirme Birimi: Genel kuruldan seçilen üç kişiden oluşur.'
    },
    notes: {
      ar: 'نجح في جعل التجمع في المرتبة الأولى في تركيا. تم تنفيذ ما يقارب 85 فعالية في غضون 6 أشهر. نجح برفع عدد المنتسبين إلى 3 أضعاف والمتطوعين إلى ضعفين.',
      en: 'Succeeded in making the gathering rank first in Turkey. Approximately 85 events were implemented within 6 months. Succeeded in tripling the number of members and doubling the number of volunteers.',
      tr: 'Topluluğu Türkiye\'de birinci sıraya getirmeyi başardı. 6 ay içinde yaklaşık 85 etkinlik gerçekleştirildi. Üye sayısını 3 katına ve gönüllü sayısını 2 katına çıkarmayı başardı.'
    },
    logo: ''
  },
  "اتحاد عنتاب": {
    aboutDescription: {
      ar: 'اتحاد عنتاب يخدم الطلبة السوريين في مدينة غازي عنتاب. يتميز الاتحاد بتركيزه على الدعم الأكاديمي القوي والأنشطة الثقافية المتنوعة. ينظم الاتحاد ورش عمل في مختلف المجالات، ودورات تدريبية في المهارات المهنية، وفعاليات ثقافية وترفيهية. كما يقدم خدمات الاستشارة الأكاديمية والمساعدة في البحث عن فرص العمل والتدريب.',
      en: 'Gaziantep Union serves Syrian students in the city of Gaziantep. The union is distinguished by its focus on strong academic support and diverse cultural activities. The union organizes workshops in various fields, professional skills training courses, and cultural and recreational events. It also provides academic counseling services and assistance in finding job and training opportunities.',
      tr: 'Gaziantep Birliği, Gaziantep şehrindeki Suriyeli öğrencilere hizmet verir. Birlik, güçlü akademik desteğe ve çeşitli kültürel etkinliklere odaklanmasıyla öne çıkar. Birlik, çeşitli alanlarda atölye çalışmaları, mesleki beceriler eğitim kursları ve kültürel ve rekreasyon etkinlikleri düzenler. Ayrıca akademik danışmanlık hizmetleri ve iş ve eğitim fırsatları bulma konusunda yardım sağlar.'
    },
    cardDescription: {
      ar: 'اتحاد في غازي عنتاب يركز على الدعم الأكاديمي القوي والأنشطة الثقافية المتنوعة.',
      en: 'A union in Gaziantep focusing on strong academic support and diverse cultural activities.',
      tr: 'Gaziantep\'teki güçlü akademik destek ve çeşitli kültürel etkinliklere odaklanan bir birlik.'
    },
    contactNumber: {
      ar: '+90 312 XXX XXXX',
      en: '+90 312 XXX XXXX',
      tr: '+90 312 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمرات وندوات علمية، برامج تدريبية في المهارات القيادية، ورش عمل في ريادة الأعمال، خدمات التوجيه والإرشاد.',
      en: 'Scientific conferences and seminars, leadership skills training programs, entrepreneurship workshops, orientation and guidance services.',
      tr: 'Bilimsel konferanslar ve seminerler, liderlik becerileri eğitim programları, girişimcilik atölye çalışmaları, oryantasyon ve rehberlik hizmetleri.'
    },
    specialAchievements: {
      ar: 'تنظيم مؤتمر قيادة طلابي دولي، إطلاق برنامج ريادة الأعمال، فوز بجائزة التميز في القيادة.',
      en: 'Organizing an international student leadership conference, launching an entrepreneurship program, winning Leadership Excellence Award.',
      tr: 'Uluslararası öğrenci liderliği konferansı düzenlemek, girişimcilik programı başlatmak, Liderlik Mükemmellik Ödülü kazanmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: خالد محمود، نائب الرئيس: سمر علي، أمين السر: طارق يوسف، أمين الصندوق: ناديا حسن.',
      en: 'President: Khaled Mahmoud, Vice President: Samar Ali, Secretary: Tariq Youssef, Treasurer: Nadia Hassan.',
      tr: 'Başkan: Khaled Mahmoud, Başkan Yardımcısı: Samar Ali, Sekreter: Tariq Youssef, Sayman: Nadia Hassan.'
    },
    notes: {
      ar: 'الاتحاد رائد في مجال القيادة الطلابية وريادة الأعمال. يقدم برامج متميزة للطلاب الطموحين.',
      en: 'The union is a leader in student leadership and entrepreneurship. Provides outstanding programs for ambitious students.',
      tr: 'Birlik, öğrenci liderliği ve girişimcilik alanında öncüdür. Hırslı öğrenciler için seçkin programlar sunar.'
    },
    logo: './assets/subunions/gazientab-logo.png'
  },
  "اتحاد الطلبة السوريين - قيصري": {
    aboutDescription: {
      ar: 'تأسس عام 2018، ويشمل ثلاث جامعات حكومية هي: جامعة إرجييس، جامعة قيصري، وجامعة عبدالله غول. يسعى إلى بناء مجتمع طلابي متعاون وداعم، ويسهل اندماج الطلبة السوريين في الحياة الجامعية.',
      en: 'Established in 2018, it includes three public universities: Erciyes University, Kayseri University, and Abdullah Gül University. It seeks to build a cooperative and supportive student community, and facilitates the integration of Syrian students into university life.',
      tr: '2018 yılında kuruldu ve üç devlet üniversitesini kapsar: Erciyes Üniversitesi, Kayseri Üniversitesi ve Abdullah Gül Üniversitesi. İşbirlikçi ve destekleyici bir öğrenci topluluğu oluşturmayı ve Suriyeli öğrencilerin üniversite yaşamına entegrasyonunu kolaylaştırmayı amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين - قيصري - يشمل ثلاث جامعات حكومية ويسعى لبناء مجتمع طلابي متعاون.',
      en: 'Syrian Students Union - Kayseri - Includes three public universities and seeks to build a cooperative student community.',
      tr: 'Suriyeli Öğrenci Birliği - Kayseri - Üç devlet üniversitesini kapsar ve işbirlikçi bir öğrenci topluluğu oluşturmayı amaçlar.'
    },
    contactNumber: {
      ar: '05051620198',
      en: '05051620198',
      tr: '05051620198'
    },
    activitiesAndAchievements: {
      ar: 'فعاليات ترفيهية (مسير في الجبل، رحلة إلى البحيرة، استكشاف قيصري). أنشطة ثقافية (جلسات نقاشية، مناظرات). متابعة الأمور والأخبار التعليمية، النشر عن المنح والكورسات المتوفرة. تنظيم حفل الخريجين وتخريج أكثر من 75 طالب.',
      en: 'Recreational activities (mountain hike, trip to the lake, exploring Kayseri). Cultural activities (discussion sessions, debates). Following educational matters and news, publishing about available scholarships and courses. Organizing graduation ceremony and graduating more than 75 students.',
      tr: 'Rekreasyon etkinlikleri (dağ yürüyüşü, göle gezi, Kayseri\'yi keşfetme). Kültürel etkinlikler (tartışma oturumları, münazaralar). Eğitim konularını ve haberlerini takip etmek, mevcut burslar ve kurslar hakkında yayın yapmak. Mezuniyet töreni düzenlemek ve 75\'ten fazla öğrenci mezun etmek.'
    },
    specialAchievements: {
      ar: 'حملة دعم لزملاءنا الطلبة في تأمين أقساطهم الجامعية وتم التكفل بثلاث حالات بجهود فردية.',
      en: 'Support campaign for our fellow students to secure their university tuition fees, and three cases were covered through individual efforts.',
      tr: 'Öğrenci arkadaşlarımızın üniversite harçlarını güvence altına almak için destek kampanyası ve bireysel çabalar aracılığıyla üç vaka karşılandı.'
    },
    currentAdministrativeTeam: {
      ar: 'يتكون من إدارة الاتحاد (رئيس ونائبه ورؤساء المكاتب). مجلس الاتحاد يضم كل من انضم للمكاتب واللجان الفرعية. المكاتب المتوفرة: المكتب الرقابي، مكتب شؤون الطلبة، المكتب الثقافي والترفيهي، المكتب الإعلامي، مكتب العلاقات الخارجية.',
      en: 'Consists of the union administration (president, vice president, and office heads). The union council includes everyone who joined the offices and sub-committees. Available Offices: Supervisory Office, Student Affairs Office, Cultural and Entertainment Office, Media Office, External Relations Office.',
      tr: 'Birlik yönetiminden oluşur (başkan, başkan yardımcısı ve ofis başkanları). Birlik konseyi, ofislere ve alt komitelere katılan herkesi içerir. Mevcut Ofisler: Denetim Ofisi, Öğrenci İşleri Ofisi, Kültür ve Eğlence Ofisi, Medya Ofisi, Dış İlişkiler Ofisi.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة اسطنبول وجراح باشا": {
    aboutDescription: {
      ar: 'اتحاد طلابي مستقل يمثل الطلاب السوريين في جامعتي اسطنبول واسطنبول جراح باشا، ويستمد قراراته وشرعيته من الطلاب المنتسبين إليه. يعتبر الناطق الرسمي باسم الطلبة السوريين المنخرطين فيه إزاء القضايا التي تهمهم.',
      en: 'An independent student union representing Syrian students at Istanbul University and Istanbul Cerrahpasa University, deriving its decisions and legitimacy from affiliated students. It is considered the official spokesperson for enrolled Syrian students regarding issues that concern them.',
      tr: 'İstanbul Üniversitesi ve İstanbul Cerrahpaşa Üniversitesi\'ndeki Suriyeli öğrencileri temsil eden, kararlarını ve meşruiyetini bağlı öğrencilerden alan bağımsız bir öğrenci birliği. İçindeki Suriyeli öğrencilerin onları ilgilendiren konularda resmi sözcüsü olarak kabul edilir.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة اسطنبول وجراح باشا - اتحاد طلابي مستقل يمثل الطلاب السوريين.',
      en: 'Syrian Students Union at Istanbul University and Cerrahpasa - An independent student union representing Syrian students.',
      tr: 'İstanbul Üniversitesi ve Cerrahpaşa Suriyeli Öğrenci Birliği - Suriyeli öğrencileri temsil eden bağımsız bir öğrenci birliği.'
    },
    contactNumber: {
      ar: '+905394981085 / +905370444148',
      en: '+905394981085 / +905370444148',
      tr: '+905394981085 / +905370444148'
    },
    activitiesAndAchievements: {
      ar: 'شارك الاتحاد في جميع نشاطات الاتحاد العام وكان له أثر فيها. حفل التخرج حيث ضم أكثر من 60 خريج من الاتحاد. مؤتمر ذكرى الثورة السورية "والصبح إذا تنفس". معرض الكتاب في الأربع نسخ الماضية على التوالي. أنشطة ثقافية وترفيهية. حملة دعم الخبز وقت التحرير حيث شارك بجمع أكثر من 20 ألف ليرة تركية.',
      en: 'The union participated in all General Union activities and had an impact in them. Graduation ceremony that included more than 60 graduates from the union. Syrian Revolution anniversary conference "And the Morning When It Breathes". Book Fair in the past four consecutive editions. Cultural and recreational activities. Bread support campaign during liberation days where it participated in collecting more than 20,000 Turkish lira.',
      tr: 'Birlik, Genel Birlik\'in tüm etkinliklerine katıldı ve bunlarda etkisi oldu. Birliğin 60\'tan fazla mezununu içeren mezuniyet töreni. Suriye Devrimi yıldönümü konferansı "Ve Nefes Aldığında Sabah". Son dört ardışık baskıda Kitap Fuarı. Kültürel ve rekreasyon etkinlikleri. Kurtuluş günlerinde 20,000\'den fazla Türk lirası toplamaya katıldığı ekmek destek kampanyası.'
    },
    specialAchievements: {
      ar: 'الإنجاز الأكبر لأي اتحاد هو وجوده على أرض الواقع ودعم جميع الطلاب والسعي وراء متطلباتهم وتوفير الفرص لهم.',
      en: 'The biggest achievement of any union is its existence on the ground and supporting all students and pursuing their requirements and providing opportunities for them.',
      tr: 'Herhangi bir birliğin en büyük başarısı, gerçekte var olması ve tüm öğrencileri desteklemesi, gereksinimlerini takip etmesi ve onlar için fırsatlar sağlamasıdır.'
    },
    currentAdministrativeTeam: {
      ar: 'يتألف من إدارة تضم خمسة مكاتب ورئيس ونائب الرئيس. مكاتب الإدارة: العلاقات العامة، الإعلامي، أمين السر، شؤون الطلبة، الأنشطة. عدد الأعضاء المنتسبين: أكثر من 270 عضو منتسب، ووصول مباشر إلى 500 طالب، والعديد منهم متطوعون.',
      en: 'Consists of an administration that includes five offices, a president, and a vice president. Administration Offices: Public Relations, Media, Secretary General, Student Affairs, Activities. Number of affiliated members: More than 270 affiliated members, direct access to 500 students, and many of them are volunteers.',
      tr: 'Bir başkan, başkan yardımcısı ve beş ofisten oluşan bir yönetimden oluşur. Yönetim Ofisleri: Halkla İlişkiler, Medya, Genel Sekreter, Öğrenci İşleri, Etkinlikler. Bağlı üye sayısı: 270\'ten fazla bağlı üye, 500 öğrenciye doğrudan erişim ve birçoğu gönüllü.'
    },
    notes: {
      ar: 'شكراً لجهودكم.',
      en: 'Thank you for your efforts.',
      tr: 'Çabalarınız için teşekkürler.'
    },
    logo: './assets/subunions/basha-logo.gif'
  },
  "اتحاد الطلبة السوريين في جامعة اسطنبول أيدن": {
    aboutDescription: {
      ar: 'الجالية السورية في جامعة أيدن هي اتحاد طلابي فرعي يُعنى بتمثيل الطلبة السوريين داخل الجامعة. يهدف إلى خلق بيئة طلابية جامعة تسودها روح التعاون والانتماء وتكون صوتاً فاعلاً لطلابها.',
      en: 'The Syrian community at Aydin University is a sub-student union concerned with representing Syrian students within the university. It aims to create a comprehensive student environment characterized by a spirit of cooperation and belonging and to be an active voice for its students.',
      tr: 'Aydın Üniversitesi\'ndeki Suriye topluluğu, üniversite içindeki Suriyeli öğrencileri temsil etmekle ilgilenen bir alt öğrenci birliğidir. İşbirliği ve aidiyet ruhunun hâkim olduğu kapsamlı bir öğrenci ortamı yaratmayı ve öğrencileri için aktif bir ses olmayı amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة اسطنبول أيدن - اتحاد طلابي فرعي يهدف إلى خلق بيئة طلابية جامعة.',
      en: 'Syrian Students Union at Istanbul Aydin University - A sub-student union aiming to create a comprehensive student environment.',
      tr: 'İstanbul Aydın Üniversitesi Suriyeli Öğrenci Birliği - Kapsamlı bir öğrenci ortamı yaratmayı amaçlayan bir alt öğrenci birliği.'
    },
    contactNumber: {
      ar: '+905527225783 / +905356119783',
      en: '+905527225783 / +905356119783',
      tr: '+905527225783 / +905356119783'
    },
    activitiesAndAchievements: {
      ar: 'احتفال الثورة. توزيع الخبز في مدينة حلب. رحلات وأنشطة خاصة لطلاب الجامعة.',
      en: 'Revolution celebration. Bread distribution in Aleppo city. Trips and special activities for university students.',
      tr: 'Devrim kutlaması. Halep şehrinde ekmek dağıtımı. Üniversite öğrencileri için geziler ve özel etkinlikler.'
    },
    specialAchievements: {
      ar: 'لا يوجد',
      en: 'No special achievements.',
      tr: 'Özel başarı yok.'
    },
    currentAdministrativeTeam: {
      ar: '17 طالب موزعين أدوارهم من الرئاسيين إلى مسؤولين الأنشطة.',
      en: '17 students with roles distributed from presidents to activities officers.',
      tr: 'Başkanlardan etkinlik görevlilerine kadar roller dağıtılmış 17 öğrenci.'
    },
    notes: {
      ar: 'تتميز الجالية بروح المبادرة والتعاون، وتسعى لتمثيل الطلاب بأفضل صورة ممكنة. تعمل كمنصة تجمع الطلاب وتمنحهم الفرصة للتعبير عن أفكارهم.',
      en: 'The community is characterized by a spirit of initiative and cooperation, and seeks to represent students in the best possible way. It works as a platform that brings students together and gives them the opportunity to express their ideas.',
      tr: 'Topluluk, girişimcilik ve işbirliği ruhuyla karakterize edilir ve öğrencileri mümkün olan en iyi şekilde temsil etmeye çalışır. Öğrencileri bir araya getiren ve onlara fikirlerini ifade etme fırsatı veren bir platform olarak çalışır.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة كولتور": {
    aboutDescription: {
      ar: 'يتضمن أهدافاً مثل تمثيل الطلبة السوريين والدفاع عن حقوقهم، وتعزيز الهوية الوطنية والثورية، ودعم الاندماج الأكاديمي والثقافي، والعمل النقابي المؤسسي والتطوعي، وتعزيز قيم الشفافية والنزاهة والمسؤولية، والاستقلالية عن الأجندات الخارجية، وتعزيز روح الاحترام والتنوع، والتفاعل مع قضايا الوطن والأمة.',
      en: 'It includes objectives such as representing Syrian students and defending their rights, strengthening national and revolutionary identity, supporting academic and cultural integration, institutional and volunteer union work, promoting values of transparency, integrity and responsibility, independence from external agendas, strengthening the spirit of respect and diversity, and interacting with homeland and nation issues.',
      tr: 'Suriyeli öğrencileri temsil etmek ve haklarını savunmak, ulusal ve devrimci kimliği güçlendirmek, akademik ve kültürel entegrasyonu desteklemek, kurumsal ve gönüllü sendika çalışması, şeffaflık, dürüstlük ve sorumluluk değerlerini teşvik etmek, dış gündemlerden bağımsızlık, saygı ve çeşitlilik ruhunu güçlendirmek ve vatan ve millet meseleleriyle etkileşim gibi hedefleri içerir.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة كولتور - تمثيل الطلبة والدفاع عن حقوقهم وتعزيز الهوية الوطنية.',
      en: 'Syrian Students Union at Culture University - Representing students and defending their rights and strengthening national identity.',
      tr: 'Kültür Üniversitesi Suriyeli Öğrenci Birliği - Öğrencileri temsil etmek, haklarını savunmak ve ulusal kimliği güçlendirmek.'
    },
    contactNumber: {
      ar: '05362257783',
      en: '05362257783',
      tr: '05362257783'
    },
    activitiesAndAchievements: {
      ar: 'احتفال النصر (دورة 2025). بطولة شطرنج في الجامعة (في دورة 2025). مشاركة في معرض الكتاب بجناح رواق الطلبة والشباب (في دورة 2025 ودورة 2026). ورشة أساسيات التصوير الصحفي باستعمال الهاتف (في دورة 2026).',
      en: 'Victory celebration (2025 session). Chess championship at the university (2025 session). Participation in the Book Fair at the Students and Youth Pavilion (2025 and 2026 sessions). Workshop on basics of photojournalism using mobile phones (2026 session).',
      tr: 'Zafer kutlaması (2025 oturumu). Üniversitede satranç şampiyonası (2025 oturumu). Öğrenci ve Gençlik Pavyonu\'nda Kitap Fuarı\'na katılım (2025 ve 2026 oturumları). Mobil telefon kullanarak fotoğrafçılığın temelleri atölyesi (2026 oturumu).'
    },
    specialAchievements: {
      ar: 'ورشة أساسيات التصوير الصحفي باستعمال الهاتف نفذت خلال دورة (2026)، والتي لاقت تفاعلاً كبيراً.',
      en: 'Workshop on basics of photojournalism using mobile phones implemented during the 2026 session, which received great interaction.',
      tr: '2026 oturumu sırasında uygulanan ve büyük ilgi gören mobil telefon kullanarak fotoğrafçılığın temelleri atölyesi.'
    },
    currentAdministrativeTeam: {
      ar: 'مجلس الإدارة يتكون من خمسة أشخاص وهم مسؤولو المكاتب. كل مسؤول يكون فريقاً للمكتب، ويتم تقسيم المهام على الأعضاء. المكاتب: أمين السر، مكتب الإعلام، مكتب الأنشطة، مكتب العلاقات، مكتب شؤون الطلبة. عدد الأعضاء المنتسبين: 102 شخص.',
      en: 'The board of directors consists of five people who are office heads. Each head forms a team for the office, and tasks are distributed among members. Offices: Secretary General, Media Office, Activities Office, Relations Office, Student Affairs Office. Number of affiliated members: 102 people.',
      tr: 'Yönetim kurulu, ofis başkanları olan beş kişiden oluşur. Her başkan ofis için bir ekip oluşturur ve görevler üyeler arasında dağıtılır. Ofisler: Genel Sekreter, Medya Ofisi, Etkinlikler Ofisi, İlişkiler Ofisi, Öğrenci İşleri Ofisi. Bağlı üye sayısı: 102 kişi.'
    },
    notes: {
      ar: 'الاتحاد هو مساحة مفتوحة للتجريب والأفكار الجديدة، نؤمن أن العمل الطلابي لا يجب أن يكرر نفسه، بل أن يُفاجئ، يلهم، ويبتكر حلولاً من داخل البيئة الجامعية نفسها.',
      en: 'The union is an open space for experimentation and new ideas, we believe that student work should not repeat itself, but should surprise, inspire, and innovate solutions from within the university environment itself.',
      tr: 'Birlik, deney ve yeni fikirler için açık bir alandır, öğrenci çalışmasının kendini tekrarlamaması, ancak üniversite ortamının kendisinden çözümler yaratması, ilham vermesi ve yenilik yapması gerektiğine inanıyoruz.'
    },
    logo: './assets/subunions/kultur-logo.png'
  },
  "اتحاد الطلبة السوريين في جامعة التن بش": {
    aboutDescription: {
      ar: 'جاء تأسيسه استجابة لحاجة حقيقية لبناء مجتمع متماسك يجمع نخبة من أصحاب الخبرة في العمل الطلابي والتطوعي. يهدف إلى إحداث نقلة نوعية في مفهوم الاتحادات الطلابية على مستوى تركيا، وتوحيد صوت الطلبة السوريين داخل وخارج الجامعة.',
      en: 'Its establishment came in response to a real need to build a cohesive community that brings together an elite group of experienced people in student and volunteer work. It aims to bring about a qualitative shift in the concept of student unions at the level of Turkey, and to unify the voice of Syrian students inside and outside the university.',
      tr: 'Kuruluşu, öğrenci ve gönüllü çalışmalarda deneyimli bir seçkin grubu bir araya getiren uyumlu bir topluluk oluşturma ihtiyacına yanıt olarak geldi. Türkiye düzeyinde öğrenci birlikleri kavramında niteliksel bir değişim yaratmayı ve üniversite içinde ve dışında Suriyeli öğrencilerin sesini birleştirmeyi amaçlamaktadır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة التن بش - يهدف إلى إحداث نقلة نوعية في مفهوم الاتحادات الطلابية.',
      en: 'Syrian Students Union at Tanbash University - Aims to bring about a qualitative shift in the concept of student unions.',
      tr: 'Tanbash Üniversitesi Suriyeli Öğrenci Birliği - Öğrenci birlikleri kavramında niteliksel bir değişim yaratmayı amaçlar.'
    },
    contactNumber: {
      ar: '05495501618',
      en: '05495501618',
      tr: '05495501618'
    },
    activitiesAndAchievements: {
      ar: 'صهاريج مياه لقطاع غزة. توزيع مساعدات في قطاع غزة. حملة إسعاد اليتيم في عيد الأضحى. تنظيم نهائي بطولة المناظرات. حملة إفطار الصائم. تقديم حفل تخرج دفعة النصر. تجمع معرض الكتاب.',
      en: 'Water tanks for Gaza Strip. Aid distribution in Gaza Strip. Orphan happiness campaign on Eid al-Adha. Organizing the debate championship final. Iftar campaign. Graduation ceremony for Al-Nasr batch. Book fair gathering.',
      tr: 'Gazze Şeridi için su tankları. Gazze Şeridi\'nde yardım dağıtımı. Kurban Bayramı\'nda yetim mutluluk kampanyası. Münazara şampiyonası finalini düzenlemek. İftar kampanyası. El-Nasr grubu mezuniyet töreni. Kitap fuarı buluşması.'
    },
    specialAchievements: {
      ar: 'توحيد صفوف اتحادات السوريين على مستوى اسطنبول والعمل ككيان موحد.',
      en: 'Unifying the ranks of Syrian unions at the level of Istanbul and working as a unified entity.',
      tr: 'İstanbul düzeyinde Suriyeli birliklerin saflarını birleştirmek ve birleşik bir varlık olarak çalışmak.'
    },
    currentAdministrativeTeam: {
      ar: 'فريق الإدارة مكون من 15 عضو بينهم رئيس ونائب رئيس ومدير تنفيذي ورؤساء أفرع (كامبوسات الجامعة المختلفة ورؤساء أقسام: ميديا، علاقات، فعاليات، محاسبة). ويندرج تحت كل غرفة ثلة من الأعضاء.',
      en: 'The management team consists of 15 members including a president, vice president, executive director, and branch heads (different university campuses and department heads: media, relations, events, accounting). Under each department there is a group of members.',
      tr: 'Yönetim ekibi, başkan, başkan yardımcısı, genel müdür ve şube başkanları (farklı üniversite kampüsleri ve bölüm başkanları: medya, ilişkiler, etkinlikler, muhasebe) dahil olmak üzere 15 üyeden oluşmaktadır. Her bölüm altında bir grup üye bulunmaktadır.'
    },
    notes: {
      ar: 'يتميز الاتحاد بانطلاقة قوية على مستوى الاتحادات ونسق تصاعدي عالي الوتيرة وكمية إنجازات كثيرة في وقت قصير بفضل الطاقم الموجود ذو الهمة العالية والرؤية الإبداعية.',
      en: 'The union is distinguished by a strong start at the level of unions, a high-paced ascending pattern, and a large number of achievements in a short time thanks to the existing team with high motivation and creative vision.',
      tr: 'Birlik, birlikler düzeyinde güçlü bir başlangıç, yüksek tempolu yükselen bir düzen ve yüksek motivasyonlu ve yaratıcı vizyona sahip mevcut ekip sayesinde kısa sürede çok sayıda başarı ile ayırt edilir.'
    },
    logo: './assets/subunions/altinbas-logo.png'
  },
  "اتحاد باشاك شيهير": {
    aboutDescription: {
      ar: 'اتحاد باشاك شيهير يخدم الطلبة السوريين في منطقة باشاك شيهير بإسطنبول. يتميز الاتحاد بتركيزه على التميز الأكاديمي والأنشطة الثقافية المتنوعة. ينظم الاتحاد مؤتمرات وندوات علمية، وورش عمل متخصصة، وفعاليات ثقافية وترفيهية.',
      en: 'Basaksehir Union serves Syrian students in the Basaksehir district of Istanbul. The union is distinguished by its focus on academic excellence and diverse cultural activities. The union organizes scientific conferences and seminars, specialized workshops, and cultural and recreational events.',
      tr: 'Başakşehir Birliği, İstanbul\'un Başakşehir ilçesindeki Suriyeli öğrencilere hizmet verir. Birlik, akademik mükemmelliğe ve çeşitli kültürel etkinliklere odaklanmasıyla öne çıkar. Birlik, bilimsel konferanslar ve seminerler, uzmanlaşmış atölye çalışmaları ve kültürel ve rekreasyon etkinlikleri düzenler.'
    },
    cardDescription: {
      ar: 'اتحاد في منطقة باشاك شيهير يركز على التميز الأكاديمي والأنشطة الثقافية.',
      en: 'A union in Basaksehir district focusing on academic excellence and cultural activities.',
      tr: 'Başakşehir ilçesindeki akademik mükemmellik ve kültürel etkinliklere odaklanan bir birlik.'
    },
    contactNumber: {
      ar: '+90 312 XXX XXXX',
      en: '+90 312 XXX XXXX',
      tr: '+90 312 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمرات وندوات علمية، برامج تدريبية في المهارات القيادية، ورش عمل في ريادة الأعمال، خدمات التوجيه والإرشاد.',
      en: 'Scientific conferences and seminars, leadership skills training programs, entrepreneurship workshops, orientation and guidance services.',
      tr: 'Bilimsel konferanslar ve seminerler, liderlik becerileri eğitim programları, girişimcilik atölye çalışmaları, oryantasyon ve rehberlik hizmetleri.'
    },
    specialAchievements: {
      ar: 'تنظيم مؤتمر قيادة طلابي دولي، إطلاق برنامج ريادة الأعمال، فوز بجائزة التميز في القيادة.',
      en: 'Organizing an international student leadership conference, launching an entrepreneurship program, winning Leadership Excellence Award.',
      tr: 'Uluslararası öğrenci liderliği konferansı düzenlemek, girişimcilik programı başlatmak, Liderlik Mükemmellik Ödülü kazanmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: خالد محمود، نائب الرئيس: سمر علي، أمين السر: طارق يوسف، أمين الصندوق: ناديا حسن.',
      en: 'President: Khaled Mahmoud, Vice President: Samar Ali, Secretary: Tariq Youssef, Treasurer: Nadia Hassan.',
      tr: 'Başkan: Khaled Mahmoud, Başkan Yardımcısı: Samar Ali, Sekreter: Tariq Youssef, Sayman: Nadia Hassan.'
    },
    notes: {
      ar: 'الاتحاد رائد في مجال القيادة الطلابية وريادة الأعمال. يقدم برامج متميزة للطلاب الطموحين.',
      en: 'The union is a leader in student leadership and entrepreneurship. Provides outstanding programs for ambitious students.',
      tr: 'Birlik, öğrenci liderliği ve girişimcilik alanında öncüdür. Hırslı öğrenciler için seçkin programlar sunar.'
    },
    logo: ''
  },
  "فريق غراس الحرية - في جامعة اسطنبول مدنيات": {
    aboutDescription: {
      ar: 'أسس عام 2020 بمبادرة رائدة من طالبات طموحات. يهدف الفريق إلى دعم الطلبة السوريين الأحرار، وتهيئة بيئة جامعية تعزز التواصل وتقوي العلاقات فيما بينهم.',
      en: 'Founded in 2020 through a pioneering initiative by ambitious female students. The team aims to support free Syrian students, and create a university environment that enhances communication and strengthens relationships among them.',
      tr: '2020 yılında hırslı kadın öğrenciler tarafından öncü bir girişimle kuruldu. Ekip, özgür Suriyeli öğrencileri desteklemeyi ve aralarında iletişimi geliştiren ve ilişkileri güçlendiren bir üniversite ortamı yaratmayı amaçlar.'
    },
    cardDescription: {
      ar: 'فريق غراس الحرية - في جامعة اسطنبول مدنيات: أسس عام 2020 ويهدف إلى دعم الطلبة السوريين الأحرار.',
      en: 'Grass of Freedom Team - at Istanbul Medeniyet University: Founded in 2020, aims to support free Syrian students.',
      tr: 'Özgürlük Çimeni Ekibi - İstanbul Medeniyet Üniversitesi: 2020 yılında kuruldu, özgür Suriyeli öğrencileri desteklemeyi amaçlar.'
    },
    contactNumber: {
      ar: '05346098452',
      en: '05346098452',
      tr: '05346098452'
    },
    activitiesAndAchievements: {
      ar: 'مشاركة الفريق في نشاطات اليوم الثقافي لجامعة اسطنبول مدنيات. مشاركات في معرض الكتاب في جناح رواق الطلبة في دورته الـ 2023-2024-2025. الملتقى الرمضاني الذي أقيم بالتعاون مع اتحاد جيلشم.',
      en: 'Team participation in Istanbul Medeniyet University Culture Day activities. Participation in the Book Fair in the Student Pavilion in its 2023-2024-2025 edition. Ramadan gathering held in cooperation with Jilsham Union.',
      tr: 'İstanbul Medeniyet Üniversitesi Kültür Günü etkinliklerine ekip katılımı. 2023-2024-2025 baskısında Öğrenci Pavyonu\'ndaki Kitap Fuarı\'na katılım. Jilsham Birliği ile işbirliği içinde düzenlenen Ramazan buluşması.'
    },
    specialAchievements: {
      ar: 'تنظيم فعاليات طلابية ساهمت في تعزيز التواصل بين الطلبة، وتقديم مبادرات تهدف إلى خدمة المجتمع الجامعي.',
      en: 'Organizing student events that contributed to enhancing communication among students, and presenting initiatives aimed at serving the university community.',
      tr: 'Öğrenciler arasındaki iletişimi geliştirmeye katkıda bulunan öğrenci etkinlikleri düzenlemek ve üniversite toplumuna hizmet etmeyi amaçlayan girişimler sunmak.'
    },
    currentAdministrativeTeam: {
      ar: 'مسؤول القسم الثقافي. مسؤول الإعلام. مسؤول الأنشطة. مسؤول العلاقات العامة.',
      en: 'Cultural Section Officer. Media Officer. Activities Officer. Public Relations Officer.',
      tr: 'Kültür Bölümü Görevlisi. Medya Görevlisi. Etkinlikler Görevlisi. Halkla İlişkiler Görevlisi.'
    },
    notes: {
      ar: 'يحرص الفريق على أن يكون مساحة تمثيلية حقيقية للطلبة تعكس تطلعاتهم وتدافع عن قضاياهم اليومية.',
      en: 'The team is keen to be a true representative space for students that reflects their aspirations and defends their daily issues.',
      tr: 'Ekip, öğrencilerin beklentilerini yansıtan ve günlük sorunlarını savunan gerçek bir temsil alanı olmaya özen gösterir.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة صباح الدين زعيم": {
    aboutDescription: {
      ar: 'كيان طلابي سوري غير تابع لأي جهة رسمية، يمثل الطلاب السوريين الموجودين في الجامعة، ويتمتع بالاستقلال النظامي والمالي ويستمد قراراته من القاعدة الطلابية. حصل على الاعتراف الرسمي من إدارة الجامعة على أنه الممثل الوحيد للجالية السورية في بداية سنة 2022.',
      en: 'A Syrian student entity not affiliated with any official body, representing Syrian students present at the university, enjoying administrative and financial independence and deriving its decisions from the student base. It obtained official recognition from the university administration as the sole representative of the Syrian community at the beginning of 2022.',
      tr: 'Herhangi bir resmi kuruma bağlı olmayan, üniversitedeki Suriyeli öğrencileri temsil eden, idari ve mali bağımsızlığa sahip ve kararlarını öğrenci tabanından alan Suriyeli bir öğrenci varlığı. 2022 yılının başında üniversite yönetiminden Suriye toplumunun tek temsilcisi olarak resmi tanınma aldı.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة صباح الدين زعيم - كيان طلابي مستقل يمثل الطلاب السوريين.',
      en: 'Syrian Students Union at Sabahattin Zaim University - An independent student entity representing Syrian students.',
      tr: 'Sabahattin Zaim Üniversitesi Suriyeli Öğrenci Birliği - Suriyeli öğrencileri temsil eden bağımsız bir öğrenci varlığı.'
    },
    contactNumber: {
      ar: '05074343482',
      en: '05074343482',
      tr: '05074343482'
    },
    activitiesAndAchievements: {
      ar: 'فعالية الوعد الحق، ذاكرة.',
      en: 'Al-Wa\'d Al-Haqq event, Memory.',
      tr: 'Al-Wa\'d Al-Haqq etkinliği, Hafıza.'
    },
    specialAchievements: {
      ar: 'استمرارية الاتحاد كل عام على نفس السوية من التنظيم والعطاء.',
      en: 'The union\'s continuity every year at the same level of organization and giving.',
      tr: 'Birliğin her yıl aynı organizasyon ve hizmet seviyesinde devamlılığı.'
    },
    currentAdministrativeTeam: {
      ar: 'هيكلية الاتحاد تتكون من رئيس ونائب وأربعة مكاتب تنفيذية. المكاتب التنفيذية: المكتب الإعلامي، مكتب الشؤون، المكتب الأكاديمي، مكتب الأنشطة.',
      en: 'The union structure consists of a president, vice president, and four executive offices. Executive Offices: Media Office, Affairs Office, Academic Office, Activities Office.',
      tr: 'Birlik yapısı bir başkan, başkan yardımcısı ve dört yürütme ofisinden oluşur. Yürütme Ofisleri: Medya Ofisi, İşler Ofisi, Akademik Ofis, Etkinlikler Ofisi.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: './assets/subunions/rumi-logo.png'
  },
  "اتحاد نيشَان ناشي": {
    aboutDescription: {
      ar: 'رسالتنا "الاتحاد قوة والتفرق ضعف".',
      en: 'Our message: "Unity is strength and division is weakness."',
      tr: 'Mesajımız: "Birlik güçtür ve ayrılık zayıflıktır."'
    },
    cardDescription: {
      ar: 'اتحاد نيشَان ناشي - رسالتنا "الاتحاد قوة والتفرق ضعف".',
      en: 'Nishan Nashi Union - Our message: "Unity is strength and division is weakness."',
      tr: 'Nişan Naşi Birliği - Mesajımız: "Birlik güçtür ve ayrılık zayıflıktır."'
    },
    contactNumber: {
      ar: '05052535994',
      en: '05052535994',
      tr: '05052535994'
    },
    activitiesAndAchievements: {
      ar: 'مبادرة إفطار الصائم. رحلة إلى الشاطئ للطالبات. رحلة إلى الغابة الفاتح. كورس مخفض للطلاب في التصميم. إفطار نادي الطالبات. أخرى.',
      en: 'Iftar for fasting initiative. Beach trip for female students. Fatih Forest trip. Discounted design course for students. Female students club Iftar. Others.',
      tr: 'Oruçlular için iftar girişimi. Kız öğrenciler için plaj gezisi. Fatih Orman gezisi. Öğrenciler için indirimli tasarım kursu. Kız öğrenci kulübü iftarı. Diğerleri.'
    },
    specialAchievements: {
      ar: 'لا يوجد',
      en: 'No special achievements.',
      tr: 'Özel başarı yok.'
    },
    currentAdministrativeTeam: {
      ar: 'رئيس الاتحاد: زهران بيسواني. مكتب العلاقات العامة: أمجد محمد. مدير المكتب الترفيهي: عبد الرحمن جابرا. أمين السر: عماد الدين دعاس. مكتب المالية: هالا اليوسف. مدير المكتب الإعلامي: بلال عبود.',
      en: 'Union President: Zuhran Biswani. Public Relations Office: Amjad Mohammed. Entertainment Office Director: Abdul Rahman Jabara. Secretary: Imad Al-Din Daas. Financial Office: Hala Al-Youssef. Media Office Director: Bilal Abboud.',
      tr: 'Birlik Başkanı: Zuhran Biswani. Halkla İlişkiler Ofisi: Amjad Mohammed. Eğlence Ofisi Müdürü: Abdul Rahman Jabara. Sekreter: Imad Al-Din Daas. Mali Ofis: Hala Al-Youssef. Medya Ofisi Müdürü: Bilal Abboud.'
    },
    notes: {
      ar: 'لا',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/nisantasi-logo.png'
  },
  "تجمع الطلبة السوريين في جامعة يلدز": {
    aboutDescription: {
      ar: 'الرؤية نحو مجتمع طلابي سوري يبني الوطن ويحفظ القيم. الأهداف: ضم الطلاب السوريين وتوحيد جهودهم لخدمة الجالية الجامعية، تمثيل الطلاب السوريين أمام الجامعة والجهات الرسمية والرأي العام، تنظيم أنشطة ثقافية واجتماعية وأكاديمية، بناء شراكات مع اتحادات سورية وعربية وجمعيات ومؤسسات، تنمية الحس الوطني والخدمي وشعور الانتماء لدى الطلبة.',
      en: 'Vision towards a Syrian student community that builds the homeland and preserves values. Objectives: bringing together Syrian students and unifying their efforts to serve the university community, representing Syrian students before the university, official bodies and public opinion, organizing cultural, social and academic activities, building partnerships with Syrian and Arab unions, associations and institutions, developing national and service awareness and sense of belonging among students.',
      tr: 'Vatanı inşa eden ve değerleri koruyan Suriyeli bir öğrenci topluluğuna doğru vizyon. Hedefler: Suriyeli öğrencileri bir araya getirmek ve çabalarını üniversite toplumuna hizmet etmek için birleştirmek, Suriyeli öğrencileri üniversite, resmi kurumlar ve kamuoyu önünde temsil etmek, kültürel, sosyal ve akademik etkinlikler düzenlemek, Suriyeli ve Arap birlikleri, dernekler ve kurumlarla ortaklıklar kurmak, öğrenciler arasında ulusal ve hizmet bilincini ve aidiyet duygusunu geliştirmek.'
    },
    cardDescription: {
      ar: 'تجمع الطلبة السوريين في جامعة يلدز - الرؤية نحو مجتمع طلابي سوري يبني الوطن ويحفظ القيم.',
      en: 'Syrian Students Gathering at Yildiz University - Vision towards a Syrian student community that builds the homeland and preserves values.',
      tr: 'Yıldız Üniversitesi\'ndeki Suriyeli Öğrenci Topluluğu - Vatanı inşa eden ve değerleri koruyan Suriyeli bir öğrenci topluluğuna doğru vizyon.'
    },
    contactNumber: {
      ar: '05340695031 (مصطفى عبسي رئيس التجمع)',
      en: '05340695031 (Mustafa Absi, Gathering President)',
      tr: '05340695031 (Mustafa Absi, Topluluk Başkanı)'
    },
    activitiesAndAchievements: {
      ar: 'تحلاية النصر. لقاء د. عمار السواح. لقاء د. باسل البيطار. اليوم الثقافي 2025. عرض فيلم For Sama في الجامعة.',
      en: 'Victory celebration. Meeting with Dr. Ammar Al-Sawah. Meeting with Dr. Basel Al-Bitar. Culture Day 2025. Screening of For Sama film at the university.',
      tr: 'Zafer kutlaması. Dr. Ammar Al-Sawah ile buluşma. Dr. Basel Al-Bitar ile buluşma. Kültür Günü 2025. Üniversitede For Sama filminin gösterimi.'
    },
    specialAchievements: {
      ar: 'استقبال رسالة مرئية من مخرجة فيلم For Sama وعد الخطيب وعرضها مباشرة بعد الفيلم.',
      en: 'Receiving a video message from For Sama film director Waad Al-Kateab and showing it immediately after the film.',
      tr: 'For Sama filminin yönetmeni Waad Al-Kateab\'dan video mesaj almak ve filmin hemen ardından göstermek.'
    },
    currentAdministrativeTeam: {
      ar: 'يتكون من رئيس ونائب وثلاث رؤساء فرق (الأنشطة، الإعلام، شؤون الطلبة) بالإضافة إلى ثلاث رؤساء مكاتب (الأرشيف والمتابعة، المالي، العلاقات).',
      en: 'Consists of a president and vice president and three team heads (Activities, Media, Student Affairs) in addition to three office heads (Archive and Follow-up, Financial, Relations).',
      tr: 'Bir başkan ve başkan yardımcısı ve üç ekip başkanından (Etkinlikler, Medya, Öğrenci İşleri) oluşur, ayrıca üç ofis başkanı (Arşiv ve Takip, Mali, İlişkiler).'
    },
    notes: {
      ar: 'تجمع يلدز واحد من أحدث التجمعات الطلابية السورية في تركيا ولكنه أثبت وجوده منذ البداية.',
      en: 'Yildiz Gathering is one of the newest Syrian student gatherings in Turkey but it has proven its presence from the beginning.',
      tr: 'Yıldız Topluluğu, Türkiye\'deki en yeni Suriyeli öğrenci topluluklarından biri ancak varlığını baştan beri kanıtlamıştır.'
    },
    logo: './assets/subunions/yildiz-logo.png	'
  },
  "اتحاد أريل": {
    aboutDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة أريل (SSU AREL) هو اتحاد طلابي فرعي يضم الطلبة السوريين الدارسين في İstanbul Arel Üniversitesi. يهدف إلى تمثيل الطلبة والمساعدة على اندماجهم الاجتماعي والأكاديمي، وتنظيم أنشطة ثقافية واجتماعية وخدمية تخدم احتياجات الطلاب.',
      en: 'Syrian Students Union at Arel University (SSU AREL) is a sub-student union that includes Syrian students studying at Istanbul Arel University. It aims to represent students and help their social and academic integration, and organize cultural, social, and service activities that serve students\' needs.',
      tr: 'Arel Üniversitesi Suriyeli Öğrenci Birliği (SSU AREL), İstanbul Arel Üniversitesi\'nde okuyan Suriyeli öğrencileri içeren bir alt öğrenci birliğidir. Öğrencileri temsil etmeyi ve sosyal ve akademik entegrasyonlarına yardımcı olmayı ve öğrencilerin ihtiyaçlarına hizmet eden kültürel, sosyal ve hizmet etkinliklerini organize etmeyi amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد أريل - اتحاد الطلبة السوريين في جامعة أريل يهدف إلى تمثيل الطلبة ومساعدتهم على الاندماج.',
      en: 'Arel Union - Syrian Students Union at Arel University aiming to represent students and help their integration.',
      tr: 'Arel Birliği - Arel Üniversitesi Suriyeli Öğrenci Birliği, öğrencileri temsil etmeyi ve entegrasyonlarına yardımcı olmayı amaçlar.'
    },
    contactNumber: {
      ar: '',
      en: '',
      tr: ''
    },
    activitiesAndAchievements: {
      ar: 'تنظيم فعاليات ثقافية ومشاركات في معارض مثل ركن الاتحاد في معرض الكتاب. أنشطة إفطار جماعي خلال رمضان. جلسات حوارية للطلاب.',
      en: 'Organizing cultural events and participation in exhibitions such as the union\'s booth at the Book Fair. Collective Iftar activities during Ramadan. Dialogue sessions for students.',
      tr: 'Kültürel etkinlikler düzenlemek ve Kitap Fuarı\'ndaki birliğin standı gibi sergilere katılım. Ramazan ayı boyunca toplu İftar etkinlikleri. Öğrenciler için diyalog oturumları.'
    },
    specialAchievements: {
      ar: 'مشاركة اتحاد الطلبة السوريين في معرض إسطنبول الدولي للكتاب العربي. اليوم الثقافي للطلبة السوريين في جامعة أريل (حدث طلابي مستقل بتنظيم كامل من الاتحاد).',
      en: 'Participation of Syrian Students Union in Istanbul International Arabic Book Fair. Syrian Students Cultural Day at Arel University (an independent student event fully organized by the union).',
      tr: 'Suriyeli Öğrenci Birliği\'nin İstanbul Uluslararası Arap Kitap Fuarı\'na katılımı. Arel Üniversitesi\'nde Suriyeli Öğrenciler Kültür Günü (birliğin tam organizasyonuyla bağımsız bir öğrenci etkinliği).'
    },
    currentAdministrativeTeam: {
      ar: 'الهيكل: الرئيس ونائب الرئيس، مكتب الأنشطة، مكتب للعلاقات، مكتب شؤون الطلبة.',
      en: 'Structure: President and Vice President, Activities Office, Relations Office, Student Affairs Office.',
      tr: 'Yapı: Başkan ve Başkan Yardımcısı, Etkinlikler Ofisi, İlişkiler Ofisi, Öğrenci İşleri Ofisi.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة البيروني": {
    aboutDescription: {
      ar: 'اتحاد يقوم على توفير بيئة للطلاب المسلمين السوريين ويدعمهم من كل النواحي. تأسس في رمضان السنة الماضية وحقق العديد من الفعاليات والأهداف.',
      en: 'A union that provides an environment for Syrian Muslim students and supports them in all aspects. It was established in Ramadan last year and has achieved many activities and goals.',
      tr: 'Suriyeli Müslüman öğrenciler için bir ortam sağlayan ve onları her yönden destekleyen bir birlik. Geçen yıl Ramazan ayında kuruldu ve birçok faaliyet ve hedef gerçekleştirdi.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة البيروني - يوفر بيئة داعمة للطلاب المسلمين السوريين.',
      en: 'Syrian Students Union at Al-Biruni University - Provides a supportive environment for Syrian Muslim students.',
      tr: 'El-Biruni Üniversitesi Suriyeli Öğrenci Birliği - Suriyeli Müslüman öğrenciler için destekleyici bir ortam sağlar.'
    },
    contactNumber: {
      ar: '+905528608178',
      en: '+905528608178',
      tr: '+905528608178'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمر لنكن. مؤتمر اغتنم. المشاركة في اليوم الدولي. فعاليات العيد وعامة أخرى.',
      en: 'Lankun Conference. Ightanam Conference. Participation in International Day. Eid celebrations and other general events.',
      tr: 'Lankun Konferansı. Ightanam Konferansı. Uluslararası Gün\'e katılım. Bayram etkinlikleri ve diğer genel etkinlikler.'
    },
    specialAchievements: {
      ar: 'مؤتمر لنكن ومؤتمر اغتنم.',
      en: 'Lankun Conference and Ightanam Conference.',
      tr: 'Lankun Konferansı ve Ightanam Konferansı.'
    },
    currentAdministrativeTeam: {
      ar: 'الكادر مكون من 21 متطوع، 5 لجان، و 5 إداريين.',
      en: 'The team consists of 21 volunteers, 5 committees, and 5 administrators.',
      tr: 'Ekip 21 gönüllü, 5 komite ve 5 yöneticiden oluşmaktadır.'
    },
    notes: {
      ar: 'بهويتنا الإسلامية وبجهودنا سنحقق متطلبات مسمى الأمة العربية الإسلامية.',
      en: 'With our Islamic identity and our efforts, we will achieve the requirements of the name of the Arab Islamic nation.',
      tr: 'İslami kimliğimiz ve çabalarımızla Arap İslam milletinin adının gerekliliklerini gerçekleştireceğiz.'
    },
    logo: './assets/subunions/biruni-logo.png'
  },
  "اتحاد الطلبة السوريين في جامعة إستينيا": {
    aboutDescription: {
      ar: 'هيئة طلابية تُعنى بتمثيل الطلبة السوريين ودعمهم أكاديميا واجتماعيا وثقافيا. يرتكز عمل الاتحاد على تعزيز روح الانتماء والعمل الجماعي، وتنظيم الفعاليات التي تساهم في تطوير مهاراتهم.',
      en: 'A student body concerned with representing Syrian students and supporting them academically, socially, and culturally. The union\'s work focuses on strengthening the spirit of belonging and teamwork, and organizing events that contribute to developing their skills.',
      tr: 'Suriyeli öğrencileri temsil eden ve onlara akademik, sosyal ve kültürel olarak destek sağlayan bir öğrenci kuruluşu. Birliğin çalışması, aidiyet ve takım çalışması ruhunu güçlendirmeye ve becerilerini geliştirmeye katkıda bulunan etkinlikler düzenlemeye odaklanır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة إستينيا - هيئة طلابية تُعنى بتمثيل الطلبة ودعمهم أكاديميا واجتماعيا وثقافيا.',
      en: 'Syrian Students Union at Istinye University - A student body concerned with representing students and supporting them academically, socially, and culturally.',
      tr: 'İstinye Üniversitesi Suriyeli Öğrenci Birliği - Öğrencileri temsil eden ve onlara akademik, sosyal ve kültürel olarak destek sağlayan bir öğrenci kuruluşu.'
    },
    contactNumber: {
      ar: 'Isusyunion@gmail.com',
      en: 'Isusyunion@gmail.com',
      tr: 'Isusyunion@gmail.com'
    },
    activitiesAndAchievements: {
      ar: 'تمثيل الجمهورية العربية السورية في اليوم العالمي للطالب (International Students\' Day) بجامعة إستينيا. المشاركة في معرض الكتاب الدولي في إسطنبول ممثلين عن الجامعة والاتحاد العام لطلبة سوريا. مشاركة وفوز ممثلي الإتحاد في "هاكاثون الريادة والإبتكار". تنظيم مسابقة Top chef. المشاركة في بطولة دوري الإتحاد العام لكرة القدم. تنظيم مسابقة دوري الألعاب الإلكترونية (FIFA). تنظيم إفطار رمضاني جامع الطلاب جامعة إستينيا. إطلاق حملة خيرية لمساعدة العائلات السورية المحتاجة في سوريا، تضمنت حملة تبرعات وجمع مستلزمات شتوية. إطلاق حملة خيرية بمناسبة العيد بالتعاون مع منظمة سلام شملت توزيع المساعدات والهدايا. المشاركة في تنظيم فعاليات الاتحاد العام لطلبة سوريا (نادي المناظرات، حفل تخرج دفعة النصر).',
      en: 'Representing the Syrian Arab Republic at International Students\' Day at Istinye University. Participation in the International Book Fair in Istanbul representing the university and the General Union of Syrian Students. Participation and victory of union representatives in "Entrepreneurship and Innovation Hackathon". Organizing Top chef competition. Participation in the General Union Football League championship. Organizing Electronic Games League (FIFA) competition. Organizing a Ramadan Iftar gathering for Istinye University students. Launching a charity campaign to help needy Syrian families in Syria, including a donation campaign and collecting winter supplies. Launching a charity campaign on the occasion of Eid in cooperation with Salam organization including distribution of aid and gifts. Participation in organizing events of the General Union of Syrian Students (Debate Club, Al-Nasr batch graduation ceremony).',
      tr: 'İstinye Üniversitesi\'nde Uluslararası Öğrenci Günü\'nde Suriye Arap Cumhuriyeti\'ni temsil etmek. Üniversite ve Suriye Öğrenci Genel Birliği\'ni temsil ederek İstanbul\'daki Uluslararası Kitap Fuarı\'na katılım. Birliğin temsilcilerinin "Girişimcilik ve İnovasyon Hackathon"unda katılımı ve zaferi. Top chef yarışması düzenlemek. Genel Birlik Futbol Ligi şampiyonasına katılım. Elektronik Oyunlar Ligi (FIFA) yarışması düzenlemek. İstinye Üniversitesi öğrencileri için Ramazan İftarı toplantısı düzenlemek. Suriye\'deki ihtiyaç sahibi Suriyeli ailelere yardım etmek için hayır kampanyası başlatmak, bağış kampanyası ve kış malzemeleri toplama dahil. Salam organizasyonu ile işbirliği içinde Bayram vesilesiyle hayır kampanyası başlatmak, yardım ve hediyelerin dağıtılması dahil. Suriye Öğrenci Genel Birliği etkinliklerinin düzenlenmesine katılım (Münazara Kulübü, El-Nasr grubu mezuniyet töreni).'
    },
    specialAchievements: {
      ar: 'الأنشطة التطوعية والخيرية، وتمثيل البلاد في المحافل والمناسبات الرسمية.',
      en: 'Volunteer and charity activities, and representing the country in official forums and occasions.',
      tr: 'Gönüllü ve hayır faaliyetleri ve ülkeyi resmi forumlar ve etkinliklerde temsil etmek.'
    },
    currentAdministrativeTeam: {
      ar: 'الهيكل: اللجنة الرقابية، اللجنة المالية، لجنة التخطيط والتنسيق العام، اللجنة الإعلامية والتوثيقية، اللجنة الخيرية والاجتماعية.',
      en: 'Structure: Supervisory Committee, Financial Committee, Planning and General Coordination Committee, Media and Documentation Committee, Charity and Social Committee.',
      tr: 'Yapı: Denetim Komitesi, Mali Komite, Planlama ve Genel Koordinasyon Komitesi, Medya ve Dokümantasyon Komitesi, Hayır ve Sosyal Komite.'
    },
    notes: {
      ar: 'يسعى دائما إلى تقديم مبادراته وأنشطته بطريقته الخاصة التي تعبر عن روحه الجماعية، ويولي اهتماماً كبيراً لتجديد الأفكار وتقديم تجربة طلابية مختلفة تجمع بين الإبداع والعمل بروح الفريق.',
      en: 'It always seeks to present its initiatives and activities in its own way that expresses its collective spirit, and pays great attention to renewing ideas and providing a different student experience that combines creativity and teamwork.',
      tr: 'Her zaman kolektif ruhunu ifade eden kendi yolunda girişimlerini ve faaliyetlerini sunmaya çalışır ve fikirleri yenilemeye ve yaratıcılık ve takım çalışmasını birleştiren farklı bir öğrenci deneyimi sunmaya büyük önem verir.'
    },
    logo: './assets/subunions/istenye-logo-2.png'
  },
  "اتحاد الطلبة السوريين في جامعة جيليشيم": {
    aboutDescription: {
      ar: 'تجمع طلابي يسعى إلى تمثيل الطلبة السوريين داخل الجامعة والعمل على خدمة مصالحهم الأكاديمية والاجتماعية والثقافية. رسالته تعزيز روح الانتماء والتعاون ودعم المسيرة التعليمية وتوفير بيئة محفزة على الإبداع والتكامل.',
      en: 'A student gathering that seeks to represent Syrian students within the university and work to serve their academic, social, and cultural interests. Its mission is to strengthen the spirit of belonging and cooperation, support the educational journey, and provide an environment that encourages creativity and integration.',
      tr: 'Üniversite içindeki Suriyeli öğrencileri temsil etmeyi ve akademik, sosyal ve kültürel çıkarlarına hizmet etmeyi amaçlayan bir öğrenci topluluğu. Misyonu, aidiyet ve işbirliği ruhunu güçlendirmek, eğitim yolculuğunu desteklemek ve yaratıcılığı ve entegrasyonu teşvik eden bir ortam sağlamaktır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة جيليشيم - تجمع طلابي يسعى إلى تمثيل الطلبة وخدمة مصالحهم.',
      en: 'Syrian Students Union at Gelisim University - A student gathering seeking to represent students and serve their interests.',
      tr: 'Gelişim Üniversitesi Suriyeli Öğrenci Birliği - Öğrencileri temsil etmeyi ve çıkarlarına hizmet etmeyi amaçlayan bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '+905062940823',
      en: '+905062940823',
      tr: '+905062940823'
    },
    activitiesAndAchievements: {
      ar: 'فعالية ذكرى التحرير (SY): وطنية لإحياء ذكرى تحرير الجولان. فعالية ذكرى الثورة السورية: ثقافية وفنية لإحياء الذكرى. يوم الـ International Day: شارك الاتحاد بجناح تعريفي بالثقافة السورية. إفطار رمضان الجماعي: نظم النسخة الثانية بمشاركة واسعة لتعزيز روح الألفة.',
      en: 'Liberation Anniversary Event (SY): National event to commemorate the liberation of the Golan. Syrian Revolution Anniversary Event: Cultural and artistic event to commemorate the anniversary. International Day: The union participated with an informative booth about Syrian culture. Collective Ramadan Iftar: Organized the second edition with wide participation to strengthen the spirit of camaraderie.',
      tr: 'Kurtuluş Yıldönümü Etkinliği (SY): Golan\'ın kurtuluşunu anmak için ulusal etkinlik. Suriye Devrimi Yıldönümü Etkinliği: Yıldönümünü anmak için kültürel ve sanatsal etkinlik. Uluslararası Gün: Birlik, Suriye kültürü hakkında bilgilendirici bir standla katıldı. Toplu Ramazan İftarı: Dostluk ruhunu güçlendirmek için geniş katılımlı ikinci baskıyı düzenledi.'
    },
    specialAchievements: {
      ar: 'تنظيم إفطار رمضان الجماعي (النسخة الثالثة). المشاركة الفاعلة في اليوم الدولي (International Day). إحياء المناسبات الوطنية.',
      en: 'Organizing the Collective Ramadan Iftar (third edition). Active participation in International Day. Commemorating national occasions.',
      tr: 'Toplu Ramazan İftarı\'nı düzenlemek (üçüncü baskı). Uluslararası Gün\'e aktif katılım. Ulusal günleri anmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الإدارة العامة: 5 أعضاء (الجهة القيادية): رئيس الاتحاد، نائب الرئيس/أمين السر، المسؤول الإعلامي، المسؤول التنفيذي، مسؤول العلاقات العامة، مسؤولة الطالبات. اللجنة الرقابية: 2 عضو، تتولى مراقبة سير العمل الإداري والمالي. المكاتب التنفيذية: 6 مكاتب (الذراع العملي): مكتب الأنشطة، المكتب الثقافي، المكتب الإعلامي، مكتب العلاقات العامة، مكتب الطالبات، مكتب شؤون الطلبة.',
      en: 'General Administration: 5 members (Leadership body): Union President, Vice President/Secretary General, Media Officer, Executive Officer, Public Relations Officer, Female Students Officer. Supervisory Committee: 2 members, responsible for monitoring administrative and financial operations. Executive Offices: 6 offices (Operational arm): Activities Office, Cultural Office, Media Office, Public Relations Office, Female Students Office, Student Affairs Office.',
      tr: 'Genel Yönetim: 5 üye (Liderlik organı): Birlik Başkanı, Başkan Yardımcısı/Genel Sekreter, Medya Görevlisi, Yürütme Görevlisi, Halkla İlişkiler Görevlisi, Kız Öğrenci Görevlisi. Denetim Komitesi: 2 üye, idari ve mali işlemlerin izlenmesinden sorumludur. Yürütme Ofisleri: 6 ofis (Operasyonel kol): Etkinlikler Ofisi, Kültür Ofisi, Medya Ofisi, Halkla İlişkiler Ofisi, Kız Öğrenci Ofisi, Öğrenci İşleri Ofisi.'
    },
    notes: {
      ar: 'رسالة علم وهوية.',
      en: 'Message of knowledge and identity.',
      tr: 'Bilgi ve kimlik mesajı.'
    },
    logo: ''
  },
  "اتحاد باهتشه شيهير": {
    aboutDescription: {
      ar: 'اتحاد باهتشه شيهير يجمع الطلبة السوريين في منطقة باهتشه شيهير بإسطنبول. يعمل الاتحاد على دعم الطلاب أكاديمياً واجتماعياً وثقافياً، من خلال تنظيم ورش العمل والدورات التدريبية والأنشطة المتنوعة. يسعى الاتحاد لخلق بيئة تعليمية محفزة ومجتمع طلابي متماسك.',
      en: 'Bahcesehir Union brings together Syrian students in the Bahcesehir district of Istanbul. The union works to support students academically, socially, and culturally, through organizing workshops, training courses, and various activities. The union strives to create an inspiring educational environment and a cohesive student community.',
      tr: 'Bahçeşehir Birliği, İstanbul\'un Bahçeşehir ilçesindeki Suriyeli öğrencileri bir araya getirir. Birlik, atölye çalışmaları, eğitim kursları ve çeşitli etkinlikler düzenleyerek öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışır. Birlik, ilham verici bir eğitim ortamı ve uyumlu bir öğrenci topluluğu yaratmaya çalışır.'
    },
    cardDescription: {
      ar: 'اتحاد في منطقة باهتشه شيهير يعمل على دعم الطلاب أكاديمياً واجتماعياً وثقافياً.',
      en: 'A union in Bahcesehir district working to support students academically, socially, and culturally.',
      tr: 'Bahçeşehir ilçesindeki öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışan bir birlik.'
    },
    contactNumber: {
      ar: '+90 312 XXX XXXX',
      en: '+90 312 XXX XXXX',
      tr: '+90 312 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمرات وندوات علمية، برامج تدريبية في المهارات القيادية، ورش عمل في ريادة الأعمال، خدمات التوجيه والإرشاد.',
      en: 'Scientific conferences and seminars, leadership skills training programs, entrepreneurship workshops, orientation and guidance services.',
      tr: 'Bilimsel konferanslar ve seminerler, liderlik becerileri eğitim programları, girişimcilik atölye çalışmaları, oryantasyon ve rehberlik hizmetleri.'
    },
    specialAchievements: {
      ar: 'تنظيم مؤتمر قيادة طلابي دولي، إطلاق برنامج ريادة الأعمال، فوز بجائزة التميز في القيادة.',
      en: 'Organizing an international student leadership conference, launching an entrepreneurship program, winning Leadership Excellence Award.',
      tr: 'Uluslararası öğrenci liderliği konferansı düzenlemek, girişimcilik programı başlatmak, Liderlik Mükemmellik Ödülü kazanmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: خالد محمود، نائب الرئيس: سمر علي، أمين السر: طارق يوسف، أمين الصندوق: ناديا حسن.',
      en: 'President: Khaled Mahmoud, Vice President: Samar Ali, Secretary: Tariq Youssef, Treasurer: Nadia Hassan.',
      tr: 'Başkan: Khaled Mahmoud, Başkan Yardımcısı: Samar Ali, Sekreter: Tariq Youssef, Sayman: Nadia Hassan.'
    },
    notes: {
      ar: 'الاتحاد رائد في مجال القيادة الطلابية وريادة الأعمال. يقدم برامج متميزة للطلاب الطموحين.',
      en: 'The union is a leader in student leadership and entrepreneurship. Provides outstanding programs for ambitious students.',
      tr: 'Birlik, öğrenci liderliği ve girişimcilik alanında öncüdür. Hırslı öğrenciler için seçkin programlar sunar.'
    },
    logo: ''
  },
  "اتحاد الطلبة الناطقين باللغة العربية (جامعة العلوم الصحية)": {
    aboutDescription: {
      ar: 'اتحاد تطوعي مستقل يمثل الطلبة الناطقين باللغة العربية في جامعة العلوم الصحية، ويهدف إلى تحقيق مصالحهم الأكاديمية والثقافية.',
      en: 'An independent voluntary union representing Arabic-speaking students at the Health Sciences University, aiming to achieve their academic and cultural interests.',
      tr: 'Sağlık Bilimleri Üniversitesi\'ndeki Arapça konuşan öğrencileri temsil eden, akademik ve kültürel çıkarlarını gerçekleştirmeyi amaçlayan bağımsız gönüllü bir birlik.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة الناطقين باللغة العربية (جامعة العلوم الصحية) - اتحاد تطوعي مستقل يمثل الطلبة الناطقين بالعربية.',
      en: 'Arabic-Speaking Students Union (Health Sciences University) - An independent voluntary union representing Arabic-speaking students.',
      tr: 'Arapça Konuşan Öğrenciler Birliği (Sağlık Bilimleri Üniversitesi) - Arapça konuşan öğrencileri temsil eden bağımsız gönüllü bir birlik.'
    },
    contactNumber: {
      ar: '05525330025 (جود بدران)',
      en: '05525330025 (Joud Badran)',
      tr: '05525330025 (Joud Badran)'
    },
    activitiesAndAchievements: {
      ar: 'إعادة هيكلة الاتحاد. فعالية تحرير سوريتنا. فعالية اليوم العالمي للغة العربية "عبق الضاد". اتفاقية تعاون مع جمعية "باب العالم". فعالية لوحة الأهداف للبنات. بطولة الشطرنج. ترتيب إفطار رمضاني مع الجامعة. اتفاقية تعاون مع منصة "أكاديمي". جلسة تعارفية للبنات "جمعة بنات". الإصدار الثاني من المجلة الإلكترونية "زاد الشباب".',
      en: 'Union restructuring. Liberation of Syria event. World Arabic Language Day event "Fragrance of the Letter Dhad". Cooperation agreement with "Bab Al-Alam" association. Goals board event for girls. Chess tournament. Organizing Ramadan Iftar with the university. Cooperation agreement with "Academic" platform. Girls\' acquaintance session "Girls\' Friday". Second issue of the electronic magazine "Youth Provisions".',
      tr: 'Birlik yeniden yapılandırması. Suriye\'nin kurtuluşu etkinliği. Dünya Arapça Dili Günü etkinliği "Dhad Harfinin Kokusu". "Bab Al-Alam" derneği ile işbirliği anlaşması. Kızlar için hedefler panosu etkinliği. Satranç turnuvası. Üniversite ile Ramazan İftarı düzenlemek. "Academic" platformu ile işbirliği anlaşması. Kızlar tanışma oturumu "Kızlar Cuma". Elektronik dergi "Gençlik Hükümleri"nin ikinci sayısı.'
    },
    specialAchievements: {
      ar: 'إعادة هيكلة الاتحاد والذي ضمن مرجعية تنظيمية لإدارة شؤون الاتحاد وتحقيق أهدافه.',
      en: 'Union restructuring which ensured an organizational reference for managing union affairs and achieving its objectives.',
      tr: 'Birlik işlerini yönetmek ve hedeflerine ulaşmak için organizasyonel bir referans sağlayan birlik yeniden yapılandırması.'
    },
    currentAdministrativeTeam: {
      ar: 'الهيئة العامة: تتألف من جميع أعضاء الاتحاد المسجلين رسمياً. الهيئة الإدارية: (الرئيس، نائب الرئيس، أمين السر، مسؤول العلاقات العامة، مسؤول شؤون اللغة والترجمة، مسؤول الفعاليات والأنشطة، مسؤول الإعلام). الهيئة الرقابية: مسؤولة عن مراقبة أداء الهيئة الإدارية. الهيئة الانتخابية: تشرف على إجراء الانتخابات.',
      en: 'General Assembly: Consists of all officially registered union members. Administrative Body: (President, Vice President, Secretary General, Public Relations Officer, Language and Translation Affairs Officer, Events and Activities Officer, Media Officer). Supervisory Body: Responsible for monitoring the performance of the administrative body. Electoral Commission: Supervises the conduct of elections.',
      tr: 'Genel Kurul: Resmi olarak kayıtlı tüm birlik üyelerinden oluşur. Yönetim Kurulu: (Başkan, Başkan Yardımcısı, Genel Sekreter, Halkla İlişkiler Görevlisi, Dil ve Çeviri İşleri Görevlisi, Etkinlikler ve Faaliyetler Görevlisi, Medya Görevlisi). Denetim Kurulu: Yönetim kurulunun performansını izlemekten sorumludur. Seçim Komisyonu: Seçimlerin yürütülmesini denetler.'
    },
    notes: {
      ar: 'لا يوجد ملاحظات',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/arab-logo.jpeg'
  },
  "أكاديمية تشوكوروفا": {
    aboutDescription: {
      ar: 'تجمع طلابي تم انشاؤه 2018، يسعى إلى خلق بيئة علمية وثقافية محفزة، ويسهم في تنمية مهارات الطلاب الأكاديمية والشخصية. يعمل الاتحاد من خلال تنظيم أنشطة تعليمية، ورش عمل، دورات تدريبية، وأعمال تطوعية، بما يعزز التميز والابتكار.',
      en: 'A student gathering established in 2018, seeking to create a stimulating scientific and cultural environment, and contributing to the development of students\' academic and personal skills. The union works through organizing educational activities, workshops, training courses, and volunteer work, promoting excellence and innovation.',
      tr: '2018 yılında kurulmuş bir öğrenci topluluğu, uyarıcı bir bilimsel ve kültürel ortam yaratmayı hedefler ve öğrencilerin akademik ve kişisel becerilerinin geliştirilmesine katkıda bulunur. Birlik, eğitim etkinlikleri, atölye çalışmaları, eğitim kursları ve gönüllü çalışmalar düzenleyerek mükemmellik ve yeniliği teşvik eder.'
    },
    cardDescription: {
      ar: 'تجمع طلابي في جامعة تشوكوروفا بأضنة، يسعى لخلق بيئة علمية وثقافية محفزة.',
      en: 'A student gathering at Cukurova University in Adana, seeking to create a stimulating scientific and cultural environment.',
      tr: 'Adana\'daki Çukurova Üniversitesi\'nde uyarıcı bir bilimsel ve kültürel ortam yaratmayı hedefleyen bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '05347235590',
      en: '05347235590',
      tr: '05347235590'
    },
    activitiesAndAchievements: {
      ar: 'محاضرات \'الشيء\': سلسلة محاضرات تثقيفية يقدمها طلاب متميزون أو خريجون لتنمية المهارات، وتم تقديم ما يقارب 15 محاضرة السنة الماضية. \'فرحة طفل\': نشاط ترفيهي يستهدف الأطفال (خاصة مرضى السرطان أو الأيتام). \'مكتبة نون\': مكتبة الكترونية تتيح استعارة الكتب برسوم رمزية، وتضم حالياً نحو 60 كتاباً. \'ساعد بليرة\': مبادرة تطوعية لجمع تبرعات بسيطة أسبوعياً لشراء سلال غذائية (30-50 سلة شهرياً) للأسر المحتاجة في أضنة، بدأت منذ عام 2018.',
      en: '\'The Thing\' Lectures: A series of educational lectures presented by outstanding students or graduates to develop skills, with approximately 15 lectures delivered last year. \'A Child\'s Joy\': A recreational activity targeting children (especially cancer patients or orphans). \'Nun Library\': An electronic library that allows book borrowing for a symbolic fee, currently containing about 60 books. \'Help with a Lira\': A volunteer initiative to collect simple donations weekly to purchase food baskets (30-50 baskets monthly) for needy families in Adana, started since 2018.',
      tr: '\'Şey\' Konferansları: Becerileri geliştirmek için seçkin öğrenciler veya mezunlar tarafından sunulan eğitici konferans serisi, geçen yıl yaklaşık 15 konferans verildi. \'Bir Çocuğun Sevinci\': Çocukları (özellikle kanser hastaları veya yetimleri) hedef alan eğlence etkinliği. \'Nun Kütüphanesi\': Sembolik bir ücret karşılığında kitap ödünç vermeye izin veren elektronik kütüphane, şu anda yaklaşık 60 kitap içeriyor. \'Bir Lira ile Yardım\': 2018\'den beri başlatılan, Adana\'daki ihtiyaç sahibi aileler için gıda sepetleri (ayda 30-50 sepet) satın almak üzere haftalık basit bağışlar toplamak için gönüllü bir girişim.'
    },
    specialAchievements: {
      ar: 'مباردة ساعد بليرة، سلسلة محاضرة الشيء، فرحة طفل، مكتبة نون.',
      en: 'Help with a Lira initiative, The Thing lecture series, A Child\'s Joy, Nun Library.',
      tr: 'Bir Lira ile Yardım girişimi, Şey konferans serisi, Bir Çocuğun Sevinci, Nun Kütüphanesi.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: أيهم طالب (مهندس مخبري وطالب ماجستير \'هندسة جيولوجيا\'). نائبة الرئيس العام: فاطمة أبو عابد (طالبة \'هندسة حاسوب\'). مدير المكتب الإعلامي: فاتح صيداوي (طالب \'كلية الإعلام\'). مديرة مكتب العلاقات العامة: ميسم بكور (طالبة \'هندسة عمارة داخلية\'). مديرة النادي العلمي: نغم بكور (طالبة \'قبالة\'). مدير نادي شؤون الطلاب: أحمد قرمو (طالب \'هندسة ميكانيك\'). مدير النادي التطوعي: محمد نور طالب (طالب \'تخدير\'). مديرة النادي الثقافي: بشرى إبراهيم (طالبة \'قبالة\').',
      en: 'President: Aiham Talib (Laboratory Engineer and Master\'s student in \'Geology Engineering\'). General Vice President: Fatima Abu Abed (Student in \'Computer Engineering\'). Media Office Director: Fateh Saydawi (Student in \'Faculty of Media\'). Public Relations Office Director: Maisam Bakour (Student in \'Interior Architecture Engineering\'). Scientific Club Director: Nagham Bakour (Student in \'Midwifery\'). Student Affairs Club Director: Ahmed Qarmo (Student in \'Mechanical Engineering\'). Volunteer Club Director: Muhammad Nour Talib (Student in \'Anesthesia\'). Cultural Club Director: Bushra Ibrahim (Student in \'Midwifery\').',
      tr: 'Başkan: Aiham Talib (Laboratuvar Mühendisi ve \'Jeoloji Mühendisliği\' yüksek lisans öğrencisi). Genel Başkan Yardımcısı: Fatima Abu Abed (\'Bilgisayar Mühendisliği\' öğrencisi). Medya Ofisi Müdürü: Fateh Saydawi (\'Medya Fakültesi\' öğrencisi). Halkla İlişkiler Ofisi Müdürü: Maisam Bakour (\'İç Mimarlık Mühendisliği\' öğrencisi). Bilimsel Kulüp Müdürü: Nagham Bakour (\'Ebelik\' öğrencisi). Öğrenci İşleri Kulübü Müdürü: Ahmed Qarmo (\'Makine Mühendisliği\' öğrencisi). Gönüllü Kulüp Müdürü: Muhammed Nour Talib (\'Anestezi\' öğrencisi). Kültürel Kulüp Müdürü: Bushra İbrahim (\'Ebelik\' öğrencisi).'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: ''
  },
  "اتحاد اديمان": {
    aboutDescription: {
      ar: 'اتحاد اديمان يجمع الطلبة السوريين في مدينة اديمان. يعمل الاتحاد على دعم الطلاب أكاديمياً واجتماعياً وثقافياً، من خلال تنظيم ورش العمل والدورات التدريبية والأنشطة المتنوعة. يسعى الاتحاد لخلق بيئة تعليمية محفزة ومجتمع طلابي متماسك.',
      en: 'Adiyaman Union brings together Syrian students in the city of Adiyaman. The union works to support students academically, socially, and culturally, through organizing workshops, training courses, and various activities. The union strives to create an inspiring educational environment and a cohesive student community.',
      tr: 'Adıyaman Birliği, Adıyaman şehrindeki Suriyeli öğrencileri bir araya getirir. Birlik, atölye çalışmaları, eğitim kursları ve çeşitli etkinlikler düzenleyerek öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışır. Birlik, ilham verici bir eğitim ortamı ve uyumlu bir öğrenci topluluğu yaratmaya çalışır.'
    },
    cardDescription: {
      ar: 'اتحاد في اديمان يعمل على دعم الطلاب أكاديمياً واجتماعياً وثقافياً.',
      en: 'A union in Adiyaman working to support students academically, socially, and culturally.',
      tr: 'Adıyaman\'daki öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışan bir birlik.'
    },
    contactNumber: {
      ar: '+90 312 XXX XXXX',
      en: '+90 312 XXX XXXX',
      tr: '+90 312 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمرات وندوات علمية، برامج تدريبية في المهارات القيادية، ورش عمل في ريادة الأعمال، خدمات التوجيه والإرشاد.',
      en: 'Scientific conferences and seminars, leadership skills training programs, entrepreneurship workshops, orientation and guidance services.',
      tr: 'Bilimsel konferanslar ve seminerler, liderlik becerileri eğitim programları, girişimcilik atölye çalışmaları, oryantasyon ve rehberlik hizmetleri.'
    },
    specialAchievements: {
      ar: 'تنظيم مؤتمر قيادة طلابي دولي، إطلاق برنامج ريادة الأعمال، فوز بجائزة التميز في القيادة.',
      en: 'Organizing an international student leadership conference, launching an entrepreneurship program, winning Leadership Excellence Award.',
      tr: 'Uluslararası öğrenci liderliği konferansı düzenlemek, girişimcilik programı başlatmak, Liderlik Mükemmellik Ödülü kazanmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: خالد محمود، نائب الرئيس: سمر علي، أمين السر: طارق يوسف، أمين الصندوق: ناديا حسن.',
      en: 'President: Khaled Mahmoud, Vice President: Samar Ali, Secretary: Tariq Youssef, Treasurer: Nadia Hassan.',
      tr: 'Başkan: Khaled Mahmoud, Başkan Yardımcısı: Samar Ali, Sekreter: Tariq Youssef, Sayman: Nadia Hassan.'
    },
    notes: {
      ar: 'الاتحاد رائد في مجال القيادة الطلابية وريادة الأعمال. يقدم برامج متميزة للطلاب الطموحين.',
      en: 'The union is a leader in student leadership and entrepreneurship. Provides outstanding programs for ambitious students.',
      tr: 'Birlik, öğrenci liderliği ve girişimcilik alanında öncüdür. Hırslı öğrenciler için seçkin programlar sunar.'
    },
    logo: './assets/subunions/adyman-logo.png'
  },
  "اتحاد الطلبة السوريين - دوزجة": {
    aboutDescription: {
      ar: 'تجمع طلابي تطوعي منتخب يضم الطلبة السوريين في جامعة دوزجة. رسالته المساهمة في بناء مجتمع طلابي واع ومثقف وريادي.',
      en: 'An elected voluntary student gathering that includes Syrian students at Duzce University. Its mission is to contribute to building an aware, educated, and pioneering student community.',
      tr: 'Düzce Üniversitesi\'ndeki Suriyeli öğrencileri içeren seçilmiş gönüllü bir öğrenci topluluğu. Misyonu, bilinçli, eğitimli ve öncü bir öğrenci topluluğu oluşturmaya katkıda bulunmaktır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين - دوزجة - تجمع طلابي تطوعي منتخب يضم الطلبة السوريين في جامعة دوزجة.',
      en: 'Syrian Students Union - Duzce - An elected voluntary student gathering that includes Syrian students at Duzce University.',
      tr: 'Suriyeli Öğrenci Birliği - Düzce - Düzce Üniversitesi\'ndeki Suriyeli öğrencileri içeren seçilmiş gönüllü bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '+905528118291',
      en: '+905528118291',
      tr: '+905528118291'
    },
    activitiesAndAchievements: {
      ar: 'مسك البدايات. سينما البنات. نادي القراءة. الخط الديواني. البطولة العربية لكرة القدم 2. جلسة (هل الصحة النفسية حقا مهمة). تصميم وتلوين الرسمات الخشبية (بنات). دورات التقوية الفصل الأول. أمسية النصر. كيف تحول فكرتك إلى منتج. الخطيب البارع. تصميم وتشكيل السيراميك (بنات). مباريات كرة السلة أسبوعياً (بنات). المعايدة مع جميع الجاليات العربية (عيد الفطر وعيد الأضحى). دورة أوتوكاد مع 4 اتحادات أخرى. المصلى الرمضاني مع الاتحاد العربية في دوزجة. مسرحية الخوف من الباب الواحد (ذكرى الثورة). جلسة مهارة التفكر التدبري. الركن الثقافي في الـ Düfest. حفل التخرج. عبق البدايات (2025-2026). درس بكتاب سبيل المصلحات - أسبوعي (2025-2026). رحلة ترفيهية إلى شلالات آيدن بينار (2025-2026).',
      en: 'Grasping the Beginnings. Girls Cinema. Reading Club. Diwani Calligraphy. Arab Football Championship 2. Session (Is Mental Health Really Important). Wooden Drawing Design and Coloring (Girls). First Semester Reinforcement Courses. Victory Evening. How to Turn Your Idea into a Product. The Eloquent Orator. Ceramic Design and Shaping (Girls). Weekly Basketball Matches (Girls). Greetings with All Arab Communities (Eid al-Fitr and Eid al-Adha). AutoCAD Course with 4 Other Unions. Ramadan Prayer Hall with Arab Union in Duzce. Play "Fear of the Only Door" (Revolution Anniversary). Contemplative Thinking Skills Session. Cultural Corner at Düfest. Graduation Ceremony. Fragrance of Beginnings (2025-2026). Weekly Lesson with "Path of the Righteous" Book (2025-2026). Recreational Trip to Aydın Pınar Waterfalls (2025-2026).',
      tr: 'Başlangıçları Kavrama. Kızlar Sineması. Okuma Kulübü. Divani Hat. Arap Futbol Şampiyonası 2. (Ruh Sağlığı Gerçekten Önemli mi) Oturumu. Ahşap Çizim Tasarımı ve Boyama (Kızlar). Birinci Dönem Takviye Kursları. Zafer Akşamı. Fikrinizi Ürüne Nasıl Dönüştürürsünüz. Belagatlı Hatip. Seramik Tasarımı ve Şekillendirme (Kızlar). Haftalık Basketbol Maçları (Kızlar). Tüm Arap Topluluklarıyla Bayramlaşma (Ramazan ve Kurban Bayramı). 4 Diğer Birlikle AutoCAD Kursu. Düzce\'deki Arap Birliği ile Ramazan Namazgahı. "Tek Kapıdan Korku" Oyunu (Devrim Yıldönümü). Düşünme Becerileri Oturumu. Düfest\'te Kültür Köşesi. Mezuniyet Töreni. Başlangıçların Kokusu (2025-2026). "Salihlerin Yolu" Kitabıyla Haftalık Ders (2025-2026). Aydın Pınar Şelalelerine Rekreasyon Gezisi (2025-2026).'
    },
    specialAchievements: {
      ar: 'المصلى الرمضاني - حفل التخرج - اليوم الثقافي - ذكرى الثورة.',
      en: 'Ramadan Prayer Hall - Graduation Ceremony - Culture Day - Revolution Anniversary.',
      tr: 'Ramazan Namazgahı - Mezuniyet Töreni - Kültür Günü - Devrim Yıldönümü.'
    },
    currentAdministrativeTeam: {
      ar: 'عدد الفريق: 7. الأعضاء والمناصب: الرئيس، مسؤول الأنشطة - نائب الرئيس، أمين السر، مسؤول شؤون الطلاب، مسؤول المكتب الإعلامي، مسؤولتين عن شؤون الطالبات، مسؤول المكتب الثقافي.',
      en: 'Team size: 7. Members and Positions: President, Activities Officer - Vice President, Secretary General, Student Affairs Officer, Media Office Officer, Two Female Students Affairs Officers, Cultural Office Officer.',
      tr: 'Ekip sayısı: 7. Üyeler ve Pozisyonlar: Başkan, Etkinlikler Görevlisi - Başkan Yardımcısı, Genel Sekreter, Öğrenci İşleri Görevlisi, Medya Ofisi Görevlisi, İki Kız Öğrenci İşleri Görevlisi, Kültür Ofisi Görevlisi.'
    },
    notes: {
      ar: 'تركز على المساعدات والتواصل مع المعنيين في المدينة (الوالي والهجرة والمنظمات التركية المدنية) لدعم الطلاب.',
      en: 'It focuses on assistance and communication with relevant parties in the city (governor, immigration, and Turkish civil organizations) to support students.',
      tr: 'Öğrencileri desteklemek için şehirdeki ilgili taraflarla (vali, göç ve Türk sivil kuruluşları) yardım ve iletişime odaklanır.'
    },
    logo: './assets/subunions/duzje-logo.png'
  },
  "اتحاد الطلبة السوريين في سكاريا": {
    aboutDescription: {
      ar: 'اتحاد طلابي منتخب ومستقل، يهدف لتوفير حاضنة تنمية أكاديمية إغاثية رسمية وترفيهية للطالب السوري. تتمركز ملامح عمل الاتحاد من قيمه التي يعتمد عليها وهي (الشفافية، الجودة، حرية الرأي والنقد، الخلق الحسن).',
      en: 'An elected and independent student union, aiming to provide an academic, relief, official and recreational development incubator for Syrian students. The union\'s work features are centered on the values it relies on: (transparency, quality, freedom of opinion and criticism, good character).',
      tr: 'Seçilmiş ve bağımsız bir öğrenci birliği, Suriyeli öğrenciler için akademik, yardım, resmi ve rekreasyonel gelişim kuluçkası sağlamayı amaçlar. Birliğin çalışma özellikleri, dayandığı değerlerden kaynaklanır: (şeffaflık, kalite, fikir ve eleştiri özgürlüğü, iyi ahlak).'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في سكاريا - اتحاد طلابي منتخب ومستقل يهدف لتوفير حاضنة تنمية للطالب السوري.',
      en: 'Syrian Students Union in Sakarya - An elected and independent student union aiming to provide a development incubator for Syrian students.',
      tr: 'Sakarya\'daki Suriyeli Öğrenci Birliği - Suriyeli öğrenciler için bir gelişim kuluçkası sağlamayı amaçlayan seçilmiş ve bağımsız bir öğrenci birliği.'
    },
    contactNumber: {
      ar: '+905386457432',
      en: '+905386457432',
      tr: '+905386457432'
    },
    activitiesAndAchievements: {
      ar: 'إطلاق نادي سكاريا الرياضي. الاعتماد على الداعم التركي المحلي. توفير منح وسلل إغاثية بما إجماله 4000 دولار.',
      en: 'Launching Sakarya Sports Club. Relying on local Turkish support. Providing scholarships and relief baskets totaling $4,000.',
      tr: 'Sakarya Spor Kulübü\'nü başlatmak. Yerel Türk desteğine güvenmek. Toplam 4.000 dolar değerinde burs ve yardım sepetleri sağlamak.'
    },
    specialAchievements: {
      ar: 'منح طلابية بقيمة $10,000 دولار، سلال غذائية مستمرة بقيمة 97 ألف ليرة، 22,000 معاملة طلابية (استشارة، سحب قيد، تجميد قيد وغيره)، $3,000 دولار مساعدات مادية.',
      en: 'Student scholarships worth $10,000, continuous food baskets worth 97,000 lira, 22,000 student transactions (consultation, withdrawal, freeze enrollment, etc.), $3,000 in material assistance.',
      tr: '10.000 dolar değerinde öğrenci bursları, 97.000 lira değerinde sürekli gıda sepetleri, 22.000 öğrenci işlemi (danışmanlık, kayıt çekme, kayıt dondurma vb.), 3.000 dolar maddi yardım.'
    },
    currentAdministrativeTeam: {
      ar: 'مجلس إدارة: 5 أعضاء. المكاتب: 4 مكاتب (الإعلامي، الاجتماعي والترفيهي، الثقافي والأكاديمي، شؤون الطلاب).',
      en: 'Board of Directors: 5 members. Offices: 4 offices (Media, Social and Entertainment, Cultural and Academic, Student Affairs).',
      tr: 'Yönetim Kurulu: 5 üye. Ofisler: 4 ofis (Medya, Sosyal ve Eğlence, Kültürel ve Akademik, Öğrenci İşleri).'
    },
    notes: {
      ar: 'لا يوجد',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين - كرابوك": {
    aboutDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة كرابوك هو الممثل الرسمي للطلبة. يعكس رسالته وأهدافه وأبرز ملامح عمله الطلابي.',
      en: 'The Syrian Students Union at Karabuk University is the official representative of students. It reflects its mission, goals, and key features of its student work.',
      tr: 'Karabük Üniversitesi\'ndeki Suriyeli Öğrenci Birliği, öğrencilerin resmi temsilcisidir. Misyonunu, hedeflerini ve öğrenci çalışmalarının önemli özelliklerini yansıtır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة كرابوك - الممثل الرسمي للطلبة.',
      en: 'Syrian Students Union at Karabuk University - Official representative of students.',
      tr: 'Karabük Üniversitesi Suriyeli Öğrenci Birliği - Öğrencilerin resmi temsilcisi.'
    },
    contactNumber: {
      ar: '05317396997',
      en: '05317396997',
      tr: '05317396997'
    },
    activitiesAndAchievements: {
      ar: 'فعاليات عامة وثقافية ووطنية (مثل حفل ذكرى الثورة السورية حلم صار وطن، الأمسية الأدبية المشتركة مع الاتحاد اليمني، يوم اللغة العربية، احتفالات النصر وتحرير حلب، وحفل تخرج دفعة \'النصر\')، بالإضافة إلى إطلاق الموقع الرسمي للاتحاد. تعزيز العلاقات الرسمية مع الجامعة والمؤسسات الحكومية، من خلال زيارات رسمية ولقاءات وزيارات مؤسسات حكومية لعرض أوضاع الطلبة السوريين وتحسين الخدمات. أنشطة خدمية وإنسانية (مثل إفطار رمضاني جماعي، حملات إفطار صائم وأخبز بصدقة لدعم الداخل السوري)، ومتابعة شؤون الطلبة الأكاديمية والإدارية والإقامات وإطلاق منصة إلكترونية للاستشارات. أنشطة ثقافية وفكرية (تضمنت جلسات نقاش، محاضرات، معارض كتب، تأسيس نادي سلاسل الثقافي ونادي بودكاست، بالإضافة إلى دعم النوادي الطلابية القائمة). أنشطة إعلامية (تضمنت توثيق جميع الفعاليات، إنتاج أفلام وفيديوهات، تنظيم مسابقات مثل \'أفضل اقتباس\'، \'أجمل صورة\'، و \'المسابقة البرمجية\'، ونشر محتوى إعلامي يعكس رسالة الاتحاد). أنشطة علمية (تضمنت دروس مراجعة، ورش تعريفية لطلاب التحضيري، مسابقات برمجة، الإعلان عن منح دراسية، وإطلاق الموقع الرسمي للمكتب العلمي). أنشطة رياضية (تضمنت تأسيس المنتخب السوري في الجامعة، تنظيم تدريبات ومباريات ودية، والمشاركة في فعاليات رياضية داخل الجامعة وخارجها). أنشطة خاصة بالطالبات (شملت المشاركة في فعالية \'جسر من تركيا إلى العالم\' وتنظيم لقاءات وجلسات رمضانية).',
      en: 'General, cultural and national events (such as the Syrian Revolution commemoration ceremony "Dream Became a Homeland", joint literary evening with the Yemeni Union, Arabic Language Day, victory celebrations and liberation of Aleppo, and graduation ceremony for the "Victory" class), in addition to launching the union\'s official website. Strengthening official relations with the university and government institutions through official visits, meetings and visits to government institutions to present the situation of Syrian students and improve services. Service and humanitarian activities (such as collective Ramadan breakfast, "Feed the Fasting" campaigns and "I Bake with Charity" to support inside Syria), and follow-up on students\' academic, administrative and residency affairs and launching an electronic consultation platform. Cultural and intellectual activities (including discussion sessions, lectures, book exhibitions, establishment of the Salasil Cultural Club and Podcast Club, in addition to supporting existing student clubs). Media activities (including documentation of all events, production of films and videos, organizing competitions such as "Best Quote", "Most Beautiful Picture", and "Programming Competition", and publishing media content that reflects the union\'s message). Scientific activities (including review lessons, introductory workshops for preparatory students, programming competitions, announcement of scholarships, and launching the official website of the Scientific Office). Sports activities (including the establishment of the Syrian national team at the university, organizing training and friendly matches, and participation in sports events inside and outside the university). Activities for female students (including participation in the "Bridge from Turkey to the World" event and organizing meetings and Ramadan sessions).',
      tr: 'Genel, kültürel ve ulusal etkinlikler (Suriye Devrimi anma töreni "Rüya Vatan Oldu", Yemen Birliği ile ortak edebi akşam, Arapça Dili Günü, zafer kutlamaları ve Halep\'in kurtuluşu ve "Zafer" sınıfının mezuniyet töreni gibi), ayrıca birliğin resmi web sitesinin başlatılması. Üniversite ve devlet kurumlarıyla resmi ilişkilerin güçlendirilmesi, Suriyeli öğrencilerin durumunu sunmak ve hizmetleri iyileştirmek için resmi ziyaretler, toplantılar ve devlet kurumlarına ziyaretler. Hizmet ve insani faaliyetler (toplu Ramazan kahvaltısı, "Oruçlu Yedir" kampanyaları ve Suriye içini desteklemek için "Sadaka ile Ekmek Yapıyorum" gibi) ve öğrencilerin akademik, idari ve ikamet işlerinin takibi ve elektronik danışmanlık platformunun başlatılması. Kültürel ve entelektüel etkinlikler (tartışma oturumları, konferanslar, kitap sergileri, Salasil Kültür Kulübü ve Podcast Kulübü\'nün kurulması, ayrıca mevcut öğrenci kulüplerinin desteklenmesi dahil). Medya etkinlikleri (tüm etkinliklerin belgelenmesi, film ve video üretimi, "En İyi Alıntı", "En Güzel Resim" ve "Programlama Yarışması" gibi yarışmaların düzenlenmesi ve birliğin mesajını yansıtan medya içeriğinin yayınlanması dahil). Bilimsel etkinlikler (hazırlık öğrencileri için gözden geçirme dersleri, tanıtım atölyeleri, programlama yarışmaları, burs duyuruları ve Bilimsel Ofis\'in resmi web sitesinin başlatılması dahil). Spor etkinlikleri (üniversitede Suriye milli takımının kurulması, antrenman ve dostluk maçlarının düzenlenmesi ve üniversite içinde ve dışında spor etkinliklerine katılım dahil). Kız öğrenciler için etkinlikler ("Türkiye\'den Dünyaya Köprü" etkinliğine katılım ve toplantılar ve Ramazan oturumlarının düzenlenmesi dahil).'
    },
    specialAchievements: {
      ar: 'قام اتحاد الطلبة السوريين في جامعة كرابوك بتنظيم مجموعة مميزة من الفعاليات والأنشطة.',
      en: 'The Syrian Students Union at Karabuk University organized a distinguished group of events and activities.',
      tr: 'Karabük Üniversitesi Suriyeli Öğrenci Birliği, seçkin bir etkinlik ve faaliyet grubu düzenledi.'
    },
    currentAdministrativeTeam: {
      ar: 'فريق إداري يضم (19) عضوًا موزعين على ستة مكاتب طلابية. الرئيس: إبراهيم بيطار. مكتب شؤون الطلبة: ربا سعد الدين، محمد قشقش، عمر التركاوي، شام سعد الدين. المكتب الثقافي: أنس بن مالك العداي، إسراء مزيد محمد الريمي، فريد سليمانو. المكتب الإعلامي: فراس الشيخ ويس، شام سعد الدين. المكتب العلمي: حسين الهولا، هاني الحموي. مكتب الرياضة والأنشطة: عمر الحمد، عبد الرحمن الإبراهيم، عبد الكريم صبيح، محمد بصو. مكتب الطالبات: زبيدة أسبرو، آيات كنعان، سدرة شمرجي.',
      en: 'An administrative team of (19) members distributed across six student offices. President: Ibrahim Bitar. Student Affairs Office: Raba Saad al-Din, Muhammad Qashqash, Omar al-Turkawi, Sham Saad al-Din. Cultural Office: Anas bin Malik al-Adai, Israa Mazid Muhammad al-Rimi, Farid Suleimano. Media Office: Firas al-Sheikh Wais, Sham Saad al-Din. Scientific Office: Hussein al-Hawla, Hani al-Hamwi. Sports and Activities Office: Omar al-Hamad, Abdul Rahman al-Ibrahim, Abdul Karim Sabih, Muhammad Basu. Women\'s Office: Zubaida Asbro, Ayat Kanan, Sidra Shamrji.',
      tr: 'Altı öğrenci ofisine dağıtılmış (19) üyeden oluşan bir yönetim ekibi. Başkan: İbrahim Bitar. Öğrenci İşleri Ofisi: Raba Saad al-Din, Muhammed Kaşkaş, Ömer el-Türkavi, Şam Saad al-Din. Kültür Ofisi: Enes bin Malik el-Adai, İsra Mazid Muhammed er-Rimi, Farid Süleymano. Medya Ofisi: Firas eş-Şeyh Vais, Şam Saad al-Din. Bilimsel Ofis: Hüseyin el-Havla, Hani el-Hamvi. Spor ve Etkinlikler Ofisi: Ömer el-Hamad, Abdurrahman el-İbrahim, Abdülkerim Sabih, Muhammed Basu. Kadın Ofisi: Zübeyde Asbro, Ayat Kanan, Sidra Şamrci.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: './assets/subunions/karabuk-logo.png'
  },
  "تجمع الطلبة السوريين في جامعة بورصة التقنية": {
    aboutDescription: {
      ar: 'يهدف إلى توحيد الجهود.',
      en: 'Aims to unify efforts.',
      tr: 'Çabaları birleştirmeyi amaçlar.'
    },
    cardDescription: {
      ar: 'تجمع الطلبة السوريين في جامعة بورصة التقنية - يهدف إلى توحيد الجهود.',
      en: 'Syrian Students Gathering at Bursa Technical University - Aims to unify efforts.',
      tr: 'Bursa Teknik Üniversitesi Suriyeli Öğrenci Topluluğu - Çabaları birleştirmeyi amaçlar.'
    },
    contactNumber: {
      ar: '05382466386',
      en: '05382466386',
      tr: '05382466386'
    },
    activitiesAndAchievements: {
      ar: 'حفل النصر. ستاند تعريفي بثقافة سوريا. إفطارات رمضانية. مشاهدة فيلم. حفل التخرج.',
      en: 'Victory ceremony. Informative stand about Syrian culture. Ramadan Iftars. Film screening. Graduation ceremony.',
      tr: 'Zafer töreni. Suriye kültürü hakkında bilgilendirici stand. Ramazan İftarları. Film gösterimi. Mezuniyet töreni.'
    },
    specialAchievements: {
      ar: 'حفل التخرج.',
      en: 'Graduation ceremony.',
      tr: 'Mezuniyet töreni.'
    },
    currentAdministrativeTeam: {
      ar: 'عدد أعضاء الإدارة: 3. عدد المتطوعين: 25. عدد الطلاب السوريين في الجامعة: 100.',
      en: 'Number of administrative members: 3. Number of volunteers: 25. Number of Syrian students at the university: 100.',
      tr: 'Yönetim üye sayısı: 3. Gönüllü sayısı: 25. Üniversitedeki Suriyeli öğrenci sayısı: 100.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: ''
  },
  "هيئة الطلبة السوريين في سيواس": {
    aboutDescription: {
      ar: 'كيان طلابي يهدف إلى تمثيل الطلبة السوريين في الجامعة وتعزيز تواصلهم وتفاعلهم مع الأنشطة الأكاديمية والاجتماعية. أهدافه: تمثيل الطلبة أمام الجهات الرسمية في الجامعة، تنظيم الأنشطة الطلابية والثقافية والاجتماعية.',
      en: 'A student entity that aims to represent Syrian students in the university and enhance their communication and interaction with academic and social activities. Its objectives: representing students before official bodies in the university, organizing student, cultural and social activities.',
      tr: 'Üniversitedeki Suriyeli öğrencileri temsil etmeyi ve akademik ve sosyal etkinliklerle iletişimlerini ve etkileşimlerini geliştirmeyi amaçlayan bir öğrenci varlığı. Hedefleri: öğrencileri üniversitedeki resmi kurumlar önünde temsil etmek, öğrenci, kültürel ve sosyal etkinlikleri organize etmek.'
    },
    cardDescription: {
      ar: 'هيئة الطلبة السوريين في سيواس - كيان طلابي يهدف إلى تمثيل الطلبة وتعزيز تواصلهم.',
      en: 'Syrian Students Body in Sivas - A student entity aiming to represent students and enhance their communication.',
      tr: 'Sivas\'taki Suriyeli Öğrenci Kurulu - Öğrencileri temsil etmeyi ve iletişimlerini geliştirmeyi amaçlayan bir öğrenci varlığı.'
    },
    contactNumber: {
      ar: 'صفحة أنستغرام الرسمية scu.sob',
      en: 'Official Instagram page: scu.sob',
      tr: 'Resmi Instagram sayfası: scu.sob'
    },
    activitiesAndAchievements: {
      ar: 'حفل تخرج. رحلات ترفيهية. دورات تقوية في المواد الجامعية.',
      en: 'Graduation ceremony. Recreational trips. Strengthening courses in university subjects.',
      tr: 'Mezuniyet töreni. Eğlence gezileri. Üniversite derslerinde güçlendirme kursları.'
    },
    specialAchievements: {
      ar: 'حفل التخرج.',
      en: 'Graduation ceremony.',
      tr: 'Mezuniyet töreni.'
    },
    currentAdministrativeTeam: {
      ar: 'الهيئة العامة: 40 طالب. مجلس الإدارة: حالياً 3 طلاب.',
      en: 'General Assembly: 40 students. Board of Directors: currently 3 students.',
      tr: 'Genel Kurul: 40 öğrenci. Yönetim Kurulu: şu anda 3 öğrenci.'
    },
    notes: {
      ar: 'جزاكم الله خيرا',
      en: 'May God reward you with goodness.',
      tr: 'Allah sizden razı olsun.'
    },
    logo: './assets/subunions/sivas-logo.png'
  },
  "اتحاد الطلبة السوريين في كهرمان مرعش": {
    aboutDescription: {
      ar: 'لا يوجد',
      en: 'No description available.',
      tr: 'Açıklama mevcut değil.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في كهرمان مرعش.',
      en: 'Syrian Students Union in Kahramanmaras.',
      tr: 'Kahramanmaraş\'taki Suriyeli Öğrenci Birliği.'
    },
    contactNumber: {
      ar: '05355862046',
      en: '05355862046',
      tr: '05355862046'
    },
    activitiesAndAchievements: {
      ar: 'حفل تخرج + مهرجان ثقافي.',
      en: 'Graduation ceremony + cultural festival.',
      tr: 'Mezuniyet töreni + kültürel festival.'
    },
    specialAchievements: {
      ar: 'حفل التخرج.',
      en: 'Graduation ceremony.',
      tr: 'Mezuniyet töreni.'
    },
    currentAdministrativeTeam: {
      ar: 'لا يوجد',
      en: 'Not available.',
      tr: 'Mevcut değil.'
    },
    notes: {
      ar: 'لا يوجد',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/kahramanmarash-logo.jpg'
  },
  "اتحاد اينونو": {
    aboutDescription: {
      ar: 'كيان طلابي تطوعي يهدف إلى تمثيل الطلبة السوريين داخل الجامعة والدفاع عن حقوقهم وتقديم الدعم الأكاديمي والاجتماعي. رسالته بناء مجتمع طلابي متعاون يساهم في تطوير الحياة الجامعية. يتركز عمله على تنظيم الأنشطة وتقديم الاستشارات والخدمات التعليمية والتنسيق مع إدارة الجامعة.',
      en: 'A voluntary student entity that aims to represent Syrian students within the university, defend their rights, and provide academic and social support. Its mission is to build a cooperative student community that contributes to developing university life. Its work focuses on organizing activities, providing consultations and educational services, and coordinating with the university administration.',
      tr: 'Üniversite içindeki Suriyeli öğrencileri temsil etmeyi, haklarını savunmayı ve akademik ve sosyal destek sağlamayı amaçlayan gönüllü bir öğrenci varlığı. Misyonu, üniversite yaşamının gelişmesine katkıda bulunan işbirlikçi bir öğrenci topluluğu oluşturmaktır. Çalışması, etkinlikleri organize etmeye, danışmanlık ve eğitim hizmetleri sağlamaya ve üniversite yönetimiyle koordinasyona odaklanır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة إينونو - كيان طلابي تطوعي يهدف إلى تمثيل الطلبة والدفاع عن حقوقهم.',
      en: 'Syrian Students Union at Inonu University - A voluntary student entity aiming to represent students and defend their rights.',
      tr: 'İnönü Üniversitesi Suriyeli Öğrenci Birliği - Öğrencileri temsil etmeyi ve haklarını savunmayı amaçlayan gönüllü bir öğrenci varlığı.'
    },
    contactNumber: {
      ar: '05356777045',
      en: '05356777045',
      tr: '05356777045'
    },
    activitiesAndAchievements: {
      ar: 'الفطور الرمضاني الجماعي بتاريخ 19/03/2025. المشاركة في تنظيم مهرجان الطلبة الأجانب بتاريخ 09/05/2025. تنظيم حفل التخرج بتاريخ 31/05/2025. خدمات الخريجين (المساعدة في تصديق الشهادات والرد على أكثر من 30 استفساراً). اجتماع مع إدارة الهجرة في ملطيا بتاريخ 20/03/2025 لطرح قضايا الطلبة. تسجيل أكثر من 50 طالباً على العديد من المنح الدراسية مجاناً بالكامل بالتعاون مع مؤسسة تكامل التعليمية. تسجيل أكثر من 25 طالباً في منحة Suriye Burs Program. تسهيل إجراءات تقسيط الأقساط الدراسية لأكثر من 80 طالباً. مسابقة "اقرأ وارتق" بإشراف الأستاذ خالد الناصر.',
      en: 'Collective Ramadan Iftar on 19/03/2025. Participation in organizing the International Students Festival on 09/05/2025. Organizing graduation ceremony on 31/05/2025. Graduate services (assistance in certifying diplomas and responding to more than 30 inquiries). Meeting with immigration administration in Malatya on 20/03/2025 to raise student issues. Registering more than 50 students for various scholarships completely free of charge in cooperation with Tekamul Educational Foundation. Registering more than 25 students in Suriye Burs Program scholarship. Facilitating tuition installment procedures for more than 80 students. "Read and Rise" competition under the supervision of Professor Khaled al-Nasser.',
      tr: '19/03/2025 tarihinde Toplu Ramazan İftarı. 09/05/2025 tarihinde Uluslararası Öğrenci Festivali\'nin düzenlenmesine katılım. 31/05/2025 tarihinde mezuniyet töreni düzenlemek. Mezun hizmetleri (diploma onaylama ve 30\'dan fazla soruya yanıt verme konusunda yardım). Öğrenci sorunlarını gündeme getirmek için 20/03/2025 tarihinde Malatya\'daki göç idaresiyle toplantı. Tekamul Eğitim Vakfı ile işbirliği içinde 50\'den fazla öğrenciyi çeşitli burslara tamamen ücretsiz kaydetmek. Suriye Burs Programı bursuna 25\'ten fazla öğrenci kaydetmek. 80\'den fazla öğrenci için harç taksit prosedürlerini kolaylaştırmak. Profesör Halid el-Nasır\'ın gözetiminde "Oku ve Yüksel" yarışması.'
    },
    specialAchievements: {
      ar: 'تسجيل أكثر من 50 طالباً على المنح الدراسية بالتعاون مع مؤسسة تكامل التعليمية. تسهيل إجراءات تقسيط الأقساط الدراسية لأكثر من 80 طالباً.',
      en: 'Registering more than 50 students for scholarships in cooperation with Tekamul Educational Foundation. Facilitating tuition installment procedures for more than 80 students.',
      tr: 'Tekamul Eğitim Vakfı ile işbirliği içinde 50\'den fazla öğrenciyi burslara kaydetmek. 80\'den fazla öğrenci için harç taksit prosedürlerini kolaylaştırmak.'
    },
    currentAdministrativeTeam: {
      ar: 'مجلس الإدارة مكون من 5 مكاتب رئيسية، وكل مكتب يوجد فيه عدد من المتطوعين.',
      en: 'The board of directors consists of 5 main offices, and each office has a number of volunteers.',
      tr: 'Yönetim kurulu 5 ana ofisten oluşur ve her ofiste bir dizi gönüllü bulunur.'
    },
    notes: {
      ar: '',
      en: '',
      tr: ''
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في اسكندرون": {
    aboutDescription: {
      ar: 'تأسس في النصف الثاني من العام الدراسي 2021-2022 وتم الاعتراف به من قبل جامعة اسكندرون التقنية تحت مظلة اتحاد الطلبة الدوليين. يهدف إلى تعزيز دور وهوية الطالب السوري، وتمثيله أمام مسؤولي الجامعة، وإقامة فعاليات ثقافية وترفيهية تطوعية.',
      en: 'Founded in the second half of the 2021-2022 academic year and recognized by Iskenderun Technical University under the umbrella of the International Students Union. Aims to enhance the role and identity of Syrian students, represent them before university officials, and organize voluntary cultural and recreational events.',
      tr: '2021-2022 akademik yılının ikinci yarısında kuruldu ve Uluslararası Öğrenci Birliği çatısı altında İskenderun Teknik Üniversitesi tarafından tanındı. Suriyeli öğrencilerin rolünü ve kimliğini geliştirmeyi, onları üniversite yetkilileri önünde temsil etmeyi ve gönüllü kültürel ve rekreasyon etkinlikleri düzenlemeyi amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في اسكندرون - تأسس في 2021-2022 ويهدف إلى تعزيز دور وهوية الطالب السوري.',
      en: 'Syrian Students Union in Iskenderun - Founded in 2021-2022, aims to enhance the role and identity of Syrian students.',
      tr: 'İskenderun\'daki Suriyeli Öğrenci Birliği - 2021-2022\'de kuruldu, Suriyeli öğrencilerin rolünü ve kimliğini geliştirmeyi amaçlar.'
    },
    contactNumber: {
      ar: '05305883550',
      en: '05305883550',
      tr: '05305883550'
    },
    activitiesAndAchievements: {
      ar: 'تأسيس موقع تعريف كدليل للطالب عن مدينة اسكندرون. دروس تحضيرية للفيزا في الرياضيات (HH). نشاط توزيع السلل الغذائية في رمضان للعائلات المتعففة. دوري كرة القدم للطلبة. إفطار رمضاني مع الـ HH. تمثيل سوريا في يوم الثقافة. اجتماع مع مسؤول الطلبة الأجانب ومسؤول شؤون الطلبة ومسؤول العلاقات الخارجية في الجامعة لعرض مشاكل الطلاب. حفل التخرج للطلبة السوريين خاصة والعرب كافة.',
      en: 'Establishing an informational website as a student guide about Iskenderun city. Preparatory visa lessons in mathematics (HH). Ramadan food basket distribution activity for needy families. Student football league. Ramadan Iftar with HH. Representing Syria in Culture Day. Meeting with foreign students officer, student affairs officer, and international relations officer at the university to present student problems. Graduation ceremony for Syrian students specifically and all Arab students.',
      tr: 'İskenderun şehri hakkında öğrenci rehberi olarak bilgilendirici bir web sitesi kurmak. Matematikte vize hazırlık dersleri (HH). İhtiyaç sahibi aileler için Ramazan gıda sepeti dağıtım etkinliği. Öğrenci futbol ligi. HH ile Ramazan İftarı. Kültür Günü\'nde Suriye\'yi temsil etmek. Öğrenci sorunlarını sunmak için üniversitede yabancı öğrenci görevlisi, öğrenci işleri görevlisi ve uluslararası ilişkiler görevlisi ile toplantı. Özellikle Suriyeli öğrenciler ve tüm Arap öğrenciler için mezuniyet töreni.'
    },
    specialAchievements: {
      ar: 'موقع دليل اسكندرون للطالب.',
      en: 'Iskenderun Student Guide website.',
      tr: 'İskenderun Öğrenci Rehberi web sitesi.'
    },
    currentAdministrativeTeam: {
      ar: 'رئيس الاتحاد: كنان عبد الله. مسؤول الأنشطة: حسين المصطفى. المسؤول المالي: أنس الحمد. مسؤول الإعلام: زيد حاج موسى. مسؤول شؤون الطلبة: عمر عبد الله.',
      en: 'Union President: Kenan Abdullah. Activities Officer: Hussein Al-Mustafa. Financial Officer: Anas Al-Hamad. Media Officer: Zaid Haj Musa. Student Affairs Officer: Omar Abdullah.',
      tr: 'Birlik Başkanı: Kenan Abdullah. Etkinlikler Görevlisi: Hussein Al-Mustafa. Mali Görevli: Anas Al-Hamad. Medya Görevlisi: Zaid Haj Musa. Öğrenci İşleri Görevlisi: Omar Abdullah.'
    },
    notes: {
      ar: 'لا يوجد',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/iskandarun-logo.png'
  },
  "اتحاد الفرات": {
    aboutDescription: {
      ar: 'اتحاد الفرات يخدم الطلبة السوريين في مدينة ايلازيغ. يعمل الاتحاد على دعم الطلاب أكاديمياً واجتماعياً وثقافياً، من خلال تنظيم ورش العمل والدورات التدريبية والأنشطة المتنوعة. يسعى الاتحاد لخلق بيئة تعليمية محفزة ومجتمع طلابي متماسك.',
      en: 'Euphrates Union serves Syrian students in the city of Elazig. The union works to support students academically, socially, and culturally, through organizing workshops, training courses, and various activities. The union strives to create an inspiring educational environment and a cohesive student community.',
      tr: 'Fırat Birliği, Elazığ şehrindeki Suriyeli öğrencilere hizmet verir. Birlik, atölye çalışmaları, eğitim kursları ve çeşitli etkinlikler düzenleyerek öğrencilere akademik, sosyal ve kültürel olarak destek sağlamak için çalışır. Birlik, ilham verici bir eğitim ortamı ve uyumlu bir öğrenci topluluğu yaratmaya çalışır.'
    },
    cardDescription: {
      ar: 'اتحاد الفرات - اتحاد يخدم الطلبة السوريين في مدينة ايلازيغ.',
      en: 'Euphrates Union - A union serving Syrian students in the city of Elazig.',
      tr: 'Fırat Birliği - Elazığ şehrindeki Suriyeli öğrencilere hizmet veren bir birlik.'
    },
    contactNumber: {
      ar: '05357393117',
      en: '05357393117',
      tr: '05357393117'
    },
    activitiesAndAchievements: {
      ar: 'بطولة شطرنج. ملتقى الأثر. حفل تخرج دفعة التمكين. توثيق ممثلية ولاية للاتحاد العام. زيارات رسمية إلى إدارة الهجرة في المدينة. لقاء إعلامي مع قناتي 23 و Firat. زيارات رسمية إلى بعض الجمعيات في المدينة مثل منظمة فجر وجمعية ilim yayma.',
      en: 'Chess championship. Al-Athar gathering. Empowerment batch graduation ceremony. Documenting state representation for the General Union. Official visits to the city\'s immigration administration. Media interview with channels 23 and Firat. Official visits to some associations in the city such as Fajr organization and ilim yayma association.',
      tr: 'Satranç şampiyonası. El-Eser buluşması. Güçlendirme grubu mezuniyet töreni. Genel Birlik için eyalet temsilciliğinin belgelenmesi. Şehrin göç idaresine resmi ziyaretler. 23 ve Firat kanallarıyla medya görüşmesi. Şehirdeki bazı derneklere resmi ziyaretler (Fecr organizasyonu ve ilim yayma derneği gibi).'
    },
    specialAchievements: {
      ar: 'توثيق ممثلية ولاية للاتحاد العام ولقاء إعلامي مع قناتي 23 و firat.',
      en: 'Documenting state representation for the General Union and media interview with channels 23 and Firat.',
      tr: 'Genel Birlik için eyalet temsilciliğinin belgelenmesi ve 23 ve Firat kanallarıyla medya görüşmesi.'
    },
    currentAdministrativeTeam: {
      ar: 'يتبع نظام مجلس الشورى، الذي يُعد الجهة العليا في اتخاذ القرارات داخل الاتحاد. مجلس الشورى: يتكون من ستة أعضاء، إضافة إلى الممثل العام للمجلس. أعضاء آخرون: أعضاء المكاتب الذين يشرفون على مختلف الجوانب التنظيمية والإدارية، وفريق المتطوعين.',
      en: 'Follows the Shura Council system, which is the highest authority in decision-making within the union. Shura Council: Consists of six members, in addition to the general representative of the council. Other members: Office members who supervise various organizational and administrative aspects, and the volunteer team.',
      tr: 'Birlik içinde karar alma konusunda en yüksek otorite olan Şura Konseyi sistemini takip eder. Şura Konseyi: Konseyin genel temsilcisine ek olarak altı üyeden oluşur. Diğer üyeler: Çeşitli organizasyonel ve idari yönleri denetleyen ofis üyeleri ve gönüllü ekip.'
    },
    notes: {
      ar: 'في الأيام القريبة القادمة سيتم تغيير الهوية البصرية ولوغو الاتحاد.',
      en: 'In the near future, the union\'s visual identity and logo will be changed.',
      tr: 'Yakın gelecekte birliğin görsel kimliği ve logosu değiştirilecek.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في مدينة إسبارطة": {
    aboutDescription: {
      ar: 'تجمع طلابي نقابي تطوعي منتخب ومستقل يستمد شرعيته من الطلبة السوريين. يعمل على تمثيل الطلبة والدفاع عن مصالحهم الأكاديمية والاجتماعية وتعزيز التواصل والتعاون. يتمحور حول بناء مجتمع طلابي متماسك وتقديم الدعم الأكاديمي والخدمي وتنظيم الأنشطة الثقافية والترفيهية وتمكين الطلبة.',
      en: 'An elected, independent voluntary student union gathering that derives its legitimacy from Syrian students. It works to represent students and defend their academic and social interests and enhance communication and cooperation. It revolves around building a cohesive student community and providing academic and service support, organizing cultural and recreational activities, and empowering students.',
      tr: 'Suriyeli öğrencilerden meşruiyetini alan seçilmiş, bağımsız gönüllü bir öğrenci birliği topluluğu. Öğrencileri temsil etmek, akademik ve sosyal çıkarlarını savunmak ve iletişim ve işbirliğini geliştirmek için çalışır. Uyumlu bir öğrenci topluluğu oluşturmaya, akademik ve hizmet desteği sağlamaya, kültürel ve rekreasyon etkinliklerini organize etmeye ve öğrencileri güçlendirmeye odaklanır.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في مدينة إسبارطة - تجمع طلابي منتخب ومستقل يعمل على تمثيل الطلبة.',
      en: 'Syrian Students Union in Isparta City - An elected, independent student gathering working to represent students.',
      tr: 'Isparta Şehri Suriyeli Öğrenci Birliği - Öğrencileri temsil etmek için çalışan seçilmiş, bağımsız bir öğrenci topluluğu.'
    },
    contactNumber: {
      ar: '+905350864657',
      en: '+905350864657',
      tr: '+905350864657'
    },
    activitiesAndAchievements: {
      ar: 'حفل تخرج تحت عنوان بناة دمشق. دورة تقوية في مادة الرياضيات. دورة تقوية للغة التركية. ورشة عمل فنون النسيج. دوري كرة قدم. تأمين دعم مادي مباشر لعدد للطلاب إلى جانب تأمين منح دراسية. المشاركة في ليلة الثقافات. إقامة العديد من الإفطارات خلال شهر رمضان. المشاركة في مهرجان الورد في مدينة إسبارطة. إقامة مؤتمر من إسبارطة هنا غزة. إحياء الذكرى الرابعة عشر للثورة السورية. إقامة حفل النصر تحت عنوان مسرى النصر.',
      en: 'Graduation ceremony under the title "Builders of Damascus". Mathematics reinforcement course. Turkish language reinforcement course. Textile arts workshop. Football league. Securing direct financial support for a number of students in addition to securing scholarships. Participation in Culture Night. Organizing many Iftars during the month of Ramadan. Participation in the Rose Festival in Isparta city. Organizing the conference "From Isparta, Here is Gaza". Commemorating the fourteenth anniversary of the Syrian Revolution. Organizing Victory ceremony under the title "Path of Victory".',
      tr: '"Şam\'ın İnşaatçıları" başlığı altında mezuniyet töreni. Matematik takviye kursu. Türkçe takviye kursu. Tekstil sanatları atölyesi. Futbol ligi. Bir dizi öğrenci için burs sağlamanın yanı sıra doğrudan mali destek sağlamak. Kültür Gecesi\'ne katılım. Ramazan ayı boyunca birçok İftar düzenlemek. Isparta şehrindeki Gül Festivali\'ne katılım. "Isparta\'dan, İşte Gazze" konferansını düzenlemek. Suriye Devrimi\'nin on dördüncü yıldönümünü anmak. "Zafer Yolu" başlığı altında Zafer töreni düzenlemek.'
    },
    specialAchievements: {
      ar: 'إقامة مؤتمر "من إسبارطة هنا غزة"، الذي هدف لدعم أهل غزة وتم خلاله جمع تبرعات بلغت 14,000 ليرة تركية، وتبعه إطلاق حملة "من إسبارطة هنا غزة 2" التي جمعت 25,000 ليرة تركية إضافية.',
      en: 'Organizing the conference "From Isparta, Here is Gaza", which aimed to support the people of Gaza and collected donations amounting to 14,000 Turkish lira, followed by launching the campaign "From Isparta, Here is Gaza 2" which collected an additional 25,000 Turkish lira.',
      tr: 'Gazze halkını desteklemeyi amaçlayan ve 14,000 Türk lirası bağış toplayan "Isparta\'dan, İşte Gazze" konferansını düzenlemek, ardından ek 25,000 Türk lirası toplayan "Isparta\'dan, İşte Gazze 2" kampanyasını başlatmak.'
    },
    currentAdministrativeTeam: {
      ar: 'يضم ثمانية أعضاء إداريين، وهم يشغلون مهام مسؤولي المكاتب وأعضاء الهيئة الرقابية، إضافة إلى رئيس الاتحاد ونائب الرئيس. المكاتب الإدارية: المكتب الإعلامي، مكتب شؤون الطلبة، مكتب الثقافة والترفيه، مكتب العلاقات العامة، مسؤولة الطالبات.',
      en: 'Includes eight administrative members, who hold the positions of office heads and supervisory body members, in addition to the union president and vice president. Administrative Offices: Media Office, Student Affairs Office, Culture and Entertainment Office, Public Relations Office, Female Students Officer.',
      tr: 'Birlik başkanı ve başkan yardımcısına ek olarak ofis başkanları ve denetim kurulu üyeleri pozisyonlarını tutan sekiz yönetim üyesini içerir. Yönetim Ofisleri: Medya Ofisi, Öğrenci İşleri Ofisi, Kültür ve Eğlence Ofisi, Halkla İlişkiler Ofisi, Kız Öğrenci Görevlisi.'
    },
    notes: {
      ar: 'يحرص على تعزيز روح الانتماء والمسؤولية بين الطلبة السوريين وترسيخ قيم التعاون والعمل الجماعي.',
      en: 'It strives to enhance the spirit of belonging and responsibility among Syrian students and establish values of cooperation and teamwork.',
      tr: 'Suriyeli öğrenciler arasında aidiyet ve sorumluluk ruhunu geliştirmeye ve işbirliği ve takım çalışması değerlerini yerleştirmeye çalışır.'
    },
    logo: './assets/subunions/isbarta-logo.jpg'
  },
  "اتحاد الطلبة السوريين في كلس": {
    aboutDescription: {
      ar: 'إتحاد الطلبة السوريين في كلس "طلبة اليوم قادة الغد".',
      en: 'Syrian Students Union in Kilis "Today\'s Students, Tomorrow\'s Leaders".',
      tr: 'Kilis\'teki Suriyeli Öğrenci Birliği "Bugünün Öğrencileri, Yarının Liderleri".'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في كلس - "طلبة اليوم قادة الغد".',
      en: 'Syrian Students Union in Kilis - "Today\'s Students, Tomorrow\'s Leaders".',
      tr: 'Kilis\'teki Suriyeli Öğrenci Birliği - "Bugünün Öğrencileri, Yarının Liderleri".'
    },
    contactNumber: {
      ar: '05510599459',
      en: '05510599459',
      tr: '05510599459'
    },
    activitiesAndAchievements: {
      ar: 'رحلة طلابية إلى مدينة حلب وتخللها لقاء مع رئيس جامعة حلب ومحافظ حلب. زيارة رسمية إلى معاون والي كلس السيد مراد دمير بلاك لمناقشة تحديات الطلبة. إعفاء الطلاب المستجدين من قسط الجامعة (فصل). حفل التخرج الرسمي لدفعة عام 2025 تحت شعار دفعة الأمل والإرادة.',
      en: 'Student trip to Aleppo city including a meeting with the president of Aleppo University and the governor of Aleppo. Official visit to Kilis Deputy Governor Mr. Murat Demir Black to discuss student challenges. Exemption of new students from university tuition (semester). Official graduation ceremony for the class of 2025 under the slogan "Class of Hope and Will".',
      tr: 'Halep şehrine öğrenci gezisi, Halep Üniversitesi rektörü ve Halep valisi ile toplantı dahil. Öğrenci zorluklarını görüşmek için Kilis Vali Yardımcısı Sayın Murat Demir Black\'e resmi ziyaret. Yeni öğrencilerin üniversite harçlarından muafiyeti (dönem). "Umut ve İrade Sınıfı" sloganı altında 2025 mezunları için resmi mezuniyet töreni.'
    },
    specialAchievements: {
      ar: 'تنظيم رحلة طلابية إلى مدينة حلب للقاء رئيس جامعة حلب ومحافظ حلب، وزيارة معاون والي كلس.',
      en: 'Organizing a student trip to Aleppo city to meet the president of Aleppo University and the governor of Aleppo, and visiting the deputy governor of Kilis.',
      tr: 'Halep Üniversitesi rektörü ve Halep valisi ile buluşmak için Halep şehrine öğrenci gezisi düzenlemek ve Kilis vali yardımcısını ziyaret etmek.'
    },
    currentAdministrativeTeam: {
      ar: 'حالياً في فترة انتخابات.',
      en: 'Currently in election period.',
      tr: 'Şu anda seçim döneminde.'
    },
    notes: {
      ar: 'لا',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: './assets/subunions/killis-logo.png'
  },
  "اتحاد بولو": {
    aboutDescription: {
      ar: 'اتحاد بولو يجمع الطلبة السوريين في مدينة بولو. يتميز الاتحاد باهتمامه بالأنشطة الثقافية والترفيهية، حيث ينظم فعاليات متنوعة تجمع بين التعليم والترفيه. يعمل الاتحاد على بناء مجتمع طلابي قوي ومتماسك.',
      en: 'Bolu Union brings together Syrian students in the city of Bolu. The union is distinguished by its interest in cultural and recreational activities, organizing various events that combine education and entertainment. The union works to build a strong and cohesive student community.',
      tr: 'Bolu Birliği, Bolu şehrindeki Suriyeli öğrencileri bir araya getirir. Birlik, eğitim ve eğlenceyi birleştiren çeşitli etkinlikler düzenleyerek kültürel ve rekreasyon etkinliklerine olan ilgisiyle öne çıkar. Birlik, güçlü ve uyumlu bir öğrenci topluluğu oluşturmak için çalışır.'
    },
    cardDescription: {
      ar: 'اتحاد في بولو يركز على الأنشطة الثقافية والترفيهية وبناء المجتمع الطلابي.',
      en: 'A union in Bolu focusing on cultural and recreational activities and building student community.',
      tr: 'Bolu\'daki kültürel ve rekreasyon etkinliklerine ve öğrenci topluluğu oluşturmaya odaklanan bir birlik.'
    },
    contactNumber: {
      ar: '+90 312 XXX XXXX',
      en: '+90 312 XXX XXXX',
      tr: '+90 312 XXX XXXX'
    },
    activitiesAndAchievements: {
      ar: 'مؤتمرات وندوات علمية، برامج تدريبية في المهارات القيادية، ورش عمل في ريادة الأعمال، خدمات التوجيه والإرشاد.',
      en: 'Scientific conferences and seminars, leadership skills training programs, entrepreneurship workshops, orientation and guidance services.',
      tr: 'Bilimsel konferanslar ve seminerler, liderlik becerileri eğitim programları, girişimcilik atölye çalışmaları, oryantasyon ve rehberlik hizmetleri.'
    },
    specialAchievements: {
      ar: 'تنظيم مؤتمر قيادة طلابي دولي، إطلاق برنامج ريادة الأعمال، فوز بجائزة التميز في القيادة.',
      en: 'Organizing an international student leadership conference, launching an entrepreneurship program, winning Leadership Excellence Award.',
      tr: 'Uluslararası öğrenci liderliği konferansı düzenlemek, girişimcilik programı başlatmak, Liderlik Mükemmellik Ödülü kazanmak.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: خالد محمود، نائب الرئيس: سمر علي، أمين السر: طارق يوسف، أمين الصندوق: ناديا حسن.',
      en: 'President: Khaled Mahmoud, Vice President: Samar Ali, Secretary: Tariq Youssef, Treasurer: Nadia Hassan.',
      tr: 'Başkan: Khaled Mahmoud, Başkan Yardımcısı: Samar Ali, Sekreter: Tariq Youssef, Sayman: Nadia Hassan.'
    },
    notes: {
      ar: 'الاتحاد رائد في مجال القيادة الطلابية وريادة الأعمال. يقدم برامج متميزة للطلاب الطموحين.',
      en: 'The union is a leader in student leadership and entrepreneurship. Provides outstanding programs for ambitious students.',
      tr: 'Birlik, öğrenci liderliği ve girişimcilik alanında öncüdür. Hırslı öğrenciler için seçkin programlar sunar.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة باموكالي": {
    aboutDescription: {
      ar: 'تأسس لتوحيد الجهود لتمثيل طلاب الوطن في الغربة، ونقل صوتهم، وخدمة قضاياهم التعليمية والاجتماعية والوطنية، ويجمع الطلاب السوريين تحت راية واحدة هي راية سورية المجيدة.',
      en: 'Established to unify efforts to represent students of the homeland in exile, convey their voice, and serve their educational, social, and national causes, bringing Syrian students together under one banner, the banner of glorious Syria.',
      tr: 'Sürgündeki vatan öğrencilerini temsil etmek, seslerini duyurmak ve eğitim, sosyal ve ulusal davalarına hizmet etmek için çabaları birleştirmek üzere kuruldu ve Suriyeli öğrencileri tek bir bayrak altında, şanlı Suriye bayrağı altında bir araya getiriyor.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة باموكالي - توحيد الجهود لتمثيل الطلاب وخدمة قضاياهم.',
      en: 'Syrian Students Union at Pamukkale University - Unifying efforts to represent students and serve their causes.',
      tr: 'Pamukkale Üniversitesi Suriyeli Öğrenci Birliği - Öğrencileri temsil etmek ve davalarına hizmet etmek için çabaları birleştirmek.'
    },
    contactNumber: {
      ar: '+905316118340 / +905522888327',
      en: '+905316118340 / +905522888327',
      tr: '+905316118340 / +905522888327'
    },
    activitiesAndAchievements: {
      ar: 'ملتقى طلابي بداية العام الدراسي. نزهة شواء في غابة التشاملك. ندوة سوريا جارتنا القريبة باللغة التركية. فعالية ردع العدوان. فعالية الذكرى السنوية للثورة السورية وإفطار صائم. مسرحية الخوف من الباب الوحيد. فعالية التعريف بالتراث والثقافة السورية. دورة مجانية لتعليم برامج الأوفيس بالتعاون مع الاتحاد العام. حفل تخريج دفعة النصر 2025.',
      en: 'Student gathering at the beginning of the academic year. Barbecue outing in Çamlık Forest. Seminar "Syria, our close neighbor" in Turkish. Deterrence of aggression event. Syrian Revolution anniversary event and Iftar. Play "Fear of the Only Door". Event introducing Syrian heritage and culture. Free course teaching Office programs in cooperation with the General Union. Al-Nasr batch 2025 graduation ceremony.',
      tr: 'Akademik yılın başında öğrenci buluşması. Çamlık Ormanı\'nda mangal gezisi. Türkçe "Suriye, yakın komşumuz" semineri. Saldırganlığı caydırma etkinliği. Suriye Devrimi yıldönümü etkinliği ve İftar. "Tek Kapıdan Korku" oyunu. Suriye mirası ve kültürünü tanıtma etkinliği. Genel Birlik ile işbirliği içinde Office programlarını öğreten ücretsiz kurs. El-Nasr grubu 2025 mezuniyet töreni.'
    },
    specialAchievements: {
      ar: 'الدورة التعليمية، فعالية التعريف بالثقافة السورية في حرم الجامعة، فعالية ذكرى الثورة، حفل الخريجين.',
      en: 'Educational course, event introducing Syrian culture on campus, Revolution anniversary event, graduation ceremony.',
      tr: 'Eğitim kursu, kampüste Suriye kültürünü tanıtma etkinliği, Devrim yıldönümü etkinliği, mezuniyet töreni.'
    },
    currentAdministrativeTeam: {
      ar: 'الرئيس: يزن لاطة. نائب الرئيس: أحمد دلال. المسؤولون: المسؤول العلمي والأكاديمي: سمير الترزي، مسؤول العلاقات العامة: أحمد الحزوري، مسؤول المالية: مالك تامر، مسؤول الإعلام: وسيم نجار، مسؤول الثقافة والترفيه: أحمد العلي، مسؤول الرياضة: محمد ناصر الحسن، مسؤولة شؤون الطالبات: ريان الديري.',
      en: 'President: Yazan Lata. Vice President: Ahmad Dalal. Officers: Scientific and Academic Officer: Samir al-Tarzi, Public Relations Officer: Ahmad al-Hazouri, Financial Officer: Malek Tamer, Media Officer: Wasim Najjar, Culture and Entertainment Officer: Ahmad al-Ali, Sports Officer: Muhammad Nasser al-Hassan, Female Students Affairs Officer: Rayan al-Dairi.',
      tr: 'Başkan: Yazan Lata. Başkan Yardımcısı: Ahmad Dalal. Görevliler: Bilimsel ve Akademik Görevli: Samir el-Tarzi, Halkla İlişkiler Görevlisi: Ahmad el-Hazouri, Mali Görevli: Malek Tamer, Medya Görevlisi: Wasim Najjar, Kültür ve Eğlence Görevlisi: Ahmad el-Ali, Spor Görevlisi: Muhammed Nasser el-Hassan, Kız Öğrenci İşleri Görevlisi: Rayan el-Dairi.'
    },
    notes: {
      ar: 'هذه السنة توجد عدة أفكار تسعى لتطبيقها وإنجاحها ثم السعي لتعميمها بالاتحاد العام لكي تتحقق الفائدة لدى الجميع.',
      en: 'This year there are several ideas that we seek to implement and succeed in, then work to generalize them in the General Union so that everyone benefits.',
      tr: 'Bu yıl uygulamaya koymak ve başarılı olmak için çalıştığımız, ardından herkesin faydalanması için Genel Birlik\'te genelleştirmeye çalıştığımız birkaç fikir var.'
    },
    logo: './assets/subunions/pamukali-logo.png'
  },
  "اتحاد الطلبة السوريين كاستامونو": {
    aboutDescription: {
      ar: 'يهدف إلى مساعدة الطلبة في حل مشاكلهم الجامعية، وخاصة طلاب السنة الأولى، والسعي لتأهيل طلاب قادرين على إدارة الاتحاد في الأعوام المقبلة.',
      en: 'Aims to help students solve their university problems, especially first-year students, and seeks to train students capable of managing the union in the coming years.',
      tr: 'Öğrencilerin, özellikle birinci sınıf öğrencilerinin üniversite sorunlarını çözmelerine yardımcı olmayı ve gelecek yıllarda birliği yönetebilecek öğrencileri yetiştirmeyi amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين كاستامونو - يهدف إلى مساعدة الطلبة في حل مشاكلهم الجامعية.',
      en: 'Syrian Students Union Kastamonu - Aims to help students solve their university problems.',
      tr: 'Kastamonu Suriyeli Öğrenci Birliği - Öğrencilerin üniversite sorunlarını çözmelerine yardımcı olmayı amaçlar.'
    },
    contactNumber: {
      ar: '05366893171 (رئيس الاتحاد صالح خالدي) / 05343300759 (مكتب الرقابة عباس مخيبر)',
      en: '05366893171 (Union President Saleh Khalidi) / 05343300759 (Supervision Office Abbas Mukhaybir)',
      tr: '05366893171 (Birlik Başkanı Saleh Khalidi) / 05343300759 (Denetim Ofisi Abbas Mukhaybir)'
    },
    activitiesAndAchievements: {
      ar: 'ملتقى طلابي. يوم اللغة العربية. فعالية ذكرى الثورة السورية. رحلة إلى مدينة Cide. فعالية اليوم الثقافي في الجامعة. ندوات عن القضية الفلسطينية.',
      en: 'Student gathering. Arabic Language Day. Syrian Revolution commemoration event. Trip to Cide city. Cultural Day event at the university. Seminars about the Palestinian cause.',
      tr: 'Öğrenci buluşması. Arapça Günü. Suriye Devrimi anma etkinliği. Cide şehrine gezi. Üniversitede Kültür Günü etkinliği. Filistin davası hakkında seminerler.'
    },
    specialAchievements: {
      ar: 'التركيز على تنفيذ الأساسيات ضمن الإمكانيات المحدودة في مدينة كاستامونو الصغيرة، والنجاح الملموس في أغلب الفعاليات رغم إعادة تفعيل الاتحاد مؤخراً.',
      en: 'Focusing on implementing basics within limited resources in the small city of Kastamonu, and tangible success in most activities despite the union\'s recent reactivation.',
      tr: 'Küçük Kastamonu şehrinde sınırlı kaynaklar içinde temelleri uygulamaya odaklanmak ve birliğin yakın zamanda yeniden etkinleştirilmesine rağmen çoğu etkinlikte somut başarı.'
    },
    currentAdministrativeTeam: {
      ar: 'مكتب الرئاسي: صالح الخالدي. مكتب الرقابة: عباس مخيبر. مكتب الإعلام: ميسم خليل. مكتب شؤون الطلبة: محمد الصافي. مكتب الأنشطة: دعاء جراد.',
      en: 'Presidential Office: Saleh Al-Khalidi. Supervision Office: Abbas Mukhaybir. Media Office: Maysam Khalil. Student Affairs Office: Mohammed Al-Safi. Activities Office: Duaa Jarad.',
      tr: 'Başkanlık Ofisi: Saleh Al-Khalidi. Denetim Ofisi: Abbas Mukhaybir. Medya Ofisi: Maysam Khalil. Öğrenci İşleri Ofisi: Mohammed Al-Safi. Etkinlikler Ofisi: Duaa Jarad.'
    },
    notes: {
      ar: 'لا',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في كوجالي": {
    aboutDescription: {
      ar: 'يضم ما يقارب 220 طالب سوري ويهدف إلى تمثيل الطلاب في الجامعات الثلاث الموجودة في المدينة، ويحاول أن يحقق مطالبهم ويدافع عن حقوقهم.',
      en: 'Includes approximately 220 Syrian students and aims to represent students in the three universities in the city, and seeks to achieve their demands and defend their rights.',
      tr: 'Yaklaşık 220 Suriyeli öğrenciyi içerir ve şehirdeki üç üniversitedeki öğrencileri temsil etmeyi, taleplerini gerçekleştirmeyi ve haklarını savunmayı amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في كوجالي - يضم حوالي 220 طالب ويهدف إلى تمثيل الطلاب والدفاع عن حقوقهم.',
      en: 'Syrian Students Union in Kocaeli - Includes approximately 220 students and aims to represent students and defend their rights.',
      tr: 'Kocaeli\'deki Suriyeli Öğrenci Birliği - Yaklaşık 220 öğrenciyi içerir ve öğrencileri temsil etmeyi ve haklarını savunmayı amaçlar.'
    },
    contactNumber: {
      ar: '05370265032',
      en: '05370265032',
      tr: '05370265032'
    },
    activitiesAndAchievements: {
      ar: 'مناظرة وتعاون مع جمعية تركية. رحلات ترفيهية. دورات تقوية لأعضاء الاتحاد. إفطارات رمضانية مع دروس توعوية وتربوية دينية.',
      en: 'Debate and cooperation with a Turkish association. Recreational trips. Strengthening courses for union members. Ramadan Iftars with educational and religious awareness lessons.',
      tr: 'Türk bir dernekle tartışma ve işbirliği. Eğlence gezileri. Birlik üyeleri için güçlendirme kursları. Eğitici ve dini farkındalık dersleriyle Ramazan İftarları.'
    },
    specialAchievements: {
      ar: 'فعالية المناظرة، حيث سلطت الضوء على السوريين والهجرة في تركيا ولفتت انتباه الأتراك في المدينة.',
      en: 'The debate event, which shed light on Syrians and immigration in Turkey and drew the attention of Turks in the city.',
      tr: 'Suriyeliler ve Türkiye\'deki göçe ışık tutan ve şehirdeki Türklerin dikkatini çeken tartışma etkinliği.'
    },
    currentAdministrativeTeam: {
      ar: 'رئيس اتحاد. نائب رئيس الاتحاد. مكتب أنشطة. مكتب إعلامي. مسؤول مالي.',
      en: 'Union President. Vice President of the Union. Activities Office. Media Office. Financial Officer.',
      tr: 'Birlik Başkanı. Birlik Başkan Yardımcısı. Etkinlikler Ofisi. Medya Ofisi. Mali Görevli.'
    },
    notes: {
      ar: 'لا يوجد',
      en: 'No additional notes.',
      tr: 'Ek not yok.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في كوتاهيا": {
    aboutDescription: {
      ar: 'كيان طلابي منتخب يستمد شرعيته من الطلبة المنتسبين له ويتبع الاتحاد العام لطلبة سوريا. يهدف إلى تمثيل الطلبة السوريين والدفاع عن حقوقهم، وتعزيز روح العمل الجماعي والنقابي، وتنمية دور الشباب الجامعي في الحراك المجتمعي.',
      en: 'An elected student entity that derives its legitimacy from affiliated students and follows the General Union of Syrian Students. It aims to represent Syrian students and defend their rights, strengthen the spirit of collective and union work, and develop the role of university youth in community movement.',
      tr: 'Bağlı öğrencilerden meşruiyetini alan ve Suriye Öğrenci Genel Birliği\'ne bağlı seçilmiş bir öğrenci varlığı. Suriyeli öğrencileri temsil etmeyi ve haklarını savunmayı, kolektif ve sendika çalışması ruhunu güçlendirmeyi ve üniversite gençliğinin toplumsal hareket içindeki rolünü geliştirmeyi amaçlar.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في كوتاهيا - كيان طلابي منتخب يهدف إلى تمثيل الطلبة والدفاع عن حقوقهم.',
      en: 'Syrian Students Union in Kutahya - An elected student entity aiming to represent students and defend their rights.',
      tr: 'Kütahya\'daki Suriyeli Öğrenci Birliği - Öğrencileri temsil etmeyi ve haklarını savunmayı amaçlayan seçilmiş bir öğrenci varlığı.'
    },
    contactNumber: {
      ar: '05373542742',
      en: '05373542742',
      tr: '05373542742'
    },
    activitiesAndAchievements: {
      ar: 'حفل التخرج \'حفل النصر\' بمشاركة 96 خريجاً وحضور تجاوز 450 شخصاً. إطلاق مبادرة لتغطية أقساط الطلبة، جمعت ما يزيد على 80,000 ليرة تركية دعماً للطلبة المحتاجين. تقديم دعم قانوني من خلال مساعدة عدد من الطلبة السوريين والعرب في قضاياهم القانونية. تقديم خدمات جامعية في مجالات القبول والتسجيل، حيث تمت مساعدة أكثر من 120 طالباً وطالبة. تنفيذ مشروع بعنوان \'مسائل وحلول\' لدعم طلبة التخصصات الهندسية عبر ورش تعليمية وتطبيقية. تنظيم فعاليات توعوية بالتعاون مع مؤسسات المجتمع المدني. تمثيل التراث السوري في فعاليات يوم الثقافة بالجامعة. إقامة ملتقيات طلابية تناولت أهمية وآليات وأبعاد العمل التطوعي. تنظيم أنشطة ثقافية وترفيهية (رحلات جماعية، حملات إفطار الصائم، حفل إفطار رمضاني موسع). إقامة دوري لكرة القدم والمشاركة في بطولات متعددة.',
      en: 'Graduation ceremony \'Victory Ceremony\' with participation of 96 graduates and attendance exceeding 450 people. Launching an initiative to cover student tuition fees, collecting more than 80,000 Turkish lira in support of needy students. Providing legal support by helping a number of Syrian and Arab students in their legal cases. Providing university services in admission and registration, where more than 120 students were assisted. Implementing a project titled \'Problems and Solutions\' to support engineering students through educational and practical workshops. Organizing awareness events in cooperation with civil society institutions. Representing Syrian heritage at university Culture Day events. Holding student gatherings addressing the importance, mechanisms and dimensions of volunteer work. Organizing cultural and recreational activities (group trips, Iftar campaigns, expanded Ramadan Iftar ceremony). Establishing a football league and participating in multiple championships.',
      tr: '96 mezunun katılımı ve 450\'yi aşan katılımla mezuniyet töreni \'Zafer Töreni\'. Öğrenci harçlarını karşılamak için bir girişim başlatmak, ihtiyaç sahibi öğrencilere destek olarak 80,000\'den fazla Türk lirası toplamak. Bir dizi Suriyeli ve Arap öğrenciye yasal davalarında yardımcı olarak yasal destek sağlamak. Kabul ve kayıt alanlarında üniversite hizmetleri sağlamak, 120\'den fazla öğrenciye yardımcı olundu. Mühendislik öğrencilerini eğitim ve pratik atölyeler aracılığıyla desteklemek için \'Sorunlar ve Çözümler\' başlıklı bir proje uygulamak. Sivil toplum kuruluşları ile işbirliği içinde farkındalık etkinlikleri düzenlemek. Üniversite Kültür Günü etkinliklerinde Suriye mirasını temsil etmek. Gönüllü çalışmanın önemi, mekanizmaları ve boyutlarını ele alan öğrenci buluşmaları düzenlemek. Kültürel ve rekreasyon etkinlikleri düzenlemek (grup gezileri, İftar kampanyaları, genişletilmiş Ramazan İftar töreni). Bir futbol ligi kurmak ve birden fazla şampiyonaya katılmak.'
    },
    specialAchievements: {
      ar: 'في قادم الأيام نعم، مثل إقامة منتدى النصر، بتاريخ 12/06/07/08.',
      en: 'Yes, in the coming days, such as holding the Victory Forum, on dates 12/06/07/08.',
      tr: 'Evet, önümüzdeki günlerde, 12/06/07/08 tarihlerinde Zafer Forumu\'nu düzenlemek gibi.'
    },
    currentAdministrativeTeam: {
      ar: 'يتكون من هيئتين أساسيتين: الهيئة الإدارية (5 أعضاء)، والهيئة الرقابية (3 أعضاء). الهيئة الإدارية: تضم 5 أعضاء، يتولون إدارة شؤون الاتحاد وتنظيم النشاطات والإشراف على الخطط التنفيذية، ويندرج تحتها مكاتب فرعية تستحدث حسب الحاجة. الهيئة الرقابية: تضم 3 أعضاء، وتعمل على متابعة الأداء الإداري وضمان الالتزام بالأنظمة الداخلية والشفافية.',
      en: 'Consists of two main bodies: Administrative Body (5 members), and Supervisory Body (3 members). Administrative Body: Includes 5 members who manage union affairs, organize activities and supervise executive plans, with sub-offices created as needed. Supervisory Body: Includes 3 members, working on monitoring administrative performance and ensuring compliance with internal regulations and transparency.',
      tr: 'İki ana organdan oluşur: Yönetim Kurulu (5 üye) ve Denetim Kurulu (3 üye). Yönetim Kurulu: Birlik işlerini yöneten, etkinlikleri organize eden ve yürütme planlarını denetleyen 5 üyeyi içerir, gerektiğinde alt ofisler oluşturulur. Denetim Kurulu: İdari performansı izleyen ve iç düzenlemelere ve şeffaflığa uyumu sağlayan 3 üyeyi içerir.'
    },
    notes: {
      ar: 'يهدف إلى تعزيز الوعي الاستراتيجي لدى الأفراد والمؤسسات بما يضمن تحويل العمل المؤسسي إلى منظومة متكاملة من التخطيط والتنفيذ، والمساءلة.',
      en: 'It aims to enhance strategic awareness among individuals and institutions to ensure transforming institutional work into an integrated system of planning, implementation, and accountability.',
      tr: 'Kurumsal çalışmayı planlama, uygulama ve hesap verebilirlikten oluşan entegre bir sisteme dönüştürmeyi sağlamak için bireyler ve kurumlar arasında stratejik farkındalığı artırmayı amaçlar.'
    },
    logo: ''
  },
  "اتحاد الطلبة السوريين في جامعة أوشاك": {
    aboutDescription: {
      ar: 'لا يوجد',
      en: 'No description available.',
      tr: 'Açıklama mevcut değil.'
    },
    cardDescription: {
      ar: 'اتحاد الطلبة السوريين في جامعة أوشاك.',
      en: 'Syrian Students Union at Uşak University.',
      tr: 'Uşak Üniversitesi Suriyeli Öğrenci Birliği.'
    },
    contactNumber: {
      ar: '05526210258',
      en: '05526210258',
      tr: '05526210258'
    },
    activitiesAndAchievements: {
      ar: 'ملتقى الطلاب الثقافي في الجامعة. حفل تخرج الطلاب السوريين "دفعة النصر".',
      en: 'Student cultural gathering at the university. Syrian students graduation ceremony "Victory Batch".',
      tr: 'Üniversitede öğrenci kültürel buluşması. Suriyeli öğrenciler mezuniyet töreni "Zafer Grubu".'
    },
    specialAchievements: {
      ar: 'لا يوجد',
      en: 'No special achievements.',
      tr: 'Özel başarı yok.'
    },
    currentAdministrativeTeam: {
      ar: 'عدد الأعضاء: 16 عضو. الهيكل: مجلس الإدارة، المكتب الإعلامي، مكتب الأنشطة، مكتب شؤون الطلبة.',
      en: 'Number of members: 16 members. Structure: Board of Directors, Media Office, Activities Office, Student Affairs Office.',
      tr: 'Üye sayısı: 16 üye. Yapı: Yönetim Kurulu, Medya Ofisi, Etkinlikler Ofisi, Öğrenci İşleri Ofisi.'
    },
    notes: {
      ar: 'نحن في خدمة طلابنا دائماً',
      en: 'We are always at the service of our students.',
      tr: 'Her zaman öğrencilerimizin hizmetindeyiz.'
    },
    logo: ''
  }
};

export const offices = [
  // Board of Directors (مجلس الإدارة) - 6 members
  {
    id: 1,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'عبدالكريم قبلان', en: 'Abdul Karim Qabalan', tr: 'Abdul Karim Qabalan' },
    position: { ar: 'الأمين العام', en: 'Secretary General', tr: 'Genel Sekreter' },
    email: 'secretary@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/abulkerimNobg.png'
  },
  {
    id: 2,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'صَفِيَّـة قُطُـب', en: 'Safiya Qutb', tr: 'Safiya Qutb' },
    position: { ar: 'عضو مجلس الإدارة', en: 'Board Member', tr: 'Yönetim Kurulu Üyesi' },
    email: 'safiya@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/safyaQutp.png'
  },
  {
    id: 3,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'صدام جاسم', en: 'Saddam Jasim', tr: 'Saddam Jasim' },
    position: { ar: 'عضو مجلس الإدارة', en: 'Board Member', tr: 'Yönetim Kurulu Üyesi' },
    email: 'saddam@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 4,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'ملهم عمورة', en: 'Molham Ammora', tr: 'Molham Ammora' },
    position: { ar: 'عضو مجلس الإدارة', en: 'Board Member', tr: 'Yönetim Kurulu Üyesi' },
    email: 'molham@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/mulhamAlammor.png'
  },
  {
    id: 5,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'محمد الحسن', en: 'Mohammed Al-Hassan', tr: 'Mohammed Al-Hassan' },
    position: { ar: 'عضو مجلس الإدارة', en: 'Board Member', tr: 'Yönetim Kurulu Üyesi' },
    email: 'mohammed.h@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/muhammadalhasan.png'
  },
  {
    id: 6,
    category: 'board',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'دانيال حمزة', en: 'Daniel Hamza', tr: 'Daniel Hamza' },
    position: { ar: 'عضو مجلس الإدارة', en: 'Board Member', tr: 'Yönetim Kurulu Üyesi' },
    email: 'daniel@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/danialAyyash.png'
  },

  // Supervisory Body (الهيئة الرقابية) - 6 members
  {
    id: 7,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'محمد سيرجية', en: 'Mohammed Serjiya', tr: 'Mohammed Serjiya' },
    position: { ar: 'رئيس الهيئة الرقابية', en: 'President of the Supervisory Body', tr: 'Denetim Kurulu Başkanı' },
    email: 'supervision@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 8,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'أمجد ولو', en: 'Amjad Walo', tr: 'Amjad Walo' },
    position: { ar: 'عضو الهيئة الرقابية', en: 'Supervisory Member', tr: 'Denetim Üyesi' },
    email: 'amjad@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 9,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'نسيم الحسن', en: 'Naseem Al-Hassan', tr: 'Naseem Al-Hassan' },
    position: { ar: 'عضو الهيئة الرقابية', en: 'Supervisory Member', tr: 'Denetim Üyesi' },
    email: 'naseem@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 10,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'سعيد المصطفى', en: 'Saeed Al-Mustafa', tr: 'Saeed Al-Mustafa' },
    position: { ar: 'عضو الهيئة الرقابية', en: 'Supervisory Member', tr: 'Denetim Üyesi' },
    email: 'saeed@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 11,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'حلا تاجي', en: 'Hala Taji', tr: 'Hala Taji' },
    position: { ar: 'عضو الهيئة الرقابية', en: 'Supervisory Member', tr: 'Denetim Üyesi' },
    email: 'hala@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 12,
    category: 'supervisory',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'آية زكي', en: 'Aya Zaki', tr: 'Aya Zaki' },
    position: { ar: 'عضو الهيئة الرقابية', en: 'Supervisory Member', tr: 'Denetim Üyesi' },
    email: 'aya@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },

  // Electoral Commission (الهيئة الانتخابية) - 5 members
  {
    id: 13,
    category: 'electoral',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'أحمد غزال', en: 'Ahmed Ghazal', tr: 'Ahmed Ghazal' },
    position: { ar: 'رئيس الهيئة الانتخابية', en: 'Head of the Electoral Commission', tr: 'Seçim Komisyonu Başkanı' },
    email: 'ahmed.g@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 14,
    category: 'electoral',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'أدهم عبدالرزاق', en: 'Adham Abdulrazaq', tr: 'Adham Abdulrazaq' },
    position: { ar: 'عضو الهيئة الانتخابية', en: 'Electoral Member', tr: 'Seçim Üyesi' },
    email: 'adham@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 15,
    category: 'electoral',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'عبدالرحمن خضرو', en: 'Abdulrahman Khedro', tr: 'Abdulrahman Khedro' },
    position: { ar: 'عضو الهيئة الانتخابية', en: 'Electoral Member', tr: 'Seçim Üyesi' },
    email: 'abdulrahman@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 16,
    category: 'electoral',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'آية رشيد', en: 'Aya Rashid', tr: 'Aya Rashid' },
    position: { ar: 'عضو الهيئة الانتخابية', en: 'Electoral Member', tr: 'Seçim Üyesi' },
    email: 'aya.r@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 17,
    category: 'electoral',
    name: { ar: '', en: '', tr: '' },
    head: { ar: 'عماد زلحف', en: 'Imad Zalhaf', tr: 'Imad Zalhaf' },
    position: { ar: 'عضو الهيئة الانتخابية', en: 'Electoral Member', tr: 'Seçim Üyesi' },
    email: 'imad@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },

  // Offices & Executive Committees (المكاتب واللجان التنفيذية) - 12 offices
  {
    id: 18,
    category: 'offices',
    name: { ar: 'مكتب العلاقات العامة', en: 'Public Relations Office', tr: 'Halkla İlişkiler Ofisi' },
    head: { ar: 'سفيان الوقيان', en: 'Sufyan Al-Waqyan', tr: 'Sufyan Al-Waqyan' },
    email: 'pr@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 19,
    category: 'offices',
    name: { ar: 'مكتب إدارة المشاريع', en: 'Project Management Office', tr: 'Proje Yönetimi Ofisi' },
    head: { ar: 'خلاد السوادي', en: 'Khallad Al-Sawadi', tr: 'Khallad Al-Sawadi' },
    email: 'projects@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 20,
    category: 'offices',
    name: { ar: 'المكتب الإعلامي', en: 'Media Office', tr: 'Medya Ofisi' },
    head: { ar: 'المعتصم بالله قشيط', en: 'Al-Mutasim Billah Qashit', tr: 'Al-Mutasim Billah Qashit' },
    email: 'media@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 21,
    category: 'offices',
    name: { ar: 'المكتب الثقافي', en: 'Cultural Office', tr: 'Kültür Ofisi' },
    head: { ar: 'مناف برجس', en: 'Manaf Barjas', tr: 'Manaf Barjas' },
    email: 'culture@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 22,
    category: 'offices',
    name: { ar: 'مكتب الموارد البشرية', en: 'Human Resources Office', tr: 'İnsan Kaynakları Ofisi' },
    head: { ar: 'آية ابو شعر', en: 'Aya Abu Shaar', tr: 'Aya Abu Shaar' },
    email: 'hr@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 23,
    category: 'offices',
    name: { ar: 'المكتب القانوني', en: 'Legal Office', tr: 'Hukuk Ofisi' },
    head: { ar: 'رجاء حسناتو', en: 'Raja Hasnato', tr: 'Raja Hasnato' },
    email: 'legal@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 24,
    category: 'offices',
    name: { ar: 'مكتب الارتباط الداخلي', en: 'Internal Liaison Office', tr: 'İç Bağlantı Ofisi' },
    head: { ar: 'محمد صهيب الهنداوي', en: 'Mohammed Suhaib Al-Hindawi', tr: 'Mohammed Suhaib Al-Hindawi' },
    email: 'internal@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 25,
    category: 'offices',
    name: { ar: 'مكتب إسطنبول', en: 'Istanbul Office', tr: 'İstanbul Ofisi' },
    head: { ar: 'حسن سلطان', en: 'Hassan Sultan', tr: 'Hassan Sultan' },
    email: 'istanbul@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 26,
    category: 'offices',
    name: { ar: 'المكتب المالي', en: 'Financial Office', tr: 'Mali Ofis' },
    head: { ar: 'محمد نور حسين', en: 'Mohammed Nour Hussein', tr: 'Mohammed Nour Hussein' },
    email: 'finance@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 27,
    category: 'offices',
    name: { ar: 'المكتب التقني', en: 'Technical Office', tr: 'Teknik Ofis' },
    head: { ar: 'ممدوح المصري', en: 'Mamdouh Al-Masri', tr: 'Mamdouh Al-Masri' },
    email: 'tech@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 28,
    category: 'offices',
    name: { ar: 'المكتب الأكاديمي', en: 'Academic Office', tr: 'Akademik Ofis' },
    head: { ar: 'محمد العثمان', en: 'Mohammed Al-Othman', tr: 'Mohammed Al-Othman' },
    email: 'academic@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  },
  {
    id: 29,
    category: 'offices',
    name: { ar: 'مكتب شؤون الطلبة', en: 'Student Affairs Office', tr: 'Öğrenci İşleri Ofisi' },
    head: { ar: 'خالد ناصر', en: 'Khaled Nasser', tr: 'Khaled Nasser' },
    email: 'studentaffairs@syrianstudents.org',
    phone: '+90 5XX XXX XXXX',
    image: '/assets/placeholder.webp'
  }
];
// "اتحاد الطلبة السوريين في جامعة اسكودار": {
//     aboutDescription: {
//       ar: 'لا يوجد',
//       en: 'No description available.',
//       tr: 'Açıklama mevcut değil.'
//     },
//     cardDescription: {
//       ar: 'اتحاد الطلبة السوريين في جامعة اسكودار.',
//       en: 'Syrian Students Union at Uskudar University.',
//       tr: 'Üsküdar Üniversitesi Suriyeli Öğrenci Birliği.'
//     },
//     contactNumber: {
//       ar: 'لا يوجد',
//       en: 'Not available',
//       tr: 'Mevcut değil'
//     },
//     activitiesAndAchievements: {
//       ar: 'محاضرات: أثر اللغة في الشخصية والسلوك، كيف نبني قوتنا النفسية، استعادة التوازن قبل الاختبارات النهائية، كيف نستعد لشهر رمضان، بين الحلال والحرام كيف نفهم الفتاوى في زمننا، قطوف من الشمائل المحمدية. فعاليات: سوريا العظيمة في جامعة اسكودار (احتفال التحرير)، ذكرى الثورة بالتعاون مع اتحادات اسطنبول، حفل التخرج المركزي في اسطنبول بالتعاون مع الاتحادات، فعالية اليوم العالمي في جامعة اسكودار، فلسطين من الثقافة إلى المقاومة، فعالية عرض فيلم معطف كبير الحجم، مؤتمر بوصلة الشباب، فعالية بالتعاون مع جمعية شام للأيتام. ورشات: ورشة الأنيميشن، ورشة الكونكريت، ورشة صناعة مستحضرات التجميل. حملات في رمضان: أغث بصدقة لتوزيع السلل الغذائية، إفطار صائم. مبادرات: ختمة، ترتيل.',
//       en: 'Lectures: The impact of language on personality and behavior, how to build our psychological strength, restoring balance before final exams, how to prepare for Ramadan, between halal and haram how to understand fatwas in our time, excerpts from Muhammad\'s character. Events: Great Syria at Uskudar University (Liberation celebration), Revolution commemoration in cooperation with Istanbul unions, Central graduation ceremony in Istanbul in cooperation with unions, World Day event at Uskudar University, Palestine from culture to resistance, Large Coat film screening event, Youth Compass conference, event in cooperation with Sham Orphans Association. Workshops: Animation workshop, Concrete workshop, Cosmetics manufacturing workshop. Ramadan campaigns: Help with charity to distribute food baskets, Iftar for fasting. Initiatives: Quran completion, recitation.',
//       tr: 'Konferanslar: Dilin kişilik ve davranış üzerindeki etkisi, psikolojik gücümüzü nasıl inşa ederiz, final sınavlarından önce dengeyi geri kazanma, Ramazan ayına nasıl hazırlanırız, helal ve haram arasında zamanımızda fetvaları nasıl anlarız, Muhammed\'in karakterinden alıntılar. Etkinlikler: Üsküdar Üniversitesi\'nde Büyük Suriye (Kurtuluş kutlaması), İstanbul birlikleriyle işbirliği içinde Devrim anması, birliklerle işbirliği içinde İstanbul\'da Merkezi mezuniyet töreni, Üsküdar Üniversitesi\'nde Dünya Günü etkinliği, kültürden direnişe Filistin, Büyük Palto film gösterimi etkinliği, Gençlik Pusulası konferansı, Şam Yetimler Derneği ile işbirliği içinde etkinlik. Atölyeler: Animasyon atölyesi, Beton atölyesi, Kozmetik üretim atölyesi. Ramazan kampanyaları: Gıda sepetleri dağıtmak için sadaka ile yardım, oruçlular için iftar. Girişimler: Kuran tamamlama, tilavet.'
//     },
//     specialAchievements: {
//       ar: 'حملة أغث بصدقة (تم توزيع 120 سلة غذائية). حملة إفطار صائم في رمضان (تم جمع 84 ألف ليرة تركية وتوزيع 840 وجبة).',
//       en: 'Help with charity campaign (120 food baskets were distributed). Iftar for fasting campaign in Ramadan (84,000 Turkish lira was collected and 840 meals were distributed).',
//       tr: 'Sadaka ile yardım kampanyası (120 gıda sepeti dağıtıldı). Ramazan\'da oruçlular için iftar kampanyası (84.000 Türk lirası toplandı ve 840 yemek dağıtıldı).'
//     },
//     currentAdministrativeTeam: {
//       ar: 'الإدارة: 7 أعضاء. المتطوعين: حوالي 15.',
//       en: 'Administration: 7 members. Volunteers: approximately 15.',
//       tr: 'Yönetim: 7 üye. Gönüllüler: yaklaşık 15.'
//     },
//     notes: {
//       ar: 'لا يوجد',
//       en: 'No additional notes.',
//       tr: 'Ek not yok.'
//     },
//     logo: ''
//   },